import { useLocation, useNavigate } from "react-router-dom";
import React, { useEffect, useRef, useState } from "react";
import { OverlayTrigger, Tooltip, Button, Modal, Dropdown } from 'react-bootstrap';
import { Utils } from "../../../Utils";
import { TbInfoCircleFilled, TbRefresh, TbUpload } from "react-icons/tb";
import { GoQuestion } from "react-icons/go";
import { Settings, Trash } from "lucide-react";
import paymentIcon from "../../../Assets/images/icons/payment-icon.png";
import { ColorPicker, FieldColorCheckbox, FieldTextSize, SimpleModal, SingleTextCheckbox, TooltipTrig } from "./components";
import HeaderContent from "../CustomContent/headerContent";
import FooterContent from "../CustomContent/footerContent";
import OrganizationContent from "../CustomContent/organizationContent";
import BillToContent from "../CustomContent/billToContent";
import ShipToContent from "../CustomContent/shipToContent";
import AttentionContent from "../CustomContent/attentionContent";
import ItemContent from "../CustomContent/itemContent";
import AnnexureContent from "../CustomContent/otherDetailsContent";
import { useDispatch, useSelector } from "react-redux";
import { getItem } from "../../../Services/localService";
import TableContent from "../CustomContent/tableContent";
import { createTemplateStart, resetState, updateTemplateStart } from "../../../Store/Slices/templateSlice";
import Loader from "../../../Components/Loader";
import Toast from "../../../Components/Toast";
import { toast } from "react-toastify";

const InvoiceTemplate = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const divRef = useRef(null);
    let templateData = useSelector((state) => state?.template);
    let navbarList = useSelector((state) => state?.forms)?.navbarList;
    const dispatch = useDispatch();
    let currentOrg = getItem('user')?.organization?.organizationName;
    let selectedTemplateData = location?.state;

    let [invModuleId, setInvModuleId] = useState('')
    let [templateName, setTemplateName] = useState('Invoice Template')
    let [templateJson, setTemplateJson] = useState({
        general: {
            template_property: {
                template_name: 'Invoice Template',
                paper_size: 'A4',
                orientation: 'Portrait',
                margins: {
                    top: '0.7',
                    bottom: '0.7',
                    left: '0.55',
                    right: '0.4'
                },
                payment_stub: {
                    include_payment_stub: false,
                    payment_stub: 'Payment Stub ',
                    amount_enclosed: 'Amount Enclosed',
                    payment_stub_postion: 'first_page'
                }
            },
            font: {
                pdf_font: 'Ubuntu',
                label_color: '#000000',
                font_color: '#000000',
                font_size: '8'
            },
            background: {
                bg_image: '',
                image_position: 'Center Center',
                is_show_bg_color: true,
                bg_color: 'transparent'
            }
        },
        header: {
            bg_image: '',
            img_position: 'Top Left',
            is_show_bg_color: true,
            bg_color: 'transparent',
            is_apply_first_page_only: false,
            header_first_page: '0.55',
            custom_header_content: '',
            custom_header_content_other_page: ''
        },
        footer: {
            font_color: '#000000',
            font_size: '8',
            bg_image: '',
            img_position: 'Top Left',
            is_show_bg_color: true,
            bg_color: 'transparent',
            is_show_page_no: true,
            custom_footer_content: ''
        },
        organization: {
            is_show_org_logo: true,
            org_logo: '',
            is_show_org_name: true,
            font_color: '#000000',
            font_size: '12',
            is_show_org_address: true,
            custom_org_content: ''
        },
        customer: {
            font_color: '#000000',
            font_size: '8',
            is_bill_to: true,
            bill_to_title: 'Bill To',
            custom_bill_to_content: '',
            is_ship_to: false,
            ship_to_title: 'Ship To',
            custom_ship_to_content: ''
        },
        document: {
            is_show_document_title: true,
            document_title: 'TAX INVOICE',
            font_color: '#000000',
            font_size: '22',
            phone_title: 'Phone',
            fax_title: 'Fax',
            document_information: [],
            custom_document_content: '',
            is_show_status_stamp: false
        },
        table: {
            labels_section: {
                table_properties: {
                    line_item_number: {
                        is_show_line_item_number: true,
                        width: '10',
                        label: '#'
                    },
                    item: {
                        is_show_item: true,
                        width: '64',
                        label: 'Item'
                    },
                    description: {
                        is_show_description: true,
                        label: 'Description'
                    },
                    custom_item_description_content: '',
                    custom_fields: {
                        is_show_custom_fields: true,
                        width: '11',
                        label: '%Custom Field Label%'
                    },
                    quantity: {
                        is_show_quantity: true,
                        is_show_unit: true,
                        width: '11',
                        label: 'Qty'
                    },
                    rate: {
                        is_show_rate: true,
                        width: '11',
                        label: 'Rate'
                    },
                    tax: {
                        is_show_tax: true,
                        width: '11',
                        label: 'Tax %'
                    },
                    discount: {
                        is_show_discount: true,
                        width: '11',
                        label: 'Discount'
                    },
                    amount: {
                        is_show_amount: true,
                        width: '13',
                        label: 'Total'
                    }
                },
                invoices_created_from_projects: {
                    project_item: 'Task',
                    project_description: 'Description',
                    project_hours: 'Project Hours'
                }
            },
            layout_section: {
                table_properties: {
                    table_border: '#9e9e9e',
                    is_show_table_border: true,
                    table_header: {
                        font_size: '8',
                        font_color: '#000000',
                        is_show_bg_color: true,
                        bg_color: '#f2f3f4'
                    },
                    item_row: {
                        font_size: '8',
                        font_color: '#000000',
                        is_show_bg_color: true,
                        bg_color: '#ffffff'
                    },
                    item_description: {
                        font_size: '8',
                        font_color: '#000000'
                    }
                }
            }
        },
        total: {
            labels_section: {
                is_show_total_section: true,
                is_show_sub_total: true,
                sub_total_title: 'Sub Total',
                is_show_shipping_charges: true,
                shipping_charges_title: 'Shipping Charge',
                is_show_discount: true,
                is_show_taxable_amount: true,
                tax_title: 'Total Taxable Amount',
                is_show_adjustment: true,
                is_show_tax: true,
                is_show_total: true,
                total_title: 'Total',
                is_show_currency_symbol: true,
                currency_symbol_title: 'Before Amount',
                payment_details: {
                    is_show_payment_details: true,
                    payment_made: 'Payment Made',
                    credits_applied: 'Credits Applied',
                    amount_withheld: 'Amount Withheld',
                    write_off_amount: 'Write Off Amount',
                    balance_due: 'Balance Due'
                },
                is_show_qty: true,
                qty_title: 'Items in Total',
                hours_title: 'Hours in Total',
                is_show_amount_in_words: true
            },
            layout_section: {
                total: {
                    font_size: '8',
                    font_color: '#000000',
                    is_show_bg_color: true,
                    bg_color: '#ffffff'
                },
                balance_due: {
                    font_size: '9',
                    font_color: '#000000',
                    is_show_bg_color: true,
                    bg_color: '#ffffff'
                }
            }
        },
        other_details: {
            document_summary: {
                notes: {
                    label_title: 'Notes',
                    font_size: '8',
                },
                payment_options: {
                    online_payment_link: 'Payment Options',
                    custom_payment_content: ''
                },
                terms_and_conditions: {
                    is_show_terms_and_conditions: true,
                    label_title: 'Terms & Conditions',
                    font_size: '8'
                },
                signature: {
                    is_show_signature: true,
                    label_title: 'Authorized Signature',
                    signature_image: '',
                    signature_name: ''
                }
            },
            annexure: {
                custom_annexure_content: ''
            }
        }
    })
    let [showLoader, setShowLoader] = useState(false)

    // BEGIN GENERAL SETTINGS //
    // General settings -> Template Properties
    const [paperSize, setPaperSize] = useState("A4");
    const [orientation, setOrientation] = useState('Portrait');
    const [tempTopMargin, setTempTopMargin] = useState('0.7');
    const [tempBottomMargin, setTempBottomMargin] = useState('0.7');
    const [tempLeftMargin, setTempLeftMargin] = useState('0.55');
    const [tempRightMargin, setTempRightMargin] = useState('0.4');

    // General settings -> Font
    const [allFontFamily, setAllFontFamily] = useState("Ubuntu");
    const [allLabelColor, setAllLabelColor] = useState('#000000');
    const [allFontColor, setAllFontColor] = useState('#000000');
    const [allFontSize, setAllFontSize] = useState('8');

    // General settings -> Background
    const [tempBgImg, setTempBgImg] = useState(null);
    const [tempBgImgError, setTempBgImgError] = useState("");
    const [selectedTempBgPos, setSelectedTempBgPos] = useState('center center');
    const [tempBgColor, setTempBgColor] = useState('transparent');

    // Checkbox Enable/disable temp BG color picker
    const [isTempBgColorEnabled, setIsTempBgColorEnabled] = useState(true);
    const tempBgColorCheckbox = (e, setter) => {
        setter(e.target.checked);
    };

    // Font Family selection
    const handleFontFamilyChange = (fontName, fontDescription) => {
        // setAllFontFamily(fontName);
        setTemplateJson((prev) => ({
            ...prev,
            general: {
                ...prev.general,
                font: {
                    ...prev.general.font,
                    pdf_font: fontName
                }
            }
        }))
    };

    // Map of fonts and their descriptions
    const fonts = [
        {
            name: "Open Sans",
            description: "Supports English, German, Spanish, French, Italian, Dutch, Polish, Portugese, Swedish, Catalan, Czech, Maltese, Russian, and Slovenian language characters.",
        },
        {
            name: "Ubuntu",
            description: "Supports English and European languages. This font can also render Indian Rupees Symbol.",
        },
        {
            name: "Roboto",
            description: "Supports Latin, Greek and Cyrillic and Vietnamese scripts",
        },
        {
            name: "Helvetica",
            description: "Supports all English characters.",
        },
        {
            name: "Noto Sans",
            description: "Supports all European languages.",
        },
        {
            name: "DejaVu Sans",
            description: "Supports Latin, Greek, Hebrew, Georgian, Armanian and Cyrillic scripts.",
        },
        { name: "Arial", description: "A sans-serif font, widely used for both print and digital content." },
        { name: "Times New Roman", description: "A serif font with wide usage in printed documents." },
        { name: "Courier New", description: "A monospaced font, often used for code formatting." },
        { name: "Georgia", description: "A serif font commonly used for online content." },
        { name: "Verdana", description: "A sans-serif font designed for digital screen readability." },
        { name: "Lato", description: "A humanist sans-serif typeface with a warm, friendly feeling." },
        { name: "Montserrat", description: "A geometric sans-serif font with a modern, professional look." },
    ];

    const getTempFontFamily = (fontName) => {
        const fontMap = {
            "Open Sans": "'Open Sans', serif",
            "Ubuntu": "'Ubuntu', serif",
            "Roboto": "'Roboto', sans-serif",
            "Helvetica": "'Helvetica', sans-serif",
            "Noto Sans": "'Noto Sans', serif",
            "DejaVu Sans": "'DejaVu Sans', sans-serif",
            "Arial": "'Arial', sans-serif",
            "Times New Roman": "'Times New Roman', serif",
            "Courier New": "'Courier New', monospace",
            "Georgia": "'Georgia', serif",
            "Verdana": "'Verdana', sans-serif",
            "Lato": "'Lato', sans-serif",
            "Montserrat": "'Montserrat', sans-serif",
        };

        return fontMap[fontName] || "'Ubuntu', sans-serif"; // Default to Ubuntu if not found
    };

    // paper size selection
    const handlePaperSizeChange = (event) => {
        // setPaperSize(event.target.value);
        setTemplateJson((prev) => ({
            ...prev,
            general: {
                ...prev.general,
                template_property: {
                    ...prev.general.template_property,
                    paper_size: event.target.value
                }
            }
        }))
    };
    // paper orientation change
    const handleOrientationChange = (event) => {
        // setOrientation(event.target.value);
        setTemplateJson((prev) => ({
            ...prev,
            general: {
                ...prev.general,
                template_property: {
                    ...prev.general.template_property,
                    orientation: event.target.value
                }
            }
        }))
    };

    const handleGeneralMarginChange = (event) => {
        setTemplateJson((prev) => ({
            ...prev,
            general: {
                ...prev.general,
                template_property: {
                    ...prev.general.template_property,
                    margins: {
                        ...prev.general.template_property.margins,
                        [event.target.name]: event.target.value
                    }
                }
            }
        }))
    }

    const handleGeneralBgPosition = (event) => {
        setTemplateJson((prev) => ({
            ...prev,
            general: {
                ...prev.general,
                background: {
                    ...prev.general.background,
                    image_position: event.target.value
                }
            }
        }))
    }

    // based on selected paper size width set to main template
    const getTempPaperDimensions = () => {
        let width, height;

        // Determine paper size dimensions (in inches)
        switch (templateJson.general.template_property.paper_size) {
            case 'A5':
                width = 5.83;
                height = 8.27;
                break;
            case 'Letter':
                width = 8.5;
                height = 11;
                break;
            case 'A4':
            default:
                width = 8.27;
                height = 11.69;
                break;
        }

        // Adjust for orientation (Portrait or Landscape)
        if (templateJson.general.template_property.orientation === 'Landscape') {
            [width, height] = [height, width]; // Swap width and height
        }

        return { width: `${width}in`, height: `${height}in` };
    };

    const { width, height } = getTempPaperDimensions();

    // Template BG Img
    const tempBGImgChange = (event) => {
        const file = event.target.files[0];
        if (file) {
            if (file.type.startsWith("image/")) {
                const fileUrl = URL.createObjectURL(file);
                // setTempBgImg({ fileimage: fileUrl, filename: file.name });
                setTemplateJson((prev) => ({
                    ...prev,
                    general: {
                        ...prev.general,
                        background: {
                            ...prev.general.background,
                            bg_image: { fileimage: fileUrl, filename: file.name }
                        }
                    }
                }))
                setTempBgImgError("");
            } else {
                setTempBgImgError("Please select a image file only.");
                // setTempBgImg(null);
                setTemplateJson((prev) => ({
                    ...prev,
                    general: {
                        ...prev.general,
                        background: {
                            ...prev.general.background,
                            bg_image: null
                        }
                    }
                }))
            }
        }
    };
    const removeTempImage = () => {
        // setTempBgImg(null);
        setTemplateJson((prev) => ({
            ...prev,
            general: {
                ...prev.general,
                background: {
                    ...prev.general.background,
                    bg_image: null
                }
            }
        }))
        setTempBgImgError("");
    };

    const [isPayStubSetEnabled, setIsPayStubSetEnabled] = useState(false);
    const payStubSetChange = (e) => {
        // setIsPayStubSetEnabled(e.target.checked);
        setTemplateJson((prev) => ({
            ...prev,
            general: {
                ...prev.general,
                template_property: {
                    ...prev.general.template_property,
                    payment_stub: {
                        ...prev.general.template_property.payment_stub,
                        include_payment_stub: e.target.checked
                    }
                }
            }
        }))
    };
    const [payStubLabelText, setPayStubLabelText] = useState("Payment Stub");
    const handlePayStubLabelChange = (e) => {
        // setPayStubLabelText(e.target.value);
        setTemplateJson((prev) => ({
            ...prev,
            general: {
                ...prev.general,
                template_property: {
                    ...prev.general.template_property,
                    payment_stub: {
                        ...prev.general.template_property.payment_stub,
                        payment_stub: e.target.value
                    }
                }
            }
        }))
    };
    const [amtEncloseLabelText, setAmtEncloseLabelText] = useState("Amount Enclosed");
    const handleAmtEncloseLabelChange = (e) => {
        // setAmtEncloseLabelText(e.target.value);
        setTemplateJson((prev) => ({
            ...prev,
            general: {
                ...prev.general,
                template_property: {
                    ...prev.general.template_property,
                    payment_stub: {
                        ...prev.general.template_property.payment_stub,
                        amount_enclosed: e.target.value
                    }
                }
            }
        }))
    };
    const [payStubPos, setPayStubPos] = useState('separatePage');
    const handlePayStubPosChange = (e) => {
        // setPayStubPos(event.target.value);
        setTemplateJson((prev) => ({
            ...prev,
            general: {
                ...prev.general,
                template_property: {
                    ...prev.general.template_property,
                    payment_stub: {
                        ...prev.general.template_property.payment_stub,
                        payment_stub_postion: e.target.value
                    }
                }
            }
        }))
    };
    // END GENERAL SETTINGS //

    // BEGIN Header Settings
    const [headerBgImg, setHeaderBgImg] = useState(null);
    const [headerBgImgError, setHeaderBgImgError] = useState("");
    // Header BG Change
    const headerBGImgChange = (event) => {
        const file = event.target.files[0];
        if (file) {
            if (file.type.startsWith("image/")) {
                const fileUrl = URL.createObjectURL(file);
                // setHeaderBgImg({ fileimage: fileUrl, filename: file.name });
                setTemplateJson((prev) => ({
                    ...prev,
                    header: {
                        ...prev.general,
                        bg_image: { fileimage: fileUrl, filename: file.name }
                    }
                }))
                setHeaderBgImgError("");
            } else {
                setHeaderBgImgError("Please select a image file only.");
                // setHeaderBgImg(null);
                setTemplateJson((prev) => ({
                    ...prev,
                    header: {
                        ...prev.general,
                        bg_image: null
                    }
                }))
            }
        }
    };
    const removeHeaderImage = () => {
        // setHeaderBgImg(null);
        setTemplateJson((prev) => ({
            ...prev,
            header: {
                ...prev.general,
                bg_image: null
            }
        }))
        setHeaderBgImgError("");
    };

    const setHeaderBgPos = (e) => {
        setTemplateJson((prev) => ({
            ...prev,
            header: {
                ...prev.header,
                img_position: e.target.value
            }
        }))
    }

    const [selectedHeaderBgPos, setSelectedHeaderBgPos] = useState('top left');

    // Header BG Color
    const [headerBgColor, setHeaderBgColor] = useState('transparent');
    // Header BG Color Checkbox Enable/disable temp BG color picker
    const [isHeaderBgColorEnabled, setIsHeaderBgColorEnabled] = useState(true);
    const headerBgColorCheckbox = (e, setter) => {
        // setter(e.target.checked);
        setTemplateJson((prev) => ({
            ...prev,
            header: {
                ...prev.header,
                is_show_bg_color: e.target.checked
            }
        }))
    };

    // Header First page settings eneble/disable
    const [isHfPsettingEnabled, setIsHfPsettingEnabled] = useState(false);
    const headerFpSettingEnable = (e) => {
        // setIsHfPsettingEnabled(e.target.checked);
        setTemplateJson((prev) => ({
            ...prev,
            header: {
                ...prev.header,
                is_apply_first_page_only: e.target.checked
            }
        }))
    };
    // Header First page Height
    const [headerFpHeight, setHeaderFpHeight] = useState('0.55');

    // Header customized content modal
    const [haFtitle, setHaFtitle] = useState(true);
    const [headFootCusContModal, setHeadFootCusContModal] = useState(false);
    function handleHaFmodalShow(modalHeaderTitle) {
        setHaFtitle(modalHeaderTitle);
        setHeadFootCusContModal(true);
    }

    const regex = /\${(.*?)}/g;
    const [showQTHeaderContent, setshowQTHeaderContent] = useState(false);
    const [QTHeaderValues, setQTHeaderValues] = useState('');

    const [showQTFooterContent, setshowQTFooterContent] = useState(false);
    const [QTFooterValues, setQTFooterValues] = useState('');

    const [showQTOrganizationContent, setshowQTOrganizationContent] = useState(false);
    // const [QTOrganizationValues, setQTOrganizationValues] = useState('');
    const [QTOrganizationValues, setQTOrganizationValues] = useState('${ORGANIZATION.Street}\n${ORGANIZATION.City}\n${ORGANIZATION.State}\n${ORGANIZATION.Zip Code}\n${ORGANIZATION.Country}\n${ORGANIZATION.Website}\n${ORGANIZATION.Phone}\n${ORGANIZATION.Email}');

    const [showQTBillToContent, setshowQTBillToContent] = useState(false);
    const [QTBillToValues, setQTBillToValues] = useState('${INVOICES.Invoice User}\n${INVOICES.Billing Street}\n${INVOICES.Billing City}\n${INVOICES.Billing State}\n${INVOICES.Billing Zip}\n${INVOICES.Billing Country}');
    // const [QTBillToValues, setQTBillToValues] = useState('');

    const [showQTShipToContent, setshowQTShipToContent] = useState(false);
    const [QTShipToValues, setQTShipToValues] = useState('');

    const [showQTAttentionContent, setshowQTAttentionContent] = useState(false);
    const [QTAttentionValues, setQTAttentionValues] = useState('');

    const [showQTItemContent, setshowQTItemContent] = useState(false);
    const [QTItemValues, setQTItemValues] = useState('');

    const [showQTAnnexureContent, setshowQTAnnexureContent] = useState(false);
    const [QTAnnexureValues, setQTAnnexureValues] = useState('');
    // new code-dp::end

    // -dp:start
    const handleQTHeaderValuesChange = (e) => {
        setQTHeaderValues(e.target.value);
    };
    const handleInsertQTHeaderPlaceholder = (title, placeholder) => {
        setQTHeaderValues(prev => prev + '\n${' + title + '.' + placeholder + '}');
    };
    const QTHeaderArr = [...QTHeaderValues.matchAll(regex)].map(match => match[0]);

    const handleQTFooterValuesChange = (e) => {
        setQTFooterValues(e.target.value);
    };
    const handleInsertQTFooterPlaceholder = (title, placeholder) => {
        setQTFooterValues(prev => prev + '\n${' + title + '.' + placeholder + '}');
    };
    const QTFooterArr = [...QTFooterValues.matchAll(regex)].map(match => match[0]);

    const handleQTOrganizationValuesChange = (e) => {
        setQTOrganizationValues(e.target.value);
    };
    const handleInsertQTOrganizationPlaceholder = (title, placeholder) => {
        setQTOrganizationValues(prev => prev + '\n${' + title + '.' + placeholder + '}');
    };
    const QTOrganizationArr = [...QTOrganizationValues.matchAll(regex)].map(match => match[0]);

    const handleQTBillToValuesChange = (e) => {
        setQTBillToValues(e.target.value);
    };
    const handleInsertQTBillToPlaceholder = (title, placeholder) => {
        setQTBillToValues(prev => prev + '\n${' + title + '.' + placeholder + '}');
    };
    const QTBillToArr = [...QTBillToValues.matchAll(regex)].map(match => match[0]);

    const handleQTShipToValuesChange = (e) => {
        setQTShipToValues(e.target.value);
    };
    const handleInsertQTShipToPlaceholder = (title, placeholder) => {
        setQTShipToValues(prev => prev + '\n${' + title + '.' + placeholder + '}');
    };
    const QTShipToArr = [...QTShipToValues.matchAll(regex)].map(match => match[0]);

    const handleQTAttentionValuesChange = (e) => {
        setQTAttentionValues(e.target.value);
    };
    const handleInsertQTAttentionPlaceholder = (title, placeholder) => {
        setQTAttentionValues(prev => prev + '\n${' + title + '.' + placeholder + '}');
    };
    const QTAttentionArr = [...QTAttentionValues.matchAll(regex)].map(match => match[0]);

    const handleQTItemValuesChange = (e) => {
        setQTItemValues(e.target.value);
    };
    const handleInsertQTItemPlaceholder = (title, placeholder) => {
        setQTItemValues(prev => prev + '\n${' + title + '.Item.' + placeholder + '}');
    };
    const QTItemArr = [...QTItemValues.matchAll(regex)].map(match => match[0]);

    const handleQTAnnexureValuesChange = (e) => {
        setQTAnnexureValues(e.target.value);
    };
    const handleInsertQTAnnexurePlaceholder = (title, placeholder) => {
        setQTAnnexureValues(prev => prev + '\n${' + title + '.' + placeholder + '}');
    };
    const QTAnnexureArr = [...QTAnnexureValues.matchAll(regex)].map(match => match[0]);
    // dp:end

    const [hAfCustomValues, setHaFcustomValues] = useState('');
    const customPlaceholders = [
        {
            categoryTitle: 'ORGANIZATION',
            items: ['Organization Name', 'Logo', 'Street Address1', 'Street Address2', 'City', 'ZIP/Postal Code', 'State/Province', 'Country', 'Phone#', 'Fax#', 'Website', 'Label 1', 'Label 2', 'Label 3', 'Label 4', 'Label 5', 'Value 1', 'Value 2', 'Value 3', 'Value 4', 'Value 5', 'CompanyIDLabel', 'CompanyIDValue', 'TaxIDLabel', 'TaxIDValue'],
        },
        {
            categoryTitle: 'INVOICE',
            items: ['Invoice Date', 'Invoice Number', 'P.O. Number', 'Total', 'Due Date'],
        },
        {
            categoryTitle: 'CUSTOMER',
            items: ['Salutation', 'First Name', 'Last Name', 'Email', 'Phone', 'Mobile', 'Department', 'Designation', 'Skype', 'Name', 'Company Name', 'Billing Attention', 'Billing Address', 'Billing City', 'Billing State', 'Billing Code', 'Billing Country', 'Billing Phone', 'Billing Fax', 'Shipping Attention', 'Shipping Address', 'Shipping City', 'Shipping State', 'Shipping Code', 'Shipping Country', 'Shipping Phone', 'Shipping Fax', 'Twitter', 'Facebook', 'Website'],
        },
    ];
    const handleHaFcustomValuesChange = (e) => {
        setHaFcustomValues(e.target.value);
    };
    const handleInsertCustomPlaceholder = (placeholder) => {
        setHaFcustomValues(prev => prev + `\n%${placeholder}%`);
    };
    // END Header Settings //

    // Begin Footer Settings 
    const [footFontColor, setFootFontColor] = useState('#000000');
    const [footFontSize, setFootFontSize] = useState('8');
    const [footBgImg, setFootBgImg] = useState(null);
    const [footBgImgError, setFootBgImgError] = useState("");
    // Footer BG Change
    const footBGImgChange = (event) => {
        const file = event.target.files[0];
        if (file) {
            if (file.type.startsWith("image/")) {
                const fileUrl = URL.createObjectURL(file);
                // setFootBgImg({ fileimage: fileUrl, filename: file.name });
                setTemplateJson((prev) => ({
                    ...prev,
                    footer: {
                        ...prev.footer,
                        bg_image: { fileimage: fileUrl, filename: file.name }
                    }
                }))
                setFootBgImgError("");
            } else {
                setFootBgImgError("Please select a image file only.");
                // setFootBgImg(null);
                setTemplateJson((prev) => ({
                    ...prev,
                    footer: {
                        ...prev.footer,
                        bg_image: null
                    }
                }))
            }
        }
    };
    const removeFootImage = () => {
        // setFootBgImg(null);
        setTemplateJson((prev) => ({
            ...prev,
            footer: {
                ...prev.footer,
                bg_image: null
            }
        }))
        setFootBgImgError("");
    };

    const [selectedFootBgPos, setSelectedFootBgPos] = useState('top left');

    // Footer BG Color
    const [footBgColor, setFootBgColor] = useState('transparent');
    // Footer BG Color Checkbox Enable/disable temp BG color picker
    const [isFootBgColorEnabled, setIsFootBgColorEnabled] = useState(true);
    const footBgColorCheckbox = (e, setter) => {
        // setter(e.target.checked);
        setTemplateJson((prev) => ({
            ...prev,
            footer: {
                ...prev.footer,
                is_show_bg_color: e.target.checked
            }
        }))
    };
    // END FOOTER Settings //

    // Begin:: Transaction Details //
    // Begin:: Organization Details //
    const [isOrgImgCheckEnabled, setIsOrgImgCheckEnabled] = useState(false);
    const tDOrgImgSettingEnable = (e) => {
        // setIsOrgImgCheckEnabled(e.target.checked);
        setTemplateJson((prev) => ({
            ...prev,
            organization: {
                ...prev.organization,
                is_show_org_logo: e.target.checked
            }
        }))
    };
    const [orgImg, setOrgImg] = useState(null);
    const [orgImgError, setOrgImgError] = useState("");
    // Org img Change
    const orgImgChange = (event) => {
        const file = event.target.files[0];
        if (file) {
            if (file.type.startsWith("image/")) {
                const fileUrl = URL.createObjectURL(file);
                setOrgImg({ fileimage: fileUrl, filename: file.name });
                setOrgImgError("");
            } else {
                setOrgImgError("Please select a image file only.");
                setOrgImg(null);
            }
        }
    };

    // Org Name Show/Hide
    const [isOrgNameCheckEnabled, setIsOrgNameCheckEnabled] = useState(true);
    const tDOrgNameSettingEnable = (e) => {
        // setIsOrgNameCheckEnabled(e.target.checked);
        setTemplateJson((prev) => ({
            ...prev,
            organization: {
                ...prev.organization,
                is_show_org_name: e.target.checked
            }
        }))
    };

    const [orgNameFontColor, setOrgNameFontColor] = useState('#000000');
    const [orgNameFontSize, setOrgNameFontSize] = useState('12');

    // Org Address Check show/hide
    const [isOrgAddressCheckEnabled, setIsOrgAddressCheckEnabled] = useState(true);
    const tDOrgAddressSettingEnable = (e) => {
        // setIsOrgAddressCheckEnabled(e.target.checked);
        setTemplateJson((prev) => ({
            ...prev,
            organization: {
                ...prev.organization,
                is_show_org_address: e.target.checked
            }
        }))
    };

    // Org Address Format Modal
    const [orgAddressFormatShow, setOrgAddressFormatShow] = useState(false);

    const orgAddressModalClose = () => {
        setOrgAddressFormatShow(false);
        setOrgAddConfigShow(true);
    }
    const orgAddressModalShow = () => {
        setOrgAddressFormatShow(true);
        setOrgAddConfigShow(true);
    }

    // Org Address Format Custom Placeholders change function
    const [orgAddCustomValues, setOrgAddCustomValues] = useState('${ORGANIZATION.CITY} ${ORGANIZATION.STATE} ${ORGANIZATION.POSTAL_CODE}\n${ORGANIZATION.COUNTRY}\n${ORGANIZATION.PHONE}\n${ORGANIZATION.EMAIL}\n${ORGANIZATION.WEBSITE}');
    const orgCustomPlaceholders = [
        {
            categoryTitle: 'ORGANIZATION',
            items: ['Street Address1', 'Street Address2', 'Organization Name', 'City', 'State/Province', 'Country', 'ZIP/Postal Code'],
        },
        {
            categoryTitle: 'QUOTE',
            items: ['Fax Label', 'Fax', 'Phone Label', 'Phone', 'Email', 'Website'],
        },
    ];
    const handleOrgCustomValuesChange = (e) => {
        setOrgAddCustomValues(e.target.value);
    };
    const handleInsertOrgCustomPlaceholder = (placeholder) => {
        setOrgAddCustomValues(prev => prev + '\n${ORGANIZATION.' + `${placeholder}}`);
    };
    const [orgAddConfigShow, setOrgAddConfigShow] = useState(true);
    // END:: Organization Details //

    // Begin:: Customer Details //
    const [cusNameFontColor, setCusNameFontColor] = useState('#000000');
    const [cusNameFontSize, setCusNameFontSize] = useState('8');

    // Bill To
    const [isBillToEnabled, setIsBillToEnabled] = useState(true);
    const billToCheckbox = (e, setter) => {
        // setter(e.target.checked);
        setTemplateJson((prev) => ({
            ...prev,
            customer: {
                ...prev.customer,
                is_bill_to: e.target.checked
            }
        }))
    };

    // Bill To Label Text
    const [billToLabelText, setBillToLabelText] = useState('Bill To');
    const handleBillToLabelChange = (e) => {
        // setBillToLabelText(e.target.value);
        setTemplateJson((prev) => ({
            ...prev,
            customer: {
                ...prev.customer,
                bill_to_title: e.target.value
            }
        }))
    };

    // Ship To
    const [isShipToEnabled, setIsShipToEnabled] = useState(true);
    const shipToCheckbox = (e, setter) => {
        // setter(e.target.checked);
        setTemplateJson((prev) => ({
            ...prev,
            customer: {
                ...prev.customer,
                is_ship_to: e.target.checked
            }
        }))
    };

    // Ship To Label Text
    const [shipToLabelText, setShipToLabelText] = useState('Ship To');
    const handleShipToLabelChange = (e) => {
        // setShipToLabelText(e.target.value);
        setTemplateJson((prev) => ({
            ...prev,
            customer: {
                ...prev.customer,
                ship_to_title: e.target.value
            }
        }))
    };

    // Bill To OR Ship To Address Format Modal
    const [billOrShipAddressFormatShow, setBillOrShipAddressFormatShow] = useState(false);

    const billOrShipAddressModalClose = () => {
        setBillOrShipAddressFormatShow(false);
        setBillOrShipAddConfigShow(true);
    }
    const [billOrShipTitle, setBillOrShipTitle] = useState(true);
    const billOrShipAddressModalShow = (headerTitle) => {
        setBillOrShipTitle(headerTitle);
        setBillOrShipAddressFormatShow(true);
        setBillOrShipAddConfigShow(true);
    }

    // Org Address Format Custom Placeholders change function
    const [billOrShipAddCustomValues, setBillOrShipAddCustomValues] = useState('${${CONTACT.CONTACT_DISPLAYNAME}\n${CONTACT.CONTACT_ADDRESS}\n${CONTACT.CONTACT_CITY}\n${CONTACT.CONTACT_CODE} ${CONTACT.CONTACT_STATE}\n${CONTACT.CONTACT_COUNTRY}');
    const billOrShipCustomPlaceholders = [
        {
            categoryTitle: 'CONTACT',
            items: ['Display Name', 'Company Name', 'Website', 'Salutation', 'First Name', 'Last Name', 'Contact Email', 'Mobile Phone', 'Phone Label', 'Phone', 'Department', 'Designation', 'PAN Label', 'PAN', ''],
        },
        {
            categoryTitle: 'ADDRESS',
            items: ['Attention', 'Steet Address', 'Steet Address1', 'Steet Address2', 'City', 'State/Province', 'Country', 'ZIP/Postal Code', 'FAX Label', 'Phone', 'Fax'],
        },
    ];
    const handleBillOrShipCustomValuesChange = (e) => {
        setBillOrShipAddCustomValues(e.target.value);
    };
    const handleInsertBillOrShipCustomPlaceholder = (placeholder) => {
        setBillOrShipAddCustomValues(prev => prev + '\n${CONTACT.' + `${placeholder}}`);
    };
    const [billOrShipAddConfigShow, setBillOrShipAddConfigShow] = useState(true);
    // END:: Customer Details //

    // Begin:: Document Details //
    // Doc Title
    const [isDocTitleEnabled, setIsDocTitleEnabled] = useState(true);
    const docTitleCheckbox = (e, setter) => {
        // setter(e.target.checked);
        setTemplateJson((prev) => ({
            ...prev,
            document: {
                ...prev.document,
                is_show_document_title: e.target.checked
            }
        }))
    };

    // Doc Title Label Text
    const [docTitleLabelText, setDocTitleLabelText] = useState('TAX INVOICE');
    const handleDocTitleLabelChange = (e) => {
        // setDocTitleLabelText(e.target.value);
        setTemplateJson((prev) => ({
            ...prev,
            document: {
                ...prev.document,
                document_title: e.target.value
            }
        }))
    };

    // Doc Title Color & Size
    const [docTitleFontColor, setDocTitleFontColor] = useState('#000000');
    const [docTitleFontSize, setDocTitleFontSize] = useState('22');

    // Document Information //
    const [checkboxes, setCheckboxes] = useState([
        { id: 'numFieldCheckbox', label: 'Number Field', value: 'Invoice Number', placeholderValue: '${INVOICES.Invoice Number}', isChecked: true },
        { id: 'invoiceDateCheckbox', label: 'Date Field', value: 'Invoice Date', placeholderValue: '${INVOICES.CreatedAt}', isChecked: true },
        { id: 'invoiceTermsCheckbox', label: 'Terms', value: 'Terms', placeholderValue: '${INVOICES.Terms}', isChecked: true },
        { id: 'dueDateCheckbox', label: 'Due Date', value: 'Due Date', placeholderValue: '${INVOICES.Due Date}', isChecked: true },
        { id: 'referenceCheckbox', label: 'Reference Field', value: 'Reference No', placeholderValue: '${INVOICES.Reference No}', isChecked: true },
        // { id: 'salesPersonCheckbox', label: 'Sales Person', value: 'Sales Person', placeholderValue: 'Richard James', isChecked: false },
        { id: 'projectNameCheckbox', label: 'Project', value: 'Project Name', placeholderValue: '${INVOICES.Deal Name}', isChecked: true },
        { id: 'subjectCheckbox', label: 'Subject', value: 'Subject', placeholderValue: '${INVOICES.Subject}', isChecked: true }
    ]);

    const handleCheckboxChange = (id, isChecked) => {
        setCheckboxes((prevCheckboxes) =>
            prevCheckboxes.map((checkbox) =>
                checkbox.id === id ? { ...checkbox, isChecked } : checkbox
            )
        );
    };
    const handleValueChange = (id, value) => {
        setCheckboxes((prevCheckboxes) =>
            prevCheckboxes.map((checkbox) =>
                checkbox.id === id ? { ...checkbox, value } : checkbox
            )
        );
    };
    // Document Details "Table Left" section
    const firstArray = checkboxes.filter(checkbox =>
        ['numFieldCheckbox', 'invoiceDateCheckbox', 'invoiceTermsCheckbox', 'dueDateCheckbox', 'referenceCheckbox'].includes(checkbox.id)
    );

    // Document Details "Table Right" section
    const secondArray = checkboxes.filter(checkbox =>
        ['salesPersonCheckbox', 'projectNameCheckbox'].includes(checkbox.id)
    );

    // Document Details "Subject" section
    const thirdArray = checkboxes.filter(checkbox =>
        ['subjectCheckbox'].includes(checkbox.id)
    );

    // Show Status Stamp
    const [isStatusStampEnabled, setIsStatusStampEnabled] = useState(false);
    const statusStampCheckbox = (e) => {
        // setIsStatusStampEnabled(e.target.checked);
        setTemplateJson((prev) => ({
            ...prev,
            document: {
                ...prev.document,
                is_show_status_stamp: e.target.checked
            }
        }))
    };

    const [addAttentionContModal, setAddAttentionContModal] = useState(false);
    function handleAddAttentionContModalShow() {
        setAddAttentionContModal(true);
    }
    // END:: Document Details //
    // END:: Transaction Details //

    // Begin:: Table Settings //
    // Label - Items num checkbox
    const [isLineItemNumCheckEnabled, setIsLineItemNumCheckEnabled] = useState(true);
    const lineItemNumCheckbox = (e, setter) => {
        // setter(e.target.checked);
        setTemplateJson((prev) => ({
            ...prev,
            table: {
                ...prev.table,
                labels_section: {
                    ...prev.table.labels_section,
                    table_properties: {
                        ...prev.table.labels_section.table_properties,
                        line_item_number: {
                            ...prev.table.labels_section.table_properties.line_item_number,
                            is_show_line_item_number: e.target.checked
                        }
                    }
                }
            }
        }))
    };
    // Label - Items num width
    const [lineNumWidth, setLineNumWidth] = useState('10');
    const handleLineNumWidthChange = (e) => {
        // setLineNumWidth(e.target.value);
        setTemplateJson((prev) => ({
            ...prev,
            table: {
                ...prev.table,
                labels_section: {
                    ...prev.table.labels_section,
                    table_properties: {
                        ...prev.table.labels_section.table_properties,
                        line_item_number: {
                            ...prev.table.labels_section.table_properties.line_item_number,
                            width: e.target.value
                        }
                    }
                }
            }
        }))
    };
    // Label - Items num 
    const [lineNumLabelText, setLineNumLabelText] = useState('#');
    const handleLineNumLabelChange = (e) => {
        // setLineNumLabelText(e.target.value);
        setTemplateJson((prev) => ({
            ...prev,
            table: {
                ...prev.table,
                labels_section: {
                    ...prev.table.labels_section,
                    table_properties: {
                        ...prev.table.labels_section.table_properties,
                        line_item_number: {
                            ...prev.table.labels_section.table_properties.line_item_number,
                            label: e.target.value
                        }
                    }
                }
            }
        }))
    };

    // Label - Items checkbox
    const [isItemEnabled, setIsItemEnabled] = useState(true);
    const itemCheckbox = (e, setter) => {
        // setter(e.target.checked);
        setTemplateJson((prev) => ({
            ...prev,
            table: {
                ...prev.table,
                labels_section: {
                    ...prev.table.labels_section,
                    table_properties: {
                        ...prev.table.labels_section.table_properties,
                        item: {
                            ...prev.table.labels_section.table_properties.item,
                            is_show_item: e.target.checked
                        }
                    }
                }
            }
        }))
    };
    // Label - Items width
    const [itemWidth, setItemWidth] = useState('64');
    const handleItemWidthChange = (e) => {
        // setItemWidth(e.target.value);
        setTemplateJson((prev) => ({
            ...prev,
            table: {
                ...prev.table,
                labels_section: {
                    ...prev.table.labels_section,
                    table_properties: {
                        ...prev.table.labels_section.table_properties,
                        item: {
                            ...prev.table.labels_section.table_properties.item,
                            width: e.target.value
                        }
                    }
                }
            }
        }))
    };
    // Label - Items  
    const [itemLabelText, setItemLabelText] = useState('Item');
    const handleItemLabelChange = (e) => {
        // setItemLabelText(e.target.value);
        setTemplateJson((prev) => ({
            ...prev,
            table: {
                ...prev.table,
                labels_section: {
                    ...prev.table.labels_section,
                    table_properties: {
                        ...prev.table.labels_section.table_properties,
                        item: {
                            ...prev.table.labels_section.table_properties.item,
                            label: e.target.value
                        }
                    }
                }
            }
        }))
    };

    // Label - Descrpition checkbox
    const [isDescLabelEnabled, setIsDescLabelEnabled] = useState(true);
    const descLabelCheckbox = (e, setter) => {
        // setter(e.target.checked);
        setTemplateJson((prev) => ({
            ...prev,
            table: {
                ...prev.table,
                labels_section: {
                    ...prev.table.labels_section,
                    table_properties: {
                        ...prev.table.labels_section.table_properties,
                        description: {
                            ...prev.table.labels_section.table_properties.description,
                            is_show_description: e.target.checked
                        }
                    }
                }
            }
        }))
    };
    // Label - Descrpition
    const [descLabelText, setDescLabelText] = useState('Description');
    const handleDescLabelChange = (e) => {
        // setDescLabelText(e.target.value);
        setTemplateJson((prev) => ({
            ...prev,
            table: {
                ...prev.table,
                labels_section: {
                    ...prev.table.labels_section,
                    table_properties: {
                        ...prev.table.labels_section.table_properties,
                        description: {
                            ...prev.table.labels_section.table_properties.description,
                            label: e.target.value
                        }
                    }
                }
            }
        }))
    };

    // Custom Name & Description format Modal
    const [cusNameAndDescModal, setCusNameAndDescModal] = useState(false);
    function handleCusNameAndDescModalShow() {
        setCusNameAndDescModal(true);
    }
    const [cusNameAndDescValues, setCusNameAndDescValues] = useState('');
    const cusNameAndDescPlaceholders = [
        {
            categoryTitle: 'ITEM',
            items: ['Item Name', 'Item SKU', 'Description', 'HSN/SAC Label', 'HSN/SAC Value', 'Item Unit'],
        },
    ];
    const handleCusNameAndDescValuesChange = (e) => {
        setCusNameAndDescValues(e.target.value);
    };
    const handleCusNameAndDescPlaceholder = (placeholder) => {
        setCusNameAndDescValues(prev => prev + `\n%${placeholder}%`);
    };

    // Label - Qty checkbox
    const [isTaQtyEnabled, setIsTaQtyEnabled] = useState(true);
    const taQtyCheckbox = (e, setter) => {
        // setter(e.target.checked);
        setTemplateJson((prev) => ({
            ...prev,
            table: {
                ...prev.table,
                labels_section: {
                    ...prev.table.labels_section,
                    table_properties: {
                        ...prev.table.labels_section.table_properties,
                        quantity: {
                            ...prev.table.labels_section.table_properties.quantity,
                            is_show_quantity: e.target.checked
                        }
                    }
                }
            }
        }))
    };
    // Label - Qty width
    const [taQtyWidth, setTaQtyWidth] = useState('11');
    const handleTaQtyWidthChange = (e) => {
        // setTaQtyWidth(e.target.value);
        setTemplateJson((prev) => ({
            ...prev,
            table: {
                ...prev.table,
                labels_section: {
                    ...prev.table.labels_section,
                    table_properties: {
                        ...prev.table.labels_section.table_properties,
                        quantity: {
                            ...prev.table.labels_section.table_properties.quantity,
                            width: e.target.value
                        }
                    }
                }
            }
        }))
    };
    // Label - Qty  
    const [taQtyLabelText, setTaQtyLabelText] = useState('Qty');
    const handleTaQtyLabelChange = (e) => {
        // setTaQtyLabelText(e.target.value);
        setTemplateJson((prev) => ({
            ...prev,
            table: {
                ...prev.table,
                labels_section: {
                    ...prev.table.labels_section,
                    table_properties: {
                        ...prev.table.labels_section.table_properties,
                        quantity: {
                            ...prev.table.labels_section.table_properties.quantity,
                            label: e.target.value
                        }
                    }
                }
            }
        }))
    };
    // Label - Qty Unit checkbox
    const [isTaQtyUnitEnabled, setIsTaQtyUnitEnabled] = useState(true);
    const taQtyUnitCheckbox = (e, setter) => {
        // setter(e.target.checked);
        setTemplateJson((prev) => ({
            ...prev,
            table: {
                ...prev.table,
                labels_section: {
                    ...prev.table.labels_section,
                    table_properties: {
                        ...prev.table.labels_section.table_properties,
                        quantity: {
                            ...prev.table.labels_section.table_properties.quantity,
                            is_show_unit: e.target.checked
                        }
                    }
                }
            }
        }))
    };

    // Label - Rate checkbox
    const [isTaRateEnabled, setIsTaRateEnabled] = useState(true);
    const taRateCheckbox = (e, setter) => {
        // setter(e.target.checked);
        setTemplateJson((prev) => ({
            ...prev,
            table: {
                ...prev.table,
                labels_section: {
                    ...prev.table.labels_section,
                    table_properties: {
                        ...prev.table.labels_section.table_properties,
                        rate: {
                            ...prev.table.labels_section.table_properties.rate,
                            is_show_rate: e.target.checked
                        }
                    }
                }
            }
        }))
    };
    // Label - Rate width
    const [taRateWidth, setTaRateWidth] = useState('11');
    const handleTaRateWidthChange = (e) => {
        // setTaRateWidth(e.target.value);
        setTemplateJson((prev) => ({
            ...prev,
            table: {
                ...prev.table,
                labels_section: {
                    ...prev.table.labels_section,
                    table_properties: {
                        ...prev.table.labels_section.table_properties,
                        rate: {
                            ...prev.table.labels_section.table_properties.rate,
                            width: e.target.value
                        }
                    }
                }
            }
        }))
    };
    // Label - Rate  
    const [taRateLabelText, setTaRateLabelText] = useState('Rate');
    const handleTaRateLabelChange = (e) => {
        // setTaRateLabelText(e.target.value);
        setTemplateJson((prev) => ({
            ...prev,
            table: {
                ...prev.table,
                labels_section: {
                    ...prev.table.labels_section,
                    table_properties: {
                        ...prev.table.labels_section.table_properties,
                        rate: {
                            ...prev.table.labels_section.table_properties.rate,
                            label: e.target.value
                        }
                    }
                }
            }
        }))
    };

    // Label - Discount checkbox
    const [isTaDisEnabled, setIsTaDisEnabled] = useState(false);
    const taDisCheckbox = (e, setter) => {
        // setter(e.target.checked);
        setTemplateJson((prev) => ({
            ...prev,
            table: {
                ...prev.table,
                labels_section: {
                    ...prev.table.labels_section,
                    table_properties: {
                        ...prev.table.labels_section.table_properties,
                        discount: {
                            ...prev.table.labels_section.table_properties.discount,
                            is_show_discount: e.target.checked
                        }
                    }
                }
            }
        }))
    };
    // Label - Discount width
    const [taDisWidth, setTaDisWidth] = useState('11');
    const handleTaDisWidthChange = (e) => {
        // setTaDisWidth(e.target.value);
        setTemplateJson((prev) => ({
            ...prev,
            table: {
                ...prev.table,
                labels_section: {
                    ...prev.table.labels_section,
                    table_properties: {
                        ...prev.table.labels_section.table_properties,
                        discount: {
                            ...prev.table.labels_section.table_properties.discount,
                            width: e.target.value
                        }
                    }
                }
            }
        }))
    };
    // Label - Discount  
    const [taDisLabelText, setTaDisLabelText] = useState('Discount');
    const handleTaDisLabelChange = (e) => {
        // setTaDisLabelText(e.target.value);
        setTemplateJson((prev) => ({
            ...prev,
            table: {
                ...prev.table,
                labels_section: {
                    ...prev.table.labels_section,
                    table_properties: {
                        ...prev.table.labels_section.table_properties,
                        discount: {
                            ...prev.table.labels_section.table_properties.discount,
                            label: e.target.value
                        }
                    }
                }
            }
        }))
    };

    // Label - Tax % checkbox
    const [isTaTaxPerEnabled, setIsTaTaxPerEnabled] = useState(false);
    const taTaxPerCheckbox = (e, setter) => {
        // setter(e.target.checked);
        setTemplateJson((prev) => ({
            ...prev,
            table: {
                ...prev.table,
                labels_section: {
                    ...prev.table.labels_section,
                    table_properties: {
                        ...prev.table.labels_section.table_properties,
                        tax: {
                            ...prev.table.labels_section.table_properties.tax,
                            is_show_tax: e.target.checked
                        }
                    }
                }
            }
        }))
    };
    // Label - Tax % width
    const [taTaxPerWidth, setTaTaxPerWidth] = useState('11');
    const handleTaTaxPerWidthChange = (e) => {
        // setTaTaxPerWidth(e.target.value);
        setTemplateJson((prev) => ({
            ...prev,
            table: {
                ...prev.table,
                labels_section: {
                    ...prev.table.labels_section,
                    table_properties: {
                        ...prev.table.labels_section.table_properties,
                        tax: {
                            ...prev.table.labels_section.table_properties.tax,
                            width: e.target.value
                        }
                    }
                }
            }
        }))
    };
    // Label - Tax %  
    const [taTaxPerLabelText, setTaTaxPerLabelText] = useState('Tax %');
    const handleTaTaxPerLabelChange = (e) => {
        // setTaTaxPerLabelText(e.target.value);
        setTemplateJson((prev) => ({
            ...prev,
            table: {
                ...prev.table,
                labels_section: {
                    ...prev.table.labels_section,
                    table_properties: {
                        ...prev.table.labels_section.table_properties,
                        tax: {
                            ...prev.table.labels_section.table_properties.tax,
                            label: e.target.value
                        }
                    }
                }
            }
        }))
    };

    // Label - Tax Amount checkbox
    const [isTaTaxAmtEnabled, setIsTaTaxAmtEnabled] = useState(false);
    const taTaxAmtCheckbox = (e, setter) => {
        setter(e.target.checked);
    };
    // Label - Tax Amount width
    const [taTaxAmtWidth, setTaTaxAmtWidth] = useState('11');
    const handleTaTaxAmtWidthChange = (e) => {
        setTaTaxAmtWidth(e.target.value);
    };
    // Label - Tax Amount  
    const [taTaxAmtLabelText, setTaTaxAmtLabelText] = useState('Tax');
    const handleTaTaxAmtLabelChange = (e) => {
        setTaTaxAmtLabelText(e.target.value);
    };

    // Label - Amount checkbox
    const [isTaAmtEnabled, setIsTaAmtEnabled] = useState(true);
    const taAmtCheckbox = (e, setter) => {
        // setter(e.target.checked);
        setTemplateJson((prev) => ({
            ...prev,
            table: {
                ...prev.table,
                labels_section: {
                    ...prev.table.labels_section,
                    table_properties: {
                        ...prev.table.labels_section.table_properties,
                        amount: {
                            ...prev.table.labels_section.table_properties.amount,
                            is_show_amount: e.target.checked
                        }
                    }
                }
            }
        }))
    };
    // Label - Amount width
    const [taAmtWidth, setTaAmtWidth] = useState('13');
    const handleTaAmtWidthChange = (e) => {
        // setTaAmtWidth(e.target.value);
        setTemplateJson((prev) => ({
            ...prev,
            table: {
                ...prev.table,
                labels_section: {
                    ...prev.table.labels_section,
                    table_properties: {
                        ...prev.table.labels_section.table_properties,
                        amount: {
                            ...prev.table.labels_section.table_properties.amount,
                            width: e.target.value
                        }
                    }
                }
            }
        }))
    };
    // Label - Amount  
    const [taAmtLabelText, setTaAmtLabelText] = useState('Amount');
    const handleTaAmtLabelChange = (e) => {
        // setTaAmtLabelText(e.target.value);
        setTemplateJson((prev) => ({
            ...prev,
            table: {
                ...prev.table,
                labels_section: {
                    ...prev.table.labels_section,
                    table_properties: {
                        ...prev.table.labels_section.table_properties,
                        amount: {
                            ...prev.table.labels_section.table_properties.amount,
                            label: e.target.value
                        }
                    }
                }
            }
        }))
    };
    // END:: Label Settings //

    // projects labels

    const handleProjectItemChange = (e) => {
        // setTaAmtLabelText(e.target.value);
        setTemplateJson((prev) => ({
            ...prev,
            table: {
                ...prev.table,
                labels_section: {
                    ...prev.table.labels_section,
                    invoices_created_from_projects: {
                        ...prev.table.labels_section.invoices_created_from_projects,
                        project_item: e.target.value
                    }
                }
            }
        }))
    };

    const handleProjectDescChange = (e) => {
        // setTaAmtLabelText(e.target.value);
        setTemplateJson((prev) => ({
            ...prev,
            table: {
                ...prev.table,
                labels_section: {
                    ...prev.table.labels_section,
                    invoices_created_from_projects: {
                        ...prev.table.labels_section.invoices_created_from_projects,
                        project_description: e.target.value
                    }
                }
            }
        }))
    };

    const handleProjectHoursChange = (e) => {
        // setTaAmtLabelText(e.target.value);
        setTemplateJson((prev) => ({
            ...prev,
            table: {
                ...prev.table,
                labels_section: {
                    ...prev.table.labels_section,
                    invoices_created_from_projects: {
                        ...prev.table.labels_section.invoices_created_from_projects,
                        project_hours: e.target.value
                    }
                }
            }
        }))
    };

    // Begin:: Table Layout Settings
    const [tempBorderColor, setTempBorderColor] = useState('#9e9e9e');
    const [isTableBorderEnabled, setIsTableBorderEnabled] = useState(true);
    const handleTempBorderCheckboxChange = (isChecked) => {
        // setIsTableBorderEnabled(isChecked);
        setTemplateJson((prev) => ({
            ...prev,
            table: {
                ...prev.table,
                layout_section: {
                    ...prev.table.layout_section,
                    table_properties: {
                        ...prev.table.layout_section.table_properties,
                        is_show_table_border: isChecked
                    }
                }
            }
        }))
    };

    // Table Head
    const [taHeadFontSize, setTaHeadFontSize] = useState('8');

    const [taHeadBgColor, setTaHeadBgColor] = useState('#f2f3f4');
    const [isTaHeadBgColorEnabled, setIsTaHeadBgColorEnabled] = useState(true);
    const handleTaHeadBgColorCheckboxChange = (isChecked) => {
        // setIsTaHeadBgColorEnabled(isChecked);
        setTemplateJson((prev) => ({
            ...prev,
            table: {
                ...prev.table,
                layout_section: {
                    ...prev.table.layout_section,
                    table_properties: {
                        ...prev.table.layout_section.table_properties,
                        table_header: {
                            ...prev.table.layout_section.table_properties.table_header,
                            is_show_bg_color: isChecked
                        }
                    }
                }
            }
        }))
    };

    const [taHeadFontColor, setTaHeadFontColor] = useState('#000000');

    // Table Body (Item Row)
    const [taBodyFontSize, setTaBodyFontSize] = useState('8');

    const [taBodyBgColor, setTaBodyBgColor] = useState('#ffffff');
    const [isTaBodyBgColorEnabled, setIsTaBodyBgColorEnabled] = useState(true);
    const handleTaBodyBgColorCheckboxChange = (isChecked) => {
        // setIsTaBodyBgColorEnabled(isChecked);
        setTemplateJson((prev) => ({
            ...prev,
            table: {
                ...prev.table,
                layout_section: {
                    ...prev.table.layout_section,
                    table_properties: {
                        ...prev.table.layout_section.table_properties,
                        item_row: {
                            ...prev.table.layout_section.table_properties.item_row,
                            is_show_bg_color: isChecked
                        }
                    }
                }
            }
        }))
    };

    const [taBodyFontColor, setTaBodyFontColor] = useState('#000000');
    const [taBodyDescSize, setTaBodyDescSize] = useState('8');
    const [taBodyDescColor, setTaBodyDescColor] = useState('#000000');
    // END:: Table Layout Settings //
    // END:: Table Settings //

    // Begin:: Total Section Settings //
    // Labels section
    const [isAllTotalSetEnabled, setIsAllTotalSetEnabled] = useState(true);
    const allTotalSetChange = (e) => {
        // setIsAllTotalSetEnabled(e.target.checked);
        setTemplateJson((prev) => ({
            ...prev,
            total: {
                ...prev.total,
                labels_section: {
                    ...prev.total.labels_section,
                    is_show_total_section: e.target.checked
                }
            }
        }))
    };

    const [subTotalText, setSubTotalText] = useState("Sub Total");
    const [isSubTotalEnabled, setIsSubTotalEnabled] = useState(true);
    const handleSubTotalCheckboxChange = (isChecked) => {
        // setIsSubTotalEnabled(isChecked);
        setTemplateJson((prev) => ({
            ...prev,
            total: {
                ...prev.total,
                labels_section: {
                    ...prev.total.labels_section,
                    is_show_sub_total: isChecked
                }
            }
        }))
    };

    const [shipChargeText, setShipChargeText] = useState("Shipping Charge");
    const [isShipChargeEnabled, setIsShipChargeEnabled] = useState(true);
    const handleShipChargeCheckboxChange = (isChecked) => {
        // setIsShipChargeEnabled(isChecked);
        setTemplateJson((prev) => ({
            ...prev,
            total: {
                ...prev.total,
                labels_section: {
                    ...prev.total.labels_section,
                    is_show_shipping_charges: isChecked
                }
            }
        }))
    };

    const [isDiscountSecEnabled, setIsDiscountSecEnabled] = useState(true);
    const discountSecChange = (e) => {
        // setIsDiscountSecEnabled(e.target.checked);
        setTemplateJson((prev) => ({
            ...prev,
            total: {
                ...prev.total,
                labels_section: {
                    ...prev.total.labels_section,
                    is_show_discount: e.target.checked
                }
            }
        }))
    };

    const adjustmentSecChange = (e) => {
        // setIsDiscountSecEnabled(e.target.checked);
        setTemplateJson((prev) => ({
            ...prev,
            total: {
                ...prev.total,
                labels_section: {
                    ...prev.total.labels_section,
                    is_show_adjustment: e.target.checked
                }
            }
        }))
    };

    // Tatal Taxable Amount checkbox
    const [isToTaxAmtEnabled, setIsToTaxAmtEnabled] = useState(false);
    const toTaxAmtCheckbox = (e) => {
        // setIsToTaxAmtEnabled(e.target.checked);
        setTemplateJson((prev) => ({
            ...prev,
            total: {
                ...prev.total,
                labels_section: {
                    ...prev.total.labels_section,
                    is_show_tax: e.target.checked
                }
            }
        }))
    };

    // Tatal Taxable Amount Label Text
    const [toTaxAmtLabelText, setToTaxAmtLabelText] = useState('Total Taxable Amount');
    const handleToTaxAmtLabelChange = (e) => {
        // setToTaxAmtLabelText(e.target.value);
        setTemplateJson((prev) => ({
            ...prev,
            total: {
                ...prev.total,
                labels_section: {
                    ...prev.total.labels_section,
                    tax_title: e.target.value
                }
            }
        }))
    };

    // Show Tax Details 
    const [isShowTaxDetailEnabled, setIsShowTaxDetailEnabled] = useState(false);
    const showTaxDetailCheckbox = (e) => {
        setIsShowTaxDetailEnabled(e.target.checked);
    };

    const [mainTotalText, setMainTotalText] = useState("Total");
    const [isMainTotalEnabled, setIsMainTotalEnabled] = useState(true);
    const handleMainTotalCheckboxChange = (isChecked) => {
        // setIsMainTotalEnabled(isChecked);
        setTemplateJson((prev) => ({
            ...prev,
            total: {
                ...prev.total,
                labels_section: {
                    ...prev.total.labels_section,
                    is_show_total: isChecked
                }
            }
        }))
    };

    // Currency symbol position
    const [isCurSymbolEnabled, setIsCurSymbolEnabled] = useState(true);
    const [selectedCurSymbolPos, setSelectedCurSymbolPos] = useState("beforeAmt");

    // Show Payment Details
    const [isPayDetailSetEnabled, setIsPayDetailSetEnabled] = useState(true);
    const payDetailSetChange = (e) => {
        setIsPayDetailSetEnabled(e.target.checked);
    };
    const [payMadeLabel, setPayMadeLabel] = useState("Payment Made");
    const handlePayMadeLabelChange = (e) => {
        setPayMadeLabel(e.target.value);
    };
    const [creditAppliedLabel, setCreditAppliedLabel] = useState("Payment Made");
    const handleCreditAppliedLabelChange = (e) => {
        setCreditAppliedLabel(e.target.value);
    };
    const [amtWitheldLabel, setAmtWitheldLabel] = useState("Amount Withheld");
    const handleAmtWitheldLabelChange = (e) => {
        setAmtWitheldLabel(e.target.value);
    };
    const [writeOffAmtLabel, setWriteOffAmtLabel] = useState("Write Off Amount");
    const handleWriteOffAmtLabelChange = (e) => {
        setWriteOffAmtLabel(e.target.value);
    };
    const [balDueAmtLabel, setBalDueAmtLabel] = useState("Balance Due");
    const handleBalDueAmtLabelChange = (e) => {
        setBalDueAmtLabel(e.target.value);
    };

    // Quantity Total setting check
    const [isTotalQtySetEnabled, setIsTotalQtySetEnabled] = useState(false);
    const totalQtySetChange = (e) => {
        // setIsTotalQtySetEnabled(e.target.checked);
        setTemplateJson((prev) => ({
            ...prev,
            total: {
                ...prev.total,
                labels_section: {
                    ...prev.total.labels_section,
                    is_show_qty: e.target.checked
                }
            }
        }))
    };
    const [itemsTotalLabelText, setItemsTotalLabelText] = useState("Items in Total");
    const handleItemsTotalLabelChange = (e) => {
        // setItemsTotalLabelText(e.target.value);
        setTemplateJson((prev) => ({
            ...prev,
            total: {
                ...prev.total,
                labels_section: {
                    ...prev.total.labels_section,
                    qty_title: e.target.value
                }
            }
        }))
    };
    const [hoursTotalLabelText, setHoursTotalLabelText] = useState("Hours in Total");
    const handleHoursTotalLabelChange = (e) => {
        setHoursTotalLabelText(e.target.value);
    };

    // Show amount in words check
    const [isAmtShowWordsEnabled, setIsAmtShowWordsEnabled] = useState(true);
    const amtShowWordsChange = (e) => {
        // setIsAmtShowWordsEnabled(e.target.checked);
        setTemplateJson((prev) => ({
            ...prev,
            total: {
                ...prev.total,
                labels_section: {
                    ...prev.total.labels_section,
                    is_show_amount_in_words: e.target.checked
                }
            }
        }))
    };
    // END:: Labels Section // 

    // Begin:: Layout Section 
    // Total section layout setiings
    const [totalSecFsize, setTotalSecFsize] = useState('8');
    const [totalSecFcolor, setTotalSecFcolor] = useState('#000000');
    const [totalSecBgColor, setTotalSecBgColor] = useState('#ffffff');
    const [isTotalSecBgColorEnabled, setIsTotalSecBgColorEnabled] = useState(true);
    const handleTotalSecBgColorCheckboxChange = (isChecked) => {
        // setIsTotalSecBgColorEnabled(isChecked);
        setTemplateJson((prev) => ({
            ...prev,
            total: {
                ...prev.total,
                layout_section: {
                    ...prev.total.layout_section,
                    total: {
                        ...prev.total.layout_section.total,
                        is_show_bg_color: isChecked
                    }
                }
            }
        }))
    };

    // Balance Due section layout setiings
    const [balDueSecFsize, setBalDueSecFsize] = useState('9');
    const [balDueSecFcolor, setBalDueSecFcolor] = useState('#000000');
    const [balDueSecBgColor, setBalDueSecBgColor] = useState('#ffffff');
    const [isBalDueSecBgColorEnabled, setIsBalDueSecBgColorEnabled] = useState(true);
    const handleBalDueSecBgColorCheckboxChange = (isChecked) => {
        // setIsBalDueSecBgColorEnabled(isChecked);
        setTemplateJson((prev) => ({
            ...prev,
            total: {
                ...prev.total,
                layout_section: {
                    ...prev.total.layout_section,
                    balance_due: {
                        ...prev.total.layout_section.balance_due,
                        is_show_bg_color: isChecked
                    }
                }
            }
        }))
    };
    // END:: Layout Section //
    // END:: Total Section Settings //

    // Begin:: Other Details Section Settings //
    // Begin:: Document Summary Tab Settings //
    const [notesLabelText, setNotesLabelText] = useState("Notes");
    const handleNotesLabelChange = (e) => {
        // setNotesLabelText(e.target.value);
        setTemplateJson((prev) => ({
            ...prev,
            other_details: {
                ...prev.other_details,
                document_summary: {
                    ...prev.other_details.document_summary,
                    notes: {
                        ...prev.other_details.document_summary.notes,
                        [e.target.name]: e.target.value
                    }
                }
            }
        }))
    };
    const [notesFsize, setNotesFsize] = useState('8');

    const [onlinePayLinkText, setOnlinePayLinkText] = useState("Payment Options");
    const [isOnlinePayLinkEnabled, setIsOnlinePayLinkEnabled] = useState(true);
    const handleOnlinePayLinkCheckboxChange = (isChecked) => {
        setIsOnlinePayLinkEnabled(isChecked);
    };

    const [addBankDetailsModal, setAddBankDetailsModal] = useState(false);
    function handleAddBankDetailsModalShow() {
        setAddBankDetailsModal(true);
    }

    // Terms & Conditions
    const [isTermCondSetEnabled, setIsTermCondSetEnabled] = useState(true);
    const termCondSetChange = (e) => {
        // setIsTermCondSetEnabled(e.target.checked);
        setTemplateJson((prev) => ({
            ...prev,
            other_details: {
                ...prev.other_details,
                document_summary: {
                    ...prev.other_details.document_summary,
                    terms_and_conditions: {
                        ...prev.other_details.document_summary.terms_and_conditions,
                        is_show_terms_and_conditions: e.target.checked
                    }
                }
            }
        }))
    };
    const [termCondLabelText, setTermCondLabelText] = useState("Terms & Conditions");
    const handleTermCondLabelChange = (e) => {
        // setTermCondLabelText(e.target.value);
        setTemplateJson((prev) => ({
            ...prev,
            other_details: {
                ...prev.other_details,
                document_summary: {
                    ...prev.other_details.document_summary,
                    terms_and_conditions: {
                        ...prev.other_details.document_summary.terms_and_conditions,
                        [e.target.name]: e.target.value
                    }
                }
            }
        }))
    };
    const [termCondFsize, setTermCondFsize] = useState('8');

    // Signature
    const [isSignSetEnabled, setIsSignSetEnabled] = useState(true);
    const signSetChange = (e) => {
        // setIsSignSetEnabled(e.target.checked);
        setTemplateJson((prev) => ({
            ...prev,
            other_details: {
                ...prev.other_details,
                document_summary: {
                    ...prev.other_details.document_summary,
                    signature: {
                        ...prev.other_details.document_summary.signature,
                        is_show_signature: e.target.checked
                    }
                }
            }
        }))
    };
    const [signLabelText, setSignLabelText] = useState("Authorized Signature");
    const handleSignLabelChange = (e) => {
        // setSignLabelText(e.target.value);
        setTemplateJson((prev) => ({
            ...prev,
            other_details: {
                ...prev.other_details,
                document_summary: {
                    ...prev.other_details.document_summary,
                    signature: {
                        ...prev.other_details.document_summary.signature,
                        label_title: e.target.value
                    }
                }
            }
        }))
    };

    // Signature Image
    const [signImg, setSignImg] = useState(null);
    const [signImgError, setSignImgError] = useState("");
    // Signature Image Change
    const signImgChange = (event) => {
        const file = event.target.files[0];
        if (file) {
            if (file.type.startsWith("image/")) {
                const fileUrl = URL.createObjectURL(file);
                // setSignImg({ fileimage: fileUrl, filename: file.name });
                setTemplateJson((prev) => ({
                    ...prev,
                    other_details: {
                        ...prev.other_details,
                        document_summary: {
                            ...prev.other_details.document_summary,
                            signature: {
                                ...prev.other_details.document_summary.signature,
                                signature_image: { fileimage: fileUrl, filename: file.name }
                            }
                        }
                    }
                }))
                setSignImgError("");
            } else {
                setSignImgError("Please select a image file only.");
                // setSignImg(null);
                setTemplateJson((prev) => ({
                    ...prev,
                    other_details: {
                        ...prev.other_details,
                        document_summary: {
                            ...prev.other_details.document_summary,
                            signature: {
                                ...prev.other_details.document_summary.signature,
                                signature_image: null
                            }
                        }
                    }
                }))
            }
        }
    };
    const removeSignImage = () => {
        // setSignImg(null);
        setTemplateJson((prev) => ({
            ...prev,
            other_details: {
                ...prev.other_details,
                document_summary: {
                    ...prev.other_details.document_summary,
                    signature: {
                        ...prev.other_details.document_summary.signature,
                        signature_image: null
                    }
                }
            }
        }))
        setSignImgError("");
    };

    // Sign Name
    const [signNameText, setSignNameText] = useState("");
    const handleSignNameChange = (e) => {
        // setSignNameText(e.target.value);
        setTemplateJson((prev) => ({
            ...prev,
            other_details: {
                ...prev.other_details,
                document_summary: {
                    ...prev.other_details.document_summary,
                    signature: {
                        ...prev.other_details.document_summary.signature,
                        signature_name: e.target.value
                    }
                }
            }
        }))
    };
    // END:: Document Summary Tab Settings //

    // Begin:: Annexure Tab Settings //
    const [addAnnexureModal, setAddAnnexureModal] = useState(false);
    function handleAddAnnexureModalShow() {
        setAddAnnexureModal(true);
    }

    const [annexContValues, setAnnexContValues] = useState('');
    const handleAnnexContValuesChange = (e) => {
        setAnnexContValues(e.target.value);
    };
    const handleInsertAnnexContPlaceholder = (placeholder) => {
        setAnnexContValues(prev => prev + `\n%${placeholder}%`);
    };
    // END:: Annexure Tab Settings //
    // END:: Other Details Section Settings //

    useEffect(() => {
        if (navbarList?.length) {
            let so_id = navbarList?.filter(item => item.name === 'Invoices')?.[0]?._id
            setInvModuleId(so_id)
        }
    }, [navbarList])
    // set content array to json
    useEffect(() => {
        setTemplateJson((prev) => ({
            ...prev,
            header: {
                ...prev.header,
                custom_header_content: QTHeaderValues
            }
        }))
    }, [QTHeaderValues])

    useEffect(() => {
        setTemplateJson((prev) => ({
            ...prev,
            footer: {
                ...prev.footer,
                custom_footer_content: QTFooterValues
            }
        }))
    }, [QTFooterValues])

    useEffect(() => {
        setTemplateJson((prev) => ({
            ...prev,
            organization: {
                ...prev.organization,
                custom_org_content: QTOrganizationValues
            }
        }))
    }, [QTOrganizationValues])

    useEffect(() => {
        setTemplateJson((prev) => ({
            ...prev,
            customer: {
                ...prev.customer,
                custom_bill_to_content: QTBillToValues
            }
        }))
    }, [QTBillToValues])

    useEffect(() => {
        setTemplateJson((prev) => ({
            ...prev,
            customer: {
                ...prev.customer,
                custom_ship_to_content: QTShipToValues
            }
        }))
    }, [QTShipToValues])

    useEffect(() => {
        setTemplateJson((prev) => ({
            ...prev,
            document: {
                ...prev.document,
                custom_document_content: QTAttentionValues
            }
        }))
    }, [QTAttentionValues])

    useEffect(() => {
        setTemplateJson((prev) => ({
            ...prev,
            table: {
                ...prev.table,
                labels_section: {
                    ...prev.table.labels_section,
                    table_properties: {
                        ...prev.table.labels_section.table_properties,
                        custom_item_description_content: QTItemValues
                    }
                }
            }
        }))
    }, [QTItemValues])

    useEffect(() => {
        setTemplateJson((prev) => ({
            ...prev,
            other_details: {
                ...prev.other_details,
                annexure: {
                    ...prev.other_details.annexure,
                    custom_annexure_content: QTAnnexureValues
                }
            }
        }))
    }, [QTAnnexureValues])

    useEffect(() => {
        if (selectedTemplateData) {
            setTemplateName(selectedTemplateData.templateProperties.general.template_property.template_name)
            setTemplateJson(selectedTemplateData?.templateProperties)
            setQTHeaderValues(selectedTemplateData?.templateProperties?.header?.custom_header_content)
            setQTFooterValues(selectedTemplateData?.templateProperties?.footer?.custom_footer_content)
            setQTOrganizationValues(selectedTemplateData?.templateProperties?.organization?.custom_org_content)
            setQTBillToValues(selectedTemplateData?.templateProperties?.customer?.custom_bill_to_content)
            setQTShipToValues(selectedTemplateData?.templateProperties?.customer?.custom_ship_to_content)
            setQTAttentionValues(selectedTemplateData?.templateProperties?.document?.custom_document_content)
            setQTItemValues(selectedTemplateData?.templateProperties?.table?.labels_section?.table_properties?.custom_item_description_content)
            setQTAnnexureValues(selectedTemplateData?.templateProperties?.other_details?.annexure?.custom_annexure_content)
            if (selectedTemplateData?.templateProperties?.document?.document_information?.length > 0)
                setCheckboxes(selectedTemplateData?.templateProperties?.document?.document_information)
        }
    }, [selectedTemplateData])

    useEffect(() => {
        if (templateData?.createStatus === true || templateData?.updateStatus === true) {
            toast.success(templateData?.message, {
                autoClose: 1000,
                onClose: () => {
                    dispatch(resetState())
                    navigate(Utils.getNavigationUrl(`print-template`))
                }
            });
        }
        if (templateData?.createStatus === false || templateData?.updateStatus === false) {
            toast.error(templateData?.message, {
                autoClose: 2000,
                onClose: () => {
                    dispatch(resetState())
                    // window.location.reload();
                }
            });
        }
    }, [templateData?.createStatus, templateData.updateStatus])

    const saveTemplate = async () => {
        if (divRef.current) {
            let payload = {
                "moduleId": invModuleId,
                "templateName": templateName,
                "content": divRef.current.outerHTML,
                "templateProperties": templateJson
            }
            console.log('payload:', payload)
            dispatch(createTemplateStart(payload))
        }
    }

    const updateTemplate = async () => {
        if (divRef.current) {
            let payload = {
                "moduleId": invModuleId,
                "templateName": templateName,
                "content": divRef.current.outerHTML,
                "templateProperties": templateJson
            }
            console.log('payload:', payload)
            dispatch(updateTemplateStart({
                id: selectedTemplateData._id, payload: payload
            }))
        }
    }

    const refreshPreview = () => {
        setShowLoader(true);
        setTimeout(() => {
            setShowLoader(false);
        }, 2000);
    }

    // other details-color
    const handleOtherNoteFontChange = (value) => {
        setTemplateJson((prev) => ({
            ...prev,
            other_details: {
                ...prev.other_details,
                document_summary: {
                    ...prev.other_details.document_summary,
                    notes: {
                        ...prev.other_details.document_summary.notes,
                        font_size: value
                    }
                }
            }
        }))
    }

    const handleOtherTermsFontChange = (value) => {
        setTemplateJson((prev) => ({
            ...prev,
            other_details: {
                ...prev.other_details,
                document_summary: {
                    ...prev.other_details.document_summary,
                    terms_and_conditions: {
                        ...prev.other_details.document_summary.terms_and_conditions,
                        font_size: value
                    }
                }
            }
        }))
    }

    // transaction-color
    const handleTransactionOrgFontColorChange = (value) => {
        setTemplateJson((prev) => ({
            ...prev,
            organization: {
                ...prev.organization,
                font_color: value
            }
        }))
    }

    const handleTransactionCusFontColorChange = (value) => {
        setTemplateJson((prev) => ({
            ...prev,
            customer: {
                ...prev.customer,
                font_color: value
            }
        }))
    }

    const handleTransactionDOcFontColorChange = (value) => {
        setTemplateJson((prev) => ({
            ...prev,
            document: {
                ...prev.document,
                font_color: value
            }
        }))
    }

    // total-color
    const handleTotalTitleChange = (value) => {
        setTemplateJson((prev) => ({
            ...prev,
            total: {
                ...prev.total,
                labels_section: {
                    ...prev.total.labels_section,
                    total_title: value
                }
            }
        }))
    }

    const handleTotalSubTotalTitleChange = (value) => {
        setTemplateJson((prev) => ({
            ...prev,
            total: {
                ...prev.total,
                labels_section: {
                    ...prev.total.labels_section,
                    sub_total_title: value
                }
            }
        }))
    }

    const handleTotalShpChargeTitleChange = (value) => {
        setTemplateJson((prev) => ({
            ...prev,
            total: {
                ...prev.total,
                labels_section: {
                    ...prev.total.labels_section,
                    sub_total_title: value
                }
            }
        }))
    }

    const handleTotalFontChange = (value) => {
        setTemplateJson((prev) => ({
            ...prev,
            total: {
                ...prev.total,
                layout_section: {
                    ...prev.total.layout_section,
                    total: {
                        ...prev.total.layout_section.total,
                        font_size: value
                    }
                }
            }
        }))
    }

    const handleTotalBgColorChange = (value) => {
        setTemplateJson((prev) => ({
            ...prev,
            total: {
                ...prev.total,
                layout_section: {
                    ...prev.total.layout_section,
                    total: {
                        ...prev.total.layout_section.total,
                        bg_color: value
                    }
                }
            }
        }))
    }

    const handleTotalFontColorChange = (value) => {
        setTemplateJson((prev) => ({
            ...prev,
            total: {
                ...prev.total,
                layout_section: {
                    ...prev.total.layout_section,
                    total: {
                        ...prev.total.layout_section.total,
                        font_color: value
                    }
                }
            }
        }))
    }

    const handleTotalBlcFontChange = (value) => {
        setTemplateJson((prev) => ({
            ...prev,
            total: {
                ...prev.total,
                layout_section: {
                    ...prev.total.layout_section,
                    balance_due: {
                        ...prev.total.layout_section.balance_due,
                        font_size: value
                    }
                }
            }
        }))
    }

    const handleTotalBlcBgColorChange = (value) => {
        setTemplateJson((prev) => ({
            ...prev,
            total: {
                ...prev.total,
                layout_section: {
                    ...prev.total.layout_section,
                    balance_due: {
                        ...prev.total.layout_section.balance_due,
                        bg_color: value
                    }
                }
            }
        }))
    }

    const handleTotalBlcFontColorChange = (value) => {
        setTemplateJson((prev) => ({
            ...prev,
            total: {
                ...prev.total,
                layout_section: {
                    ...prev.total.layout_section,
                    balance_due: {
                        ...prev.total.layout_section.balance_due,
                        font_color: value
                    }
                }
            }
        }))
    }

    // table-color

    const handleTableBorderColorChange = (value) => {
        setTemplateJson((prev) => ({
            ...prev,
            table: {
                ...prev.table,
                layout_section: {
                    ...prev.table.layout_section,
                    table_properties: {
                        ...prev.table.layout_section.table_properties,
                        table_border: value
                    }
                }
            }
        }))
    }

    const handleTableHeaderFontChange = (value) => {
        setTemplateJson((prev) => ({
            ...prev,
            table: {
                ...prev.table,
                layout_section: {
                    ...prev.table.layout_section,
                    table_properties: {
                        ...prev.table.layout_section.table_properties,
                        table_header: {
                            ...prev.table.layout_section.table_properties.table_header,
                            font_size: value
                        }
                    }
                }
            }
        }))
    }

    const handleTableHeaderBgColorChange = (value) => {
        setTemplateJson((prev) => ({
            ...prev,
            table: {
                ...prev.table,
                layout_section: {
                    ...prev.table.layout_section,
                    table_properties: {
                        ...prev.table.layout_section.table_properties,
                        table_header: {
                            ...prev.table.layout_section.table_properties.table_header,
                            bg_color: value
                        }
                    }
                }
            }
        }))
    }

    const handleTableHeaderFontColorChange = (value) => {
        setTemplateJson((prev) => ({
            ...prev,
            table: {
                ...prev.table,
                layout_section: {
                    ...prev.table.layout_section,
                    table_properties: {
                        ...prev.table.layout_section.table_properties,
                        table_header: {
                            ...prev.table.layout_section.table_properties.table_header,
                            font_color: value
                        }
                    }
                }
            }
        }))
    }

    const handleTableRowFontChange = (value) => {
        setTemplateJson((prev) => ({
            ...prev,
            table: {
                ...prev.table,
                layout_section: {
                    ...prev.table.layout_section,
                    table_properties: {
                        ...prev.table.layout_section.table_properties,
                        item_row: {
                            ...prev.table.layout_section.table_properties.item_row,
                            font_size: value
                        }
                    }
                }
            }
        }))
    }

    const handleTableRowBgColorChange = (value) => {
        setTemplateJson((prev) => ({
            ...prev,
            table: {
                ...prev.table,
                layout_section: {
                    ...prev.table.layout_section,
                    table_properties: {
                        ...prev.table.layout_section.table_properties,
                        item_row: {
                            ...prev.table.layout_section.table_properties.item_row,
                            bg_color: value
                        }
                    }
                }
            }
        }))
    }

    const handleTableRowFontColorChange = (value) => {
        setTemplateJson((prev) => ({
            ...prev,
            table: {
                ...prev.table,
                layout_section: {
                    ...prev.table.layout_section,
                    table_properties: {
                        ...prev.table.layout_section.table_properties,
                        item_row: {
                            ...prev.table.layout_section.table_properties.item_row,
                            font_color: value
                        }
                    }
                }
            }
        }))
    }

    const handleTableDescFontChange = (value) => {
        setTemplateJson((prev) => ({
            ...prev,
            table: {
                ...prev.table,
                layout_section: {
                    ...prev.table.layout_section,
                    table_properties: {
                        ...prev.table.layout_section.table_properties,
                        item_description: {
                            ...prev.table.layout_section.table_properties.item_description,
                            font_size: value
                        }
                    }
                }
            }
        }))
    }

    const handleTableDescFontColorChange = (value) => {
        setTemplateJson((prev) => ({
            ...prev,
            table: {
                ...prev.table,
                layout_section: {
                    ...prev.table.layout_section,
                    table_properties: {
                        ...prev.table.layout_section.table_properties,
                        item_description: {
                            ...prev.table.layout_section.table_properties.item_description,
                            font_color: value
                        }
                    }
                }
            }
        }))
    }

    // footer-color
    const handleFooterBgColorChange = (value) => {
        setTemplateJson((prev) => ({
            ...prev,
            footer: {
                ...prev.footer,
                bg_color: value
            }
        }))
    }

    const handleFooterFontColorChange = (value) => {
        setTemplateJson((prev) => ({
            ...prev,
            footer: {
                ...prev.footer,
                font_color: value
            }
        }))
    }

    // header-color
    const handleHeaderBgColorChange = (value) => {
        setTemplateJson((prev) => ({
            ...prev,
            header: {
                ...prev.header,
                bg_color: value
            }
        }))
    }
    // general-color
    const handleGeneralBgEnableChange = (e) => {
        setTemplateJson((prev) => ({
            ...prev,
            general: {
                ...prev.general,
                background: {
                    ...prev.general.background,
                    is_show_bg_color: e.target.checked
                }
            }
        }))
    }

    const handleGeneralBgColorChange = (value) => {
        setTemplateJson((prev) => ({
            ...prev,
            general: {
                ...prev.general,
                background: {
                    ...prev.general.background,
                    bg_color: value
                }
            }
        }))
    }

    const handleGeneralLabelColorChange = (value) => {
        setTemplateJson((prev) => ({
            ...prev,
            general: {
                ...prev.general,
                font: {
                    ...prev.general.font,
                    label_color: value
                }
            }
        }))
    }

    const handleGeneralFontColorChange = (value) => {
        setTemplateJson((prev) => ({
            ...prev,
            general: {
                ...prev.general,
                font: {
                    ...prev.general.font,
                    font_color: value
                }
            }
        }))
    }
    // color changes end
    const handleGeneralFontSizeChange = (e) => {
        setTemplateJson((prev) => ({
            ...prev,
            general: {
                ...prev.general,
                font: {
                    ...prev.general.font,
                    font_size: e.target.value
                }
            }
        }))
    }

    return (<>
        <Loader isVisible={templateData?.isLoading} />
        <Toast />
        <div className="position-relative pdf-temp-design">
            <div className="navbar sticky-top bg-light-subtle border-bottom border-light-subtle px-0 tb-header">
                <div className="ps-3 me-auto">
                    <span className="text-body fw-medium fs-5">
                        <i className="fa fa-arrow-left me-2 cursor-pointer"
                            onClick={() => navigate(Utils.getNavigationUrl(`print-template`))}></i>
                        {selectedTemplateData ? 'Edit Invoice Template' : 'Create Invoice Template'}
                    </span>
                </div>
                <div className="pe-3 ms-auto">
                    <div className="btn-group">
                        <button type="button" className="btn btn-outline-primary btn-blue rounded-2">
                            <TbRefresh size={16} />
                            <span className="ps-2">Refresh Preview</span>
                        </button>
                        {selectedTemplateData ?
                            <button type="button" className="btn btn-primary btn-blue rounded-2"
                                onClick={() => updateTemplate()}>
                                <span>Update</span>
                            </button>
                            :
                            <button type="button" className="btn btn-primary btn-blue rounded-2"
                                onClick={() => saveTemplate()}>
                                <span>Save</span>
                            </button>
                        }
                    </div>
                </div>
            </div>
            <div className="content-section">

                <div className="px-5 fw-medium hstack d-md-none mx-auto my-5 py-5">
                    <span>
                        This page best fit to view <span className="fw-semibold">above 768 viewport</span> only.
                    </span>
                </div>

                <div className="d-none d-md-flex h-100">
                    {/* Left side tab with settings forms */}
                    <div className="l-tab-view">
                        <div className="d-flex align-items-start h-100">
                            <div className="position-relative h-100" style={{ width: "94px" }}>
                                <div className="nav flex-column nav-pills small position-absolute w-100 h-100 overflow-y-auto border-end" id="v-pills-tab"
                                    role="tablist" aria-orientation="vertical">
                                    <button className="nav-link m-1 px-2 mb-0 border-bottom active" id="v-pills-1-tab"
                                        data-bs-toggle="pill" data-bs-target="#v-pills-1" type="button" role="tab"
                                        aria-controls="v-pills-1" aria-selected="true">
                                        General
                                    </button>
                                    <button className="nav-link m-1 mb-0 border-bottom px-2" id="v-pills-2-tab"
                                        data-bs-toggle="pill" data-bs-target="#v-pills-2" type="button" role="tab"
                                        aria-controls="v-pills-2" aria-selected="false">
                                        Header & Footer
                                    </button>
                                    <button className="nav-link m-1 mb-0 border-bottom px-2" id="v-pills-3-tab"
                                        data-bs-toggle="pill" data-bs-target="#v-pills-3" type="button" role="tab"
                                        aria-controls="v-pills-3" aria-selected="false">
                                        Transaction Details
                                    </button>
                                    <button className="nav-link m-1 mb-0 border-bottom px-2" id="v-pills-4-tab"
                                        data-bs-toggle="pill" data-bs-target="#v-pills-4" type="button" role="tab"
                                        aria-controls="v-pills-4" aria-selected="false">
                                        Table
                                    </button>
                                    <button className="nav-link m-1 mb-0 border-bottom px-2" id="v-pills-5-tab"
                                        data-bs-toggle="pill" data-bs-target="#v-pills-5" type="button" role="tab"
                                        aria-controls="v-pills-5" aria-selected="false">
                                        Total
                                    </button>
                                    <button className="nav-link m-1 mb-0 border-bottom px-2" id="v-pills-6-tab"
                                        data-bs-toggle="pill" data-bs-target="#v-pills-6" type="button" role="tab"
                                        aria-controls="v-pills-6" aria-selected="false">
                                        Other Details
                                    </button>
                                </div>
                            </div>
                            <div className="position-relative h-100" style={{ width: "386px" }}>
                                <div className="tab-content position-absolute w-100 h-100 overflow-y-auto border-end" id="v-pills-tabContent">
                                    <div className="tab-pane fade show active" id="v-pills-1" role="tabpanel"
                                        aria-labelledby="v-pills-1-tab" tabIndex="0">
                                        <div className="accordion accordion-flush bg-body-tertiary pb-2" id="generalAccordion">
                                            <div className="accordion-item mb-2">
                                                <h2 className="accordion-header">
                                                    <button className="accordion-button bg-transparent fw-medium" type="button" data-bs-toggle="collapse" data-bs-target="#generalCollapseOne" aria-expanded="true" aria-controls="generalCollapseOne">
                                                        Template Properties
                                                    </button>
                                                </h2>
                                                <div id="generalCollapseOne" className="accordion-collapse collapse show" data-bs-parent="#generalAccordion">
                                                    <div className="accordion-body">
                                                        <div className="mb-3">
                                                            <label htmlFor="templateName" className="form-label text-danger">Template Name *</label>
                                                            <input type="text" className="form-control" id="templateName"
                                                                name="template_name" defaultValue="Invoice Template"
                                                                placeholder="Enter template name"
                                                                value={templateName}
                                                                onChange={(e) => setTemplateName(e.target.value)}
                                                                disabled={selectedTemplateData ? true : false}
                                                            />
                                                        </div>
                                                        <div className="mb-3">
                                                            <div className="col-form-label">
                                                                <span>Paper Size</span>
                                                                <TooltipTrig id="paperSizeInfo"
                                                                    title="If you've used a Header or Footer image from the Gallery and you change the Paper Size, you need to remove and upload the image so that it fits the new paper size.">
                                                                    <span className="ps-1 text-gray">
                                                                        <TbInfoCircleFilled size={16} />
                                                                    </span>
                                                                </TooltipTrig>
                                                            </div>
                                                            <div className="form-check ps-0">
                                                                <div className="form-check form-check-inline">
                                                                    <input className="form-check-input cursor-pointer" type="radio" name="paperSizeOptions" id="paperSize1"
                                                                        value="A5" onChange={handlePaperSizeChange}
                                                                        checked={templateJson.general.template_property.paper_size === 'A5'} />
                                                                    <label className="form-check-label cursor-pointer" htmlFor="paperSize1">A5</label>
                                                                </div>
                                                                <div className="form-check form-check-inline">
                                                                    <input className="form-check-input cursor-pointer" type="radio" name="paperSizeOptions" id="paperSize2"
                                                                        value="A4" onChange={handlePaperSizeChange}
                                                                        checked={templateJson.general.template_property.paper_size === 'A4'} />
                                                                    <label className="form-check-label cursor-pointer" htmlFor="paperSize2">A4</label>
                                                                </div>
                                                                <div className="form-check form-check-inline">
                                                                    <input className="form-check-input cursor-pointer" type="radio" name="paperSizeOptions" id="paperSize3"
                                                                        value="Letter" onChange={handlePaperSizeChange}
                                                                        checked={templateJson.general.template_property.paper_size === 'Letter'} />
                                                                    <label className="form-check-label cursor-pointer" htmlFor="paperSize3">Letter</label>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="mb-3">
                                                            <div className="col-form-label">
                                                                <span>Orientation</span>
                                                            </div>
                                                            <div className="form-check ps-0">
                                                                <div className="form-check form-check-inline">
                                                                    <input className="form-check-input cursor-pointer" type="radio" name="orientationOptions" id="orientation1"
                                                                        value="Portrait" onChange={handleOrientationChange}
                                                                        checked={templateJson.general.template_property.orientation === 'Portrait'} />
                                                                    <label className="form-check-label cursor-pointer" htmlFor="orientation1">Portrait</label>
                                                                </div>
                                                                <div className="form-check form-check-inline">
                                                                    <input className="form-check-input cursor-pointer" type="radio" name="orientationOptions" id="orientation2"
                                                                        value="Landscape" onChange={handleOrientationChange}
                                                                        checked={templateJson.general.template_property.orientation === 'Landscape'} />
                                                                    <label className="form-check-label cursor-pointer" htmlFor="orientation2">Landscape</label>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="mb-3">
                                                            <div className="col-form-label">
                                                                Margins <span className="text-body-secondary">(in inches)</span>
                                                            </div>
                                                            <div className="d-flex gap-3">
                                                                <div>
                                                                    <label htmlFor="marginTop" className="form-label small">Top</label>
                                                                    <input type="text" className="form-control" id="marginTop"
                                                                        name="top" value={templateJson.general.template_property.margins.top}
                                                                        placeholder="Enter top margin"
                                                                        onChange={handleGeneralMarginChange} />
                                                                </div>
                                                                <div>
                                                                    <label htmlFor="marginBottom" className="form-label small">Bottom</label>
                                                                    <input type="text" className="form-control" id="marginBottom"
                                                                        name="bottom" value={templateJson.general.template_property.margins.bottom}
                                                                        placeholder="Enter bottom margin"
                                                                        onChange={handleGeneralMarginChange} />
                                                                </div>
                                                                <div>
                                                                    <label htmlFor="marginLeft" className="form-label small">Left</label>
                                                                    <input type="text" className="form-control" id="marginLeft"
                                                                        name="left" value={templateJson.general.template_property.margins.left}
                                                                        placeholder="Enter left margin"
                                                                        onChange={handleGeneralMarginChange} />
                                                                </div>
                                                                <div>
                                                                    <label htmlFor="marginRight" className="form-label small">Right</label>
                                                                    <input type="text" className="form-control" id="marginRight"
                                                                        name="right" value={templateJson.general.template_property.margins.right}
                                                                        placeholder="Enter right margin"
                                                                        onChange={handleGeneralMarginChange} />
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="mb-0 pt-2 d-none">
                                                            <div className="form-check form-check-inline">
                                                                <input type="checkbox" className="form-check-input cursor-pointer"
                                                                    id="payStubSetCheck"
                                                                    checked={templateJson.general.template_property.payment_stub.include_payment_stub}
                                                                    onChange={payStubSetChange} />
                                                                <label className="form-check-label fw-semibold cursor-pointer" htmlFor="payStubSetCheck">
                                                                    Include Payment Stub
                                                                    <TooltipTrig id="payStubInfo"
                                                                        title="Payment Stub is a detachable section that is added to an invoice to collect cash payments, especially when you send invoices via postal services.">
                                                                        <span className="ps-1 text-gray">
                                                                            <TbInfoCircleFilled size={16} />
                                                                        </span>
                                                                    </TooltipTrig>
                                                                </label>
                                                            </div>
                                                            {templateJson.general.template_property.payment_stub.include_payment_stub ? (
                                                                <>
                                                                    <div className="mb-3">
                                                                        <label htmlFor="payStub_label" className="form-label">Payment Stub</label>
                                                                        <input type="text" className="form-control"
                                                                            id="payStub_label"
                                                                            name="payStubLabel_name"
                                                                            value={templateJson.general.template_property.payment_stub.payment_stub}
                                                                            onChange={(e) => handlePayStubLabelChange(e)}
                                                                            placeholder={`Enter text`} />
                                                                    </div>
                                                                    <div className="mb-3">
                                                                        <label htmlFor="amtEnclose_label" className="form-label">Amount Enclosed</label>
                                                                        <input type="text" className="form-control"
                                                                            id="amtEnclose_label"
                                                                            name="amtEncloseLabel_name"
                                                                            value={templateJson.general.template_property.payment_stub.amount_enclosed}
                                                                            onChange={(e) => handleAmtEncloseLabelChange(e)}
                                                                            placeholder={`Enter text`} />
                                                                    </div>
                                                                    <div className="mb-3">
                                                                        <div className="col-form-label">
                                                                            <span>Payment Stub Position</span>
                                                                        </div>
                                                                        <div className="form-check ps-0">
                                                                            <div className="form-check">
                                                                                <input className="form-check-input cursor-pointer" type="radio" name="payStubPosOptions" id="payStubPos1"
                                                                                    value="firstPage" onChange={handlePayStubPosChange}
                                                                                    checked={templateJson.general.template_property.payment_stub.payment_stub_postion === 'firstPage'} />
                                                                                <label className="form-check-label cursor-pointer" htmlFor="payStubPos1">On the First Page</label>
                                                                            </div>
                                                                            <div className="form-check">
                                                                                <input className="form-check-input cursor-pointer" type="radio" name="payStubPosOptions" id="payStubPos2"
                                                                                    value="separatePage" onChange={handlePayStubPosChange}
                                                                                    checked={templateJson.general.template_property.payment_stub.payment_stub_postion === 'separatePage'} />
                                                                                <label className="form-check-label cursor-pointer" htmlFor="payStubPos2">On a Seperate Page</label>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </>
                                                            ) : ('')}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="accordion-item mb-2">
                                                <h2 className="accordion-header">
                                                    <button className="accordion-button collapsed bg-transparent fw-medium" type="button" data-bs-toggle="collapse" data-bs-target="#generalCollapseTwo" aria-expanded="false" aria-controls="generalCollapseTwo">
                                                        Font
                                                    </button>
                                                </h2>
                                                <div id="generalCollapseTwo" className="accordion-collapse collapse" data-bs-parent="#generalAccordion">
                                                    <div className="accordion-body">
                                                        <div className="mb-3">
                                                            <label htmlFor="pdfFont" className="col-form-label">PDF Font</label>
                                                            <div className="dropdown custom-dropdown w-100">
                                                                <button type="button" id="pdfFont" data-bs-toggle="dropdown" aria-expanded="false"
                                                                    className="btn btn-link border dropdown-toggle with-arrow text-decoration-none text-dark w-100 justify-content-start">
                                                                    {templateJson.general.font.pdf_font}
                                                                </button>
                                                                <ul className="dropdown-menu w-100 max-h-200px">
                                                                    {fonts.map((font) => (
                                                                        <li key={font.name}>
                                                                            <button
                                                                                className={`dropdown-item rounded-0 ps-3 mb-2 ${templateJson.general.font.pdf_font === font.name ? 'active' : ''}`}
                                                                                type="button"
                                                                                onClick={() => handleFontFamilyChange(font.name, font.description)}
                                                                            >
                                                                                <span className="d-block ps-3">
                                                                                    <span className="fw-medium">{font.name}</span> <br />
                                                                                    <span className="fw-light small">{font.description}</span>
                                                                                </span>
                                                                            </button>
                                                                        </li>
                                                                    ))}
                                                                </ul>
                                                            </div>
                                                            <div className="d-block text-secondary small mt-2">
                                                                {fonts.find((font) => font.name === templateJson.general.font.pdf_font)?.description}
                                                            </div>
                                                        </div>
                                                        <div className="mb-3">
                                                            <label htmlFor="label_color" className="col-form-label">Label Color</label>
                                                            <ColorPicker
                                                                id="label_color"
                                                                color={templateJson.general.font.label_color}
                                                                // onColorChange={setAllLabelColor}
                                                                onColorChange={handleGeneralLabelColorChange}
                                                            />
                                                        </div>
                                                        <div className="row row-cols-2">
                                                            <div className="col">
                                                                <label htmlFor="font_color" className="col-form-label">Font Color</label>
                                                                <ColorPicker
                                                                    id="font_color"
                                                                    color={templateJson.general.font.font_color}
                                                                    // onColorChange={setAllFontColor}
                                                                    onColorChange={handleGeneralFontColorChange}
                                                                />
                                                            </div>
                                                            <div className="col">
                                                                <label htmlFor="baseFontSize" className="col-form-label">Font Size</label>
                                                                <div className="input-group mb-0">
                                                                    <input type="text" className="form-control" id="baseFontSize"
                                                                        name="base_font_size" value={templateJson.general.font.font_size}
                                                                        placeholder="Enter font size"
                                                                        aria-label="base font size"
                                                                        aria-describedby="base-font-size-1"
                                                                        // onChange={e => setAllFontSize(e.target.value)}
                                                                        onChange={handleGeneralFontSizeChange}
                                                                    />
                                                                    <span className="input-group-text" id="base-font-size-1">pt</span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="accordion-item">
                                                <h2 className="accordion-header">
                                                    <button className="accordion-button collapsed bg-transparent fw-medium" type="button" data-bs-toggle="collapse" data-bs-target="#generalCollapseThree" aria-expanded="false" aria-controls="generalCollapseThree">
                                                        Background
                                                    </button>
                                                </h2>
                                                <div id="generalCollapseThree" className="accordion-collapse collapse" data-bs-parent="#generalAccordion">
                                                    <div className="accordion-body">
                                                        <div className="mb-3">
                                                            <label htmlFor="pdfBgImg" className="col-form-label fw-medium">Background Image</label>
                                                            {!templateJson.general.background.bg_image ? (
                                                                <>
                                                                    <div className="choose-img">
                                                                        <span className="btn btn-outline-secondary btn-file d-inline-flex py-2 mt-2">
                                                                            Browse From Desktop
                                                                            <input
                                                                                type="file"
                                                                                accept="image/*"
                                                                                id="pdfBgImg"
                                                                                onChange={tempBGImgChange} // Handle the file selection
                                                                            />
                                                                        </span>
                                                                    </div>
                                                                    {tempBgImgError && (
                                                                        <div style={{ color: "red", marginTop: "8px" }}>
                                                                            <small>{tempBgImgError}</small>
                                                                        </div>
                                                                    )}
                                                                </>
                                                            ) : (
                                                                <>
                                                                    <div className="selected-img">
                                                                        <img
                                                                            src={templateJson.general.background.bg_image.fileimage}
                                                                            alt="pdf-bg-img"
                                                                            style={{ height: "212px", width: "162px", border: "1px solid #dddddd" }}
                                                                        />
                                                                        <span className="d-block link-danger mt-2" role="button" onClick={removeTempImage}>
                                                                            Remove
                                                                        </span>
                                                                    </div>
                                                                </>
                                                            )}
                                                        </div>
                                                        <div className="mb-3">
                                                            <label htmlFor="pdfBgImgPos" className="col-form-label">Image Position</label>
                                                            <select className="form-select" id='pdfBgImgPos'
                                                                name='selectPdfBgImgPos' value={templateJson.general.background.image_position}
                                                                // onChange={e => setSelectedTempBgPos(e.target.value)}
                                                                onChange={handleGeneralBgPosition}
                                                            >
                                                                <option value="top left">Top Left</option>
                                                                <option value="top center">Top Center</option>
                                                                <option value="top right">Top Right</option>
                                                                <option value="center left">Center Left</option>
                                                                <option value="center center">Center Center</option>
                                                                <option value="center right">Center Right</option>
                                                                <option value="bottom left">Bottom Left</option>
                                                                <option value="bottom center">Bottom Center</option>
                                                                <option value="bottom right">Bottom Right</option>
                                                            </select>
                                                        </div>
                                                        <div>
                                                            <label htmlFor="background_color" className="col-form-label fw-medium">Background Color</label>
                                                            <div className="d-flex align-items-center justify-content-between">
                                                                <div className="form-check form-check-inline">
                                                                    <input
                                                                        type="checkbox"
                                                                        className="form-check-input"
                                                                        id="temp_bgColorCheckbox"
                                                                        checked={templateJson.general.background.is_show_bg_color}
                                                                        // onChange={(e) => tempBgColorCheckbox(e, setIsTempBgColorEnabled)}
                                                                        onChange={handleGeneralBgEnableChange}
                                                                    />
                                                                </div>
                                                                <ColorPicker
                                                                    id="background_color"
                                                                    color={templateJson.general.background.bg_color}
                                                                    onColorChange={handleGeneralBgColorChange}
                                                                    disabled={!templateJson.general.background.is_show_bg_color}
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="tab-pane fade" id="v-pills-2" role="tabpanel"
                                        aria-labelledby="v-pills-2-tab" tabIndex="0">
                                        <div className="accordion accordion-flush bg-body-tertiary pb-2" id="hAfAccordion">
                                            <div className="accordion-item mb-2">
                                                <h2 className="accordion-header">
                                                    <button className="accordion-button bg-transparent fw-medium" type="button" data-bs-toggle="collapse" data-bs-target="#hAfCollapseOne" aria-expanded="true" aria-controls="hAfCollapseOne">
                                                        Header
                                                    </button>
                                                </h2>
                                                <div id="hAfCollapseOne" className="accordion-collapse collapse show" data-bs-parent="#hAfAccordion">
                                                    <div className="accordion-body">
                                                        <div className="mb-3">
                                                            <label htmlFor="headerBgImg" className="col-form-label fw-medium">Background Image</label>
                                                            {!templateJson.header.bg_image ? (
                                                                <>
                                                                    <div className="choose-img">
                                                                        <span className="btn btn-outline-secondary btn-file d-inline-flex py-2 mt-2">
                                                                            Browse From Desktop
                                                                            <input
                                                                                type="file"
                                                                                accept="image/*"
                                                                                id="headerBgImg"
                                                                                onChange={headerBGImgChange}
                                                                            />
                                                                        </span>
                                                                    </div>
                                                                    {headerBgImgError && (
                                                                        <div style={{ color: "red", marginTop: "8px" }}>
                                                                            <small>{headerBgImgError}</small>
                                                                        </div>
                                                                    )}
                                                                </>
                                                            ) : (
                                                                <>
                                                                    <div className="selected-img d-flex justify-content-between">
                                                                        <img
                                                                            src={templateJson.header.bg_image.fileimage}
                                                                            alt="header-bg-img"
                                                                            style={{ height: "31px", width: "232px", border: "1px solid #dddddd" }}
                                                                        />
                                                                        <button type="button" onClick={removeHeaderImage}
                                                                            className="btn btn-outline-light text-danger px-2 py-1"
                                                                            style={{ textDecoration: "none", color: "red" }}>
                                                                            <Trash size={16} />
                                                                        </button>
                                                                    </div>
                                                                </>
                                                            )}
                                                        </div>
                                                        <div className="mb-3">
                                                            <label htmlFor="headerBgImgPos" className="col-form-label">Image Position</label>
                                                            <select className="form-select" id='headerBgImgPos'
                                                                name='selectHeaderBgImgPos' value={templateJson.header.img_position}
                                                                onChange={e => setHeaderBgPos(e)}>
                                                                <option value="top left">Top Left</option>
                                                                <option value="top center">Top Center</option>
                                                                <option value="top right">Top Right</option>
                                                                <option value="center left">Center Left</option>
                                                                <option value="center center">Center Center</option>
                                                                <option value="center right">Center Right</option>
                                                                <option value="bottom left">Bottom Left</option>
                                                                <option value="bottom center">Bottom Center</option>
                                                                <option value="bottom right">Bottom Right</option>
                                                            </select>
                                                        </div>
                                                        <div className="mb-3">
                                                            <label htmlFor="h_bg_color" className="col-form-label fw-medium">Background Color</label>
                                                            <div className="d-flex align-items-center justify-content-between">
                                                                <div className="form-check form-check-inline">
                                                                    <input
                                                                        type="checkbox"
                                                                        className="form-check-input"
                                                                        id="header_bgColorCheckbox"
                                                                        checked={templateJson.header.is_show_bg_color}
                                                                        onChange={(e) => headerBgColorCheckbox(e)}
                                                                    />
                                                                </div>
                                                                <ColorPicker
                                                                    id="h_bg_color"
                                                                    color={templateJson.header.bg_color}
                                                                    onColorChange={handleHeaderBgColorChange}
                                                                    disabled={!templateJson.header.is_show_bg_color}
                                                                />
                                                            </div>
                                                        </div>
                                                        <div className="mb-3">
                                                            <button type="button" className="btn btn-outline-secondary rounded-2 w-100"
                                                                onClick={() => setshowQTHeaderContent(true)}>
                                                                <Settings size={16} /> <span className="ps-2">Customize your header content</span>
                                                            </button>
                                                        </div>
                                                        <div className="mb-3">
                                                            <div className="form-check">
                                                                <input className="form-check-input cursor-pointer" type="checkbox" id="hFPcheckBox"
                                                                    checked={templateJson.header.is_apply_first_page_only}
                                                                    onChange={headerFpSettingEnable} />
                                                                <label className="form-check-label cursor-pointer" htmlFor="hFPcheckBox">
                                                                    Apply to first page only
                                                                </label>
                                                            </div>
                                                            <div className={`${templateJson.header.is_apply_first_page_only ? "d-block" : "d-none"}`}>
                                                                <div className={`row row-cols-2 mb-3 align-items-center`}>
                                                                    <label htmlFor="hFpHeight" className="col-form-label">Header height for first page</label>
                                                                    <div className="col">
                                                                        <div className="input-group mb-0">
                                                                            <input type="text" className="form-control" id="hFpHeight"
                                                                                name="base_font_size" value={templateJson.header.header_first_page}
                                                                                placeholder="Enter top margin"
                                                                                aria-label="fP Top margin"
                                                                                aria-describedby="fp-top-margin"
                                                                                // onChange={e => setHeaderFpHeight(e.target.value)} 
                                                                                onChange={(e) => setTemplateJson((prev) => ({
                                                                                    ...prev,
                                                                                    header: {
                                                                                        ...prev.header,
                                                                                        header_first_page: e.target.value
                                                                                    }
                                                                                }))}
                                                                            />
                                                                            <span className="input-group-text" id="fp-top-margin">in</span>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div className="mb-3 d-none">
                                                                    <button type="button" className="btn btn-outline-secondary rounded-2 w-100 px-1"
                                                                        onClick={() => handleHaFmodalShow('Customize your header content')}>
                                                                        <Settings size={14} /> <span className="ps-1 small">Customize your header content for other pages</span>
                                                                    </button>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="accordion-item mb-2">
                                                <h2 className="accordion-header">
                                                    <button className="accordion-button bg-transparent fw-medium" type="button" data-bs-toggle="collapse" data-bs-target="#hAfCollapseTwo" aria-expanded="true" aria-controls="hAfCollapseTwo">
                                                        Footer
                                                    </button>
                                                </h2>
                                                <div id="hAfCollapseTwo" className="accordion-collapse collapse" data-bs-parent="#hAfAccordion">
                                                    <div className="accordion-body">
                                                        <div className="mb-3 row row-cols-2 justify-content-between">
                                                            <label htmlFor="footFontSize" className="col-auto col-form-label">Font Size</label>
                                                            <div className="col-7">
                                                                <div className="input-group mb-0">
                                                                    <input type="text" className="form-control" id="footFontSize"
                                                                        name="base_font_size" value={templateJson.footer.font_size}
                                                                        placeholder="Enter font size"
                                                                        aria-label="base font size"
                                                                        aria-describedby="foot-fs-1"
                                                                        // onChange={e => setFootFontSize(e.target.value)}
                                                                        onChange={(e) => setTemplateJson((prev) => ({
                                                                            ...prev,
                                                                            footer: {
                                                                                ...prev.footer,
                                                                                font_size: e.target.value
                                                                            }
                                                                        }))}
                                                                    />
                                                                    <span className="input-group-text" id="foot-fs-1">pt</span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="mb-3 row row-cols-2 justify-content-between">
                                                            <label htmlFor="foot_font_color" className="col-auto col-form-label">Font Color</label>
                                                            <div className="col-7">
                                                                <ColorPicker
                                                                    id="foot_font_color"
                                                                    color={templateJson.footer.font_color}
                                                                    onColorChange={handleFooterFontColorChange}
                                                                />
                                                            </div>
                                                        </div>
                                                        <div className="mb-3">
                                                            <label htmlFor="footBgImg" className="col-form-label fw-medium">Background Image</label>
                                                            {!templateJson.footer.bg_image ? (
                                                                <>
                                                                    <div className="choose-img">
                                                                        <span className="btn btn-outline-secondary btn-file d-inline-flex py-2 mt-2">
                                                                            Browse From Desktop
                                                                            <input
                                                                                type="file"
                                                                                accept="image/*"
                                                                                id="footBgImg"
                                                                                onChange={footBGImgChange}
                                                                            />
                                                                        </span>
                                                                    </div>
                                                                    {footBgImgError && (
                                                                        <div style={{ color: "red", marginTop: "8px" }}>
                                                                            <small>{footBgImgError}</small>
                                                                        </div>
                                                                    )}
                                                                </>
                                                            ) : (
                                                                <>
                                                                    <div className="selected-img d-flex justify-content-between">
                                                                        <img
                                                                            src={templateJson.footer.bg_image.fileimage}
                                                                            alt="foot-bg-img"
                                                                            style={{ height: "31px", width: "232px", border: "1px solid #dddddd" }}
                                                                        />
                                                                        <button type="button" onClick={removeFootImage}
                                                                            className="btn btn-outline-light text-danger px-2 py-1"
                                                                            style={{ textDecoration: "none", color: "red" }}>
                                                                            <Trash size={16} />
                                                                        </button>
                                                                    </div>
                                                                </>
                                                            )}
                                                        </div>
                                                        <div className="mb-3">
                                                            <label htmlFor="footBgImgPos" className="col-form-label">Image Position</label>
                                                            <select className="form-select" id='footBgImgPos'
                                                                name='selectFootBgImgPos' value={templateJson.footer.img_position}
                                                                // onChange={e => setSelectedFootBgPos(e.target.value)}
                                                                onChange={(e) => setTemplateJson((prev) => ({
                                                                    ...prev,
                                                                    footer: {
                                                                        ...prev.footer,
                                                                        img_position: e.target.value
                                                                    }
                                                                }))}
                                                            >
                                                                <option value="top left">Top Left</option>
                                                                <option value="top center">Top Center</option>
                                                                <option value="top right">Top Right</option>
                                                                <option value="center left">Center Left</option>
                                                                <option value="center center">Center Center</option>
                                                                <option value="center right">Center Right</option>
                                                                <option value="bottom left">Bottom Left</option>
                                                                <option value="bottom center">Bottom Center</option>
                                                                <option value="bottom right">Bottom Right</option>
                                                            </select>
                                                        </div>
                                                        <div className="mb-3">
                                                            <label htmlFor="f_bg_color" className="col-form-label fw-medium">Background Color</label>
                                                            <div className="d-flex align-items-center justify-content-between">
                                                                <div className="form-check form-check-inline">
                                                                    <input
                                                                        type="checkbox"
                                                                        className="form-check-input"
                                                                        id="foot_bgColorCheckbox"
                                                                        checked={templateJson.footer.is_show_bg_color}
                                                                        // onChange={(e) => footBgColorCheckbox(e, setIsFootBgColorEnabled)}
                                                                        onChange={footBgColorCheckbox}
                                                                    />
                                                                </div>
                                                                <ColorPicker
                                                                    id="f_bg_color"
                                                                    color={templateJson.footer.bg_color}
                                                                    onColorChange={handleFooterBgColorChange}
                                                                    disabled={!templateJson.footer.is_show_bg_color}
                                                                />
                                                            </div>
                                                        </div>
                                                        <div className="mb-3">
                                                            <div className="form-check form-check-inline">
                                                                <input type="checkbox" className="form-check-input cursor-pointer" id="footPageNumCheck" />
                                                                <label className="form-check-label cursor-pointer" htmlFor="footPageNumCheck"
                                                                    checked={templateJson.footer.is_show_page_no}
                                                                    onChange={(e) => setTemplateJson((prev) => ({
                                                                        ...prev,
                                                                        footer: {
                                                                            ...prev.footer,
                                                                            is_show_page_no: e.target.checked
                                                                        }
                                                                    }))}
                                                                >Show Page Number</label>
                                                            </div>
                                                        </div>
                                                        <div className="mb-3">
                                                            <button type="button" className="btn btn-outline-secondary rounded-2 w-100"
                                                                onClick={() => setshowQTFooterContent(true)}>
                                                                <Settings size={16} /> <span className="ps-2">Customize your footer content</span>
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="tab-pane fade" id="v-pills-3" role="tabpanel"
                                        aria-labelledby="v-pills-3-tab" tabIndex="0">
                                        <div className="accordion accordion-flush bg-body-tertiary pb-2" id="tdAccordion">
                                            <div className="accordion-item mb-2">
                                                <h2 className="accordion-header">
                                                    <button className="accordion-button bg-transparent fw-medium" type="button" data-bs-toggle="collapse" data-bs-target="#tdCollapseOne" aria-expanded="true" aria-controls="tdCollapseOne">
                                                        Organization Details
                                                    </button>
                                                </h2>
                                                <div id="tdCollapseOne" className="accordion-collapse collapse show" data-bs-parent="#tdAccordion">
                                                    <div className="accordion-body">
                                                        <div className="mb-3">
                                                            <div className="form-check form-check-inline">
                                                                <input type="checkbox" className="form-check-input cursor-pointer" id="orgLogoShowCheck"
                                                                    checked={templateJson.organization.is_show_org_logo}
                                                                    onChange={tDOrgImgSettingEnable} />
                                                                <label className="form-check-label cursor-pointer" htmlFor="orgLogoShowCheck">Show Organization Logo</label>
                                                            </div>
                                                        </div>
                                                        {/* <div className={`${templateJson.organization.is_show_org_logo ? "d-block mb-3" : "d-none"}`}>
                                                            {!orgImg ? (
                                                                <>
                                                                    <div className="choose-img">
                                                                        <span className="file-upload-box file-upload-small mt-2">
                                                                            <span className="hstack opacity-75">
                                                                                <TbUpload size={16} />
                                                                                <span className="ps-2 text-center fs-13">Upload your logo file</span>
                                                                            </span>
                                                                            <input
                                                                                type="file"
                                                                                accept="image/gif,image/jpeg,image/png,image/bmp"
                                                                                id="orgImg"
                                                                                className="file-upload-input"
                                                                                onChange={orgImgChange}
                                                                            />
                                                                        </span>
                                                                    </div>
                                                                    {orgImgError && (
                                                                        <div style={{ color: "red", marginTop: "8px" }}>
                                                                            <small>{orgImgError}</small>
                                                                        </div>
                                                                    )}
                                                                </>
                                                            ) : (
                                                                <>
                                                                    <div className="org-img-preview rounded-2 p-2" style={{ maxHeight: "86px", border: "1px dashed #dddddd" }}>
                                                                        <img
                                                                            src={orgImg.fileimage}
                                                                            alt="org-img"
                                                                            className="img-fluid"
                                                                            style={{ maxHeight: "70px" }}
                                                                        />
                                                                    </div>
                                                                    <div className="text-muted text-opacity-75">
                                                                        <TbInfoCircleFilled />
                                                                        <span className="fst-italic small">You can change the logo in Organization Profile.</span>
                                                                    </div>
                                                                </>
                                                            )}
                                                        </div> */}
                                                        <div className="mb-3">
                                                            <div className="form-check form-check-inline">
                                                                <input type="checkbox" className="form-check-input cursor-pointer" id="orgNameShowCheck"
                                                                    checked={templateJson.organization.is_show_org_name}
                                                                    onChange={tDOrgNameSettingEnable} />
                                                                <label className="form-check-label cursor-pointer" htmlFor="orgNameShowCheck">Show Organization Name</label>
                                                            </div>
                                                        </div>
                                                        <div className="row row-cols-2 mb-3">
                                                            <div className="col">
                                                                <label htmlFor="orgName_f_color" className="col-form-label">Font Color</label>
                                                                <ColorPicker
                                                                    id="orgName_f_color"
                                                                    color={templateJson.organization.font_color}
                                                                    onColorChange={handleTransactionOrgFontColorChange}
                                                                />
                                                            </div>
                                                            <div className="col">
                                                                <label htmlFor="orgNameFSize" className="col-form-label">Font Size</label>
                                                                <div className="input-group mb-0">
                                                                    <input type="text" className="form-control" id="orgNameFSize"
                                                                        name="orgName_font_size" value={templateJson.organization.font_size}
                                                                        placeholder="Enter font size"
                                                                        aria-label="org name font size"
                                                                        aria-describedby="orgName-font-size-1"
                                                                        // onChange={e => setOrgNameFontSize(e.target.value)} 
                                                                        onChange={(e) => setTemplateJson((prev) => ({
                                                                            ...prev,
                                                                            organization: {
                                                                                ...prev.organization,
                                                                                font_size: e.target.value
                                                                            }
                                                                        }))}
                                                                    />
                                                                    <span className="input-group-text" id="orgName-font-size-1">pt</span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="mb-3">
                                                            <div className="form-check form-check-inline">
                                                                <input type="checkbox" className="form-check-input cursor-pointer" id="orgAddressCheck"
                                                                    checked={templateJson.organization.is_show_org_address}
                                                                    onChange={tDOrgAddressSettingEnable} />
                                                                <label className="form-check-label cursor-pointer" htmlFor="orgAddressCheck">Show Organization Address</label>
                                                            </div>
                                                        </div>
                                                        <div className="mb-0">
                                                            <button type="button" className="btn btn-outline-secondary rounded-2 w-100"
                                                                onClick={() => setshowQTOrganizationContent(true)}>
                                                                <Settings size={16} /> <span className="ps-2 small">Organization Address Format (Custom)</span>
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="accordion-item mb-2">
                                                <h2 className="accordion-header">
                                                    <button className="accordion-button bg-transparent fw-medium" type="button" data-bs-toggle="collapse" data-bs-target="#tdCollapseTwo" aria-expanded="false" aria-controls="tdCollapseTwo">
                                                        Customer Details
                                                    </button>
                                                </h2>
                                                <div id="tdCollapseTwo" className="accordion-collapse collapse" data-bs-parent="#tdAccordion">
                                                    <div className="accordion-body">
                                                        <div className="mb-3">
                                                            <div className="fw-semibold mb-2">Customer Name</div>
                                                            <div className="row row-cols-2 mb-3">
                                                                <div className="col">
                                                                    <label htmlFor="cusName_f_color" className="col-form-label">Font Color</label>
                                                                    <ColorPicker
                                                                        id="cusName_f_color"
                                                                        color={templateJson.customer.font_color}
                                                                        onColorChange={handleTransactionCusFontColorChange}
                                                                    />
                                                                </div>
                                                                <div className="col">
                                                                    <label htmlFor="cusNameFSize" className="col-form-label">Font Size</label>
                                                                    <div className="input-group mb-0">
                                                                        <input type="text" className="form-control" id="cusNameFSize"
                                                                            name="cusName_f_size" value={templateJson.customer.font_size}
                                                                            placeholder="Enter font size"
                                                                            aria-label="cus name font size"
                                                                            aria-describedby="cusName-font-size-1"
                                                                            // onChange={e => setCusNameFontSize(e.target.value)} 
                                                                            onChange={(e) => setTemplateJson((prev) => ({
                                                                                ...prev,
                                                                                customer: {
                                                                                    ...prev.customer,
                                                                                    font_size: e.target.value
                                                                                }
                                                                            }))}
                                                                        />
                                                                        <span className="input-group-text" id="cusName-font-size-1">pt</span>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="mb-2">
                                                            <div className="form-check">
                                                                <input type="checkbox"
                                                                    className="form-check-input cursor-pointer"
                                                                    id="billToCheck"
                                                                    checked={templateJson.customer.is_bill_to}
                                                                    onChange={(e) => billToCheckbox(e)} />
                                                                <label className="form-check-label cursor-pointer" htmlFor="billToCheck">Bill To</label>
                                                            </div>
                                                        </div>
                                                        <div className="mb-2">
                                                            <input type="text" className="form-control" id="billToInput"
                                                                name="billTo_name"
                                                                placeholder="Enter bill header"
                                                                value={templateJson.customer.bill_to_title}
                                                                onChange={(e) => handleBillToLabelChange(e)}
                                                                disabled={!templateJson.customer.is_bill_to} />
                                                        </div>
                                                        <div className="mb-3">
                                                            <Button variant="link" className="p-0 text-decoration-none"
                                                                // onClick={() => setshowQTBillToContent(true)}
                                                                // disabled={!templateJson.customer.is_bill_to}
                                                                onClick={() => setshowQTBillToContent(true)}
                                                            >
                                                                <small>Billing Address Format</small>
                                                            </Button>
                                                        </div>
                                                        <div className="mb-2">
                                                            <div className="form-check">
                                                                <input type="checkbox"
                                                                    className="form-check-input cursor-pointer"
                                                                    id="shipToCheck"
                                                                    checked={templateJson.customer.is_ship_to}
                                                                    onChange={(e) => shipToCheckbox(e, setIsShipToEnabled)} />
                                                                <label className="form-check-label cursor-pointer" htmlFor="shipToCheck">Ship To</label>
                                                            </div>
                                                        </div>
                                                        <div className="mb-2">
                                                            <input type="text" className="form-control" id="shipToInput"
                                                                name="shipTo_name"
                                                                placeholder="Enter ship header"
                                                                value={templateJson.customer.ship_to_title}
                                                                onChange={(e) => handleShipToLabelChange(e)}
                                                                disabled={!templateJson.customer.is_ship_to} />
                                                        </div>
                                                        <div className="mb-0">
                                                            <Button variant="link" className="p-0 text-decoration-none"
                                                                // onClick={() => setshowQTShipToContent(true)}
                                                                // disabled={!templateJson.customer.is_ship_to}
                                                                onClick={() => setshowQTShipToContent(true)}
                                                            >
                                                                <small>Shipping Address Format</small>
                                                            </Button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="accordion-item mb-2">
                                                <h2 className="accordion-header">
                                                    <button className="accordion-button bg-transparent fw-medium" type="button" data-bs-toggle="collapse" data-bs-target="#tdCollapseThree" aria-expanded="false" aria-controls="tdCollapseThree">
                                                        Document Details
                                                    </button>
                                                </h2>
                                                <div id="tdCollapseThree" className="accordion-collapse collapse" data-bs-parent="#tdAccordion">
                                                    <div className="accordion-body">
                                                        <div className="mb-2">
                                                            <div className="form-check">
                                                                <input type="checkbox"
                                                                    className="form-check-input cursor-pointer"
                                                                    id="docTitleCheck"
                                                                    checked={templateJson.document.is_show_document_title}
                                                                    onChange={(e) => docTitleCheckbox(e)} />
                                                                <label className="form-check-label cursor-pointer" htmlFor="docTitleCheck">Show Document Title</label>
                                                            </div>
                                                        </div>
                                                        <div className="mb-2">
                                                            <input type="text" className="form-control" id="docTitleInput"
                                                                name="docTitle_name"
                                                                placeholder="Enter document title"
                                                                value={templateJson.document.document_title}
                                                                onChange={(e) => handleDocTitleLabelChange(e)}
                                                                disabled={!templateJson.document.is_show_document_title} />
                                                        </div>
                                                        <div className="fw-semibold mt-3">Document Title</div>
                                                        <div className="row row-cols-2 mb-3">
                                                            <div className="col">
                                                                <label htmlFor="docTitle_f_color" className="col-form-label">Font Color</label>
                                                                <ColorPicker
                                                                    id="docTitle_f_color"
                                                                    color={templateJson.document.font_color}
                                                                    onColorChange={handleTransactionDOcFontColorChange}
                                                                />
                                                            </div>
                                                            <div className="col">
                                                                <label htmlFor="docTitleFSize" className="col-form-label">Font Size</label>
                                                                <div className="input-group mb-0">
                                                                    <input type="text" className="form-control" id="docTitleFSize"
                                                                        name="docTitle_f_size" value={templateJson.document.font_size}
                                                                        placeholder="Enter font size"
                                                                        aria-label="doc title font size"
                                                                        aria-describedby="docTitle-font-size-1"
                                                                        // onChange={e => setDocTitleFontSize(e.target.value)} 
                                                                        onChange={(e) => setTemplateJson((prev) => ({
                                                                            ...prev,
                                                                            document: {
                                                                                ...prev.document,
                                                                                font_size: e.target.value
                                                                            }
                                                                        }))}
                                                                    />
                                                                    <span className="input-group-text" id="docTitle-font-size-1">pt</span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        {/* <div className="row row-cols-2 mb-3">
                                                            <div className="col">
                                                                <label htmlFor="docPhoneLabel" className="col-form-label">Phone</label>
                                                                <input type="text" className="form-control" id="docPhoneLabel"
                                                                    name="docPhone_label"
                                                                    placeholder="Enter phone label"
                                                                    defaultValue="Phone" />
                                                            </div>
                                                            <div className="col">
                                                                <label htmlFor="docFaxLabel" className="col-form-label">Fax Number</label>
                                                                <input type="text" className="form-control" id="docFaxLabel"
                                                                    name="docFax_label"
                                                                    placeholder="Enter fax label"
                                                                    defaultValue="Fax" />
                                                            </div>
                                                        </div> */}
                                                        <div className="fw-semibold pt-3 mb-3">Document Information</div>
                                                        {checkboxes.map((checkbox) => (
                                                            <SingleTextCheckbox
                                                                key={checkbox.id}
                                                                checkboxId={checkbox.id}
                                                                isCheckboxDisabled={checkbox.id === 'subjectCheckbox'}
                                                                checkboxLabel={checkbox.label}
                                                                isCheckboxEnabled={checkbox.isChecked}
                                                                inputId={`${checkbox.id}Input`}
                                                                inputValue={checkbox.value}
                                                                onValueChange={(value) => handleValueChange(checkbox.id, value)}
                                                                disabled={false}
                                                                onCheckboxChange={(checked) => handleCheckboxChange(checkbox.id, checked)}
                                                            />
                                                        ))}
                                                        <div className="mb-2">
                                                            <div className="form-check">
                                                                <input type="checkbox"
                                                                    className="form-check-input cursor-pointer"
                                                                    id="statusStampCheck"
                                                                    checked={templateJson.document.is_show_status_stamp}
                                                                    onChange={(e) => statusStampCheckbox(e)} />
                                                                <label className="form-check-label cursor-pointer" htmlFor="statusStampCheck">Show Status Stamp</label>
                                                            </div>
                                                        </div>
                                                        <div className="mb-0">
                                                            <button type="button" className="btn btn-outline-secondary rounded-2 w-100"
                                                                onClick={() => setshowQTAttentionContent(true)}>
                                                                <Settings size={16} /> <span className="ps-2">Add Attention Content</span>
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="tab-pane fade" id="v-pills-4" role="tabpanel"
                                        aria-labelledby="v-pills-4-tab" tabIndex="0">
                                        <div className="accordion accordion-flush bg-body-tertiary pb-2" id="tAccordion">
                                            <div className="accordion-item mb-2">
                                                <h2 className="accordion-header">
                                                    <button className="accordion-button bg-transparent fw-medium" type="button" data-bs-toggle="collapse" data-bs-target="#tCollapseOne" aria-expanded="true" aria-controls="tCollapseOne">
                                                        Labels Section
                                                    </button>
                                                </h2>
                                                <div id="tCollapseOne" className="accordion-collapse collapse show" data-bs-parent="#tAccordion">
                                                    <div className="accordion-body">
                                                        <div className="fs-6 pb-3">Table Properties</div>
                                                        <div className="row align-items-center py-1 border-top border-bottom mb-3">
                                                            <div className="col-lg-4">
                                                                <small className="fw-medium text-uppercase text-secondary text-opacity-75">Field</small>
                                                            </div>
                                                            <div className="col-lg-3">
                                                                <small className="fw-medium text-uppercase text-secondary text-opacity-75">Width(%)</small>
                                                            </div>
                                                            <div className="col-lg-5">
                                                                <small className="fw-medium text-uppercase text-secondary text-opacity-75">Label</small>
                                                            </div>
                                                        </div>
                                                        <div className="row align-items-center mb-3">
                                                            <div className="col-lg-4">
                                                                <div className="form-check">
                                                                    <input type="checkbox"
                                                                        className="form-check-input cursor-pointer"
                                                                        id="lineItemNumCheck"
                                                                        checked={templateJson.table.labels_section.table_properties.line_item_number.is_show_line_item_number}
                                                                        onChange={(e) => lineItemNumCheckbox(e)} />
                                                                    <label className="form-check-label cursor-pointer" htmlFor="lineItemNumCheck">Line Item Number</label>
                                                                </div>
                                                            </div>
                                                            <div className="col-lg-3 px-0">
                                                                <input type="number" className="form-control" id="lineNumWidthInput"
                                                                    name="lineNumWidth_name"
                                                                    placeholder="Enter width"
                                                                    value={templateJson.table.labels_section.table_properties.line_item_number.width}
                                                                    onChange={(e) => handleLineNumWidthChange(e)}
                                                                    disabled={!templateJson.table.labels_section.table_properties.line_item_number.is_show_line_item_number} />
                                                            </div>
                                                            <div className="col-lg-5">
                                                                <input type="text" className="form-control" id="lineNumLabelInput"
                                                                    name="lineNumLabel_name"
                                                                    placeholder="Enter Label"
                                                                    value={templateJson.table.labels_section.table_properties.line_item_number.label}
                                                                    onChange={(e) => handleLineNumLabelChange(e)}
                                                                    disabled={!templateJson.table.labels_section.table_properties.line_item_number.is_show_line_item_number} />
                                                            </div>
                                                        </div>
                                                        <div className="row align-items-center mb-3">
                                                            <div className="col-lg-4">
                                                                <div className="form-check">
                                                                    <input type="checkbox"
                                                                        className="form-check-input cursor-pointer"
                                                                        id="itemCheck"
                                                                        checked={templateJson.table.labels_section.table_properties.item.is_show_item}
                                                                        onChange={(e) => itemCheckbox(e)} />
                                                                    <label className="form-check-label cursor-pointer" htmlFor="itemCheck">Item</label>
                                                                </div>
                                                            </div>
                                                            <div className="col-lg-3 px-0">
                                                                <input type="number" className="form-control" id="itemWidthInput"
                                                                    name="itemWidth_name"
                                                                    placeholder="Enter width"
                                                                    value={templateJson.table.labels_section.table_properties.item.width}
                                                                    onChange={(e) => handleItemWidthChange(e)}
                                                                    disabled={!templateJson.table.labels_section.table_properties.item.is_show_item} />
                                                            </div>
                                                            <div className="col-lg-5">
                                                                <input type="text" className="form-control" id="itemLabelInput"
                                                                    name="itemLabel_name"
                                                                    placeholder="Enter Label"
                                                                    value={templateJson.table.labels_section.table_properties.item.label}
                                                                    onChange={(e) => handleItemLabelChange(e)}
                                                                    disabled={!templateJson.table.labels_section.table_properties.item.is_show_item} />
                                                            </div>
                                                        </div>
                                                        <div className="row align-items-center mb-3">
                                                            <div className="col-lg-7">
                                                                <div className="form-check">
                                                                    <input type="checkbox"
                                                                        className="form-check-input cursor-pointer"
                                                                        id="descLabelCheck"
                                                                        checked={templateJson.table.labels_section.table_properties.description.is_show_description}
                                                                        onChange={(e) => descLabelCheckbox(e)} />
                                                                    <label className="form-check-label cursor-pointer" htmlFor="descLabelCheck">Description</label>
                                                                </div>
                                                            </div>
                                                            <div className="col-lg-5">
                                                                <input type="text" className="form-control" id="descLabelInput"
                                                                    name="descLabel_name"
                                                                    placeholder="Enter Label"
                                                                    value={templateJson.table.labels_section.table_properties.description.label}
                                                                    onChange={(e) => handleDescLabelChange(e)}
                                                                    disabled={!templateJson.table.labels_section.table_properties.description.is_show_description} />
                                                            </div>
                                                        </div>
                                                        <div className="mb-4">
                                                            <button type="button" className="btn btn-outline-secondary rounded-2 w-100"
                                                                onClick={() => setshowQTItemContent(true)}>
                                                                <Settings size={16} /> <span className="small ps-2">Customize Item Name & Description</span>
                                                            </button>
                                                        </div>
                                                        <div className="row align-items-center mb-3">
                                                            <div className="col-lg-4">
                                                                <div className="form-check">
                                                                    <input type="checkbox"
                                                                        className="form-check-input cursor-pointer"
                                                                        id="cusTaFieldCheck"
                                                                        checked={true}
                                                                        disabled={true} />
                                                                    <label className="form-check-label cursor-pointer opacity-100" htmlFor="cusTaFieldCheck">
                                                                        <TooltipTrig id="cusTaFieldInfo"
                                                                            title='The width entered shall be applicable for all the custom fields created with "Show in all PDF" option.'>
                                                                            <span className="text-body text-dashed-underline">
                                                                                Custom Fields
                                                                            </span>
                                                                        </TooltipTrig>
                                                                    </label>
                                                                </div>
                                                            </div>
                                                            <div className="col-lg-3 px-0">
                                                                <input type="number" className="form-control" id="cusTaFieldWidthInput"
                                                                    name="cusTaFieldWidth_name"
                                                                    placeholder="Enter width"
                                                                    defaultValue={11} />
                                                            </div>
                                                            <div className="col-lg-5">
                                                                <input type="text" className="form-control" id="cusTaFieldLabelInput"
                                                                    name="cusTaFieldLabel_name"
                                                                    placeholder="Enter Label"
                                                                    defaultValue="%Custom Field Label%"
                                                                    disabled={true} />
                                                            </div>
                                                        </div>
                                                        <div className="row align-items-start mb-3">
                                                            <div className="col-lg-4 col-form-label">
                                                                <div className="form-check">
                                                                    <input type="checkbox"
                                                                        className="form-check-input cursor-pointer"
                                                                        id="taQtyCheck"
                                                                        checked={templateJson.table.labels_section.table_properties.quantity.is_show_quantity}
                                                                        onChange={(e) => taQtyCheckbox(e)} />
                                                                    <label className="form-check-label cursor-pointer" htmlFor="taQtyCheck">Quantity</label>
                                                                </div>
                                                            </div>
                                                            <div className="col-lg-3 px-0">
                                                                <input type="number" className="form-control" id="taQtyWidthInput"
                                                                    name="taQtyWidth_name"
                                                                    placeholder="Enter width"
                                                                    value={templateJson.table.labels_section.table_properties.quantity.width}
                                                                    onChange={(e) => handleTaQtyWidthChange(e)}
                                                                    disabled={!templateJson.table.labels_section.table_properties.quantity.is_show_quantity} />
                                                            </div>
                                                            <div className="col-lg-5">
                                                                <input type="text" className="form-control" id="taQtyLabelInput"
                                                                    name="taQtyLabel_name"
                                                                    placeholder="Enter Label"
                                                                    value={templateJson.table.labels_section.table_properties.quantity.label}
                                                                    onChange={(e) => handleTaQtyLabelChange(e)}
                                                                    disabled={!templateJson.table.labels_section.table_properties.quantity.is_show_quantity} />
                                                                {!templateJson.table.labels_section.table_properties.quantity.is_show_quantity ? ('') : (
                                                                    <div className="col-auto pt-2">
                                                                        <div className="form-check">
                                                                            <input type="checkbox"
                                                                                className="form-check-input cursor-pointer"
                                                                                id="taQtyUnitCheck"
                                                                                checked={templateJson.table.labels_section.table_properties.quantity.is_show_unit}
                                                                                onChange={(e) => taQtyUnitCheckbox(e)} />
                                                                            <label className="form-check-label cursor-pointer" htmlFor="taQtyUnitCheck">Show Unit</label>
                                                                        </div>
                                                                    </div>
                                                                )}
                                                            </div>
                                                        </div>
                                                        <div className="row align-items-center mb-3">
                                                            <div className="col-lg-4">
                                                                <div className="form-check">
                                                                    <input type="checkbox"
                                                                        className="form-check-input cursor-pointer"
                                                                        id="taRateCheck"
                                                                        checked={templateJson.table.labels_section.table_properties.rate.is_show_rate}
                                                                        onChange={(e) => taRateCheckbox(e)} />
                                                                    <label className="form-check-label cursor-pointer" htmlFor="taRateCheck">Rate</label>
                                                                </div>
                                                            </div>
                                                            <div className="col-lg-3 px-0">
                                                                <input type="number" className="form-control" id="taRateWidthInput"
                                                                    name="taRateWidth_name"
                                                                    placeholder="Enter width"
                                                                    value={templateJson.table.labels_section.table_properties.rate.width}
                                                                    onChange={(e) => handleTaRateWidthChange(e)}
                                                                    disabled={!templateJson.table.labels_section.table_properties.rate.is_show_rate} />
                                                            </div>
                                                            <div className="col-lg-5">
                                                                <input type="text" className="form-control" id="taRateLabelInput"
                                                                    name="taRateLabel_name"
                                                                    placeholder="Enter Label"
                                                                    value={templateJson.table.labels_section.table_properties.rate.label}
                                                                    onChange={(e) => handleTaRateLabelChange(e)}
                                                                    disabled={!templateJson.table.labels_section.table_properties.rate.is_show_rate} />
                                                            </div>
                                                        </div>
                                                        <div className="row align-items-center mb-3">
                                                            <div className="col-lg-4">
                                                                <div className="form-check">
                                                                    <input type="checkbox"
                                                                        className="form-check-input cursor-pointer"
                                                                        id="taTaxPerCheck"
                                                                        checked={templateJson.table.labels_section.table_properties.tax.is_show_tax}
                                                                        onChange={(e) => taTaxPerCheckbox(e)} />
                                                                    <label className="form-check-label cursor-pointer" htmlFor="taTaxPerCheck">Tax (%)</label>
                                                                </div>
                                                            </div>
                                                            <div className="col-lg-3 px-0">
                                                                <input type="number" className="form-control" id="taTaxPerWidthInput"
                                                                    name="taTaxPerWidth_name"
                                                                    placeholder="Enter width"
                                                                    value={templateJson.table.labels_section.table_properties.tax.width}
                                                                    onChange={(e) => handleTaTaxPerWidthChange(e)}
                                                                    disabled={!templateJson.table.labels_section.table_properties.tax.is_show_tax} />
                                                            </div>
                                                            <div className="col-lg-5">
                                                                <input type="text" className="form-control" id="taTaxPerLabelInput"
                                                                    name="taTaxPerLabel_name"
                                                                    placeholder="Enter Label"
                                                                    value={templateJson.table.labels_section.table_properties.tax.label}
                                                                    onChange={(e) => handleTaTaxPerLabelChange(e)}
                                                                    disabled={!templateJson.table.labels_section.table_properties.tax.is_show_tax} />
                                                            </div>
                                                        </div>
                                                        {/* <div className="row align-items-center mb-3">
                                                            <div className="col-lg-4">
                                                                <div className="form-check">
                                                                    <input type="checkbox"
                                                                        className="form-check-input cursor-pointer"
                                                                        id="taTaxAmtCheck"
                                                                        checked={isTaTaxAmtEnabled}
                                                                        onChange={(e) => taTaxAmtCheckbox(e, setIsTaTaxAmtEnabled)} />
                                                                    <label className="form-check-label cursor-pointer" htmlFor="taTaxAmtCheck">Tax Amount</label>
                                                                </div>
                                                            </div>
                                                            <div className="col-lg-3 px-0">
                                                                <input type="number" className="form-control" id="taTaxAmtWidthInput"
                                                                    name="taTaxAmtWidth_name"
                                                                    placeholder="Enter width"
                                                                    value={taTaxAmtWidth}
                                                                    onChange={(e) => handleTaTaxAmtWidthChange(e, setTaTaxAmtWidth)}
                                                                    disabled={!isTaTaxAmtEnabled} />
                                                            </div>
                                                            <div className="col-lg-5">
                                                                <input type="text" className="form-control" id="taTaxAmtLabelInput"
                                                                    name="taTaxAmtLabel_name"
                                                                    placeholder="Enter Label"
                                                                    value={taTaxAmtLabelText}
                                                                    onChange={(e) => handleTaTaxAmtLabelChange(e, setTaTaxAmtLabelText)}
                                                                    disabled={!isTaTaxAmtEnabled} />
                                                            </div>
                                                        </div> */}
                                                        <div className="row align-items-center mb-3">
                                                            <div className="col-lg-4">
                                                                <div className="form-check">
                                                                    <input type="checkbox"
                                                                        className="form-check-input cursor-pointer"
                                                                        id="taDisCheck"
                                                                        checked={templateJson.table.labels_section.table_properties.discount.is_show_discount}
                                                                        onChange={(e) => taDisCheckbox(e)} />
                                                                    <label className="form-check-label cursor-pointer" htmlFor="taDisCheck">Discount</label>
                                                                </div>
                                                            </div>
                                                            <div className="col-lg-3 px-0">
                                                                <input type="number" className="form-control" id="taDisWidthInput"
                                                                    name="taDisWidth_name"
                                                                    placeholder="Enter width"
                                                                    value={templateJson.table.labels_section.table_properties.discount.width}
                                                                    onChange={(e) => handleTaDisWidthChange(e)}
                                                                    disabled={!templateJson.table.labels_section.table_properties.discount.is_show_discount} />
                                                            </div>
                                                            <div className="col-lg-5">
                                                                <input type="text" className="form-control" id="taDisLabelInput"
                                                                    name="taDisLabel_name"
                                                                    placeholder="Enter Label"
                                                                    value={templateJson.table.labels_section.table_properties.discount.label}
                                                                    onChange={(e) => handleTaDisLabelChange(e)}
                                                                    disabled={!templateJson.table.labels_section.table_properties.discount.is_show_discount} />
                                                            </div>
                                                        </div>
                                                        <div className="row align-items-center mb-3">
                                                            <div className="col-lg-4">
                                                                <div className="form-check">
                                                                    <input type="checkbox"
                                                                        className="form-check-input cursor-pointer"
                                                                        id="taAmtCheck"
                                                                        checked={templateJson.table.labels_section.table_properties.amount.is_show_amount}
                                                                        onChange={(e) => taAmtCheckbox(e)} />
                                                                    <label className="form-check-label cursor-pointer" htmlFor="taAmtCheck">Amount</label>
                                                                </div>
                                                            </div>
                                                            <div className="col-lg-3 px-0">
                                                                <input type="number" className="form-control" id="taAmtWidthInput"
                                                                    name="taAmtWidth_name"
                                                                    placeholder="Enter width"
                                                                    value={templateJson.table.labels_section.table_properties.amount.width}
                                                                    onChange={(e) => handleTaAmtWidthChange(e)}
                                                                    disabled={!templateJson.table.labels_section.table_properties.amount.is_show_amount} />
                                                            </div>
                                                            <div className="col-lg-5">
                                                                <input type="text" className="form-control" id="taAmtLabelInput"
                                                                    name="taAmtLabel_name"
                                                                    placeholder="Enter Label"
                                                                    value={templateJson.table.labels_section.table_properties.amount.label}
                                                                    onChange={(e) => handleTaAmtLabelChange(e)}
                                                                    disabled={!templateJson.table.labels_section.table_properties.amount.is_show_amount} />
                                                            </div>
                                                        </div>
                                                        <div className="fw-semibold pt-3 mb-3">Invoices Created From Projects</div>
                                                        <div className="mb-3 row row-cols-2 justify-content-between">
                                                            <label className="col-form-label col-auto" htmlFor="projectItem_label">
                                                                Project Item
                                                            </label>
                                                            <div className="col-6">
                                                                <input type="text" className="form-control"
                                                                    id="projectItem_label"
                                                                    name="projectItem_name"
                                                                    // defaultValue="Task"
                                                                    value={templateJson.table.labels_section.invoices_created_from_projects.project_item}
                                                                    onChange={handleProjectItemChange}
                                                                    placeholder={`Enter text`} />
                                                            </div>
                                                        </div>
                                                        <div className="mb-3 row row-cols-2 justify-content-between">
                                                            <label className="col-form-label col-auto" htmlFor="projectDesc_label">
                                                                Project Description
                                                            </label>
                                                            <div className="col-6">
                                                                <input type="text" className="form-control"
                                                                    id="projectDesc_label"
                                                                    name="projectDesc_name"
                                                                    // defaultValue="Description"
                                                                    value={templateJson.table.labels_section.invoices_created_from_projects.project_description}
                                                                    onChange={handleProjectDescChange}
                                                                    placeholder={`Enter text`} />
                                                            </div>
                                                        </div>
                                                        <div className="mb-0 row row-cols-2 justify-content-between">
                                                            <label className="col-form-label col-auto" htmlFor="projectHours_label">
                                                                Project Hours
                                                            </label>
                                                            <div className="col-6">
                                                                <input type="text" className="form-control"
                                                                    id="projectHours_label"
                                                                    name="projectHours_name"
                                                                    // defaultValue="Project Hours"
                                                                    value={templateJson.table.labels_section.invoices_created_from_projects.project_hours}
                                                                    onChange={handleProjectHoursChange}
                                                                    placeholder={`Enter text`} />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="accordion-item mb-2">
                                                <h2 className="accordion-header">
                                                    <button className="accordion-button bg-transparent fw-medium" type="button" data-bs-toggle="collapse" data-bs-target="#tCollapseTwo" aria-expanded="false" aria-controls="tCollapseTwo">
                                                        Layout Section
                                                    </button>
                                                </h2>
                                                <div id="tCollapseTwo" className="accordion-collapse collapse" data-bs-parent="#tAccordion">
                                                    <div className="accordion-body px-3">
                                                        <div className="fs-6 pb-3 border-bottom">Table Properties</div>
                                                        <div className="pt-3">
                                                            <FieldColorCheckbox
                                                                labelText="Table Border"
                                                                checkboxId="tempTableBorder"
                                                                isCheckboxEnabled={templateJson.table.layout_section.table_properties.is_show_table_border}
                                                                inputColorId="temp_border_color"
                                                                inputColorValue={templateJson.table.layout_section.table_properties.table_border}
                                                                onValueChange={handleTableBorderColorChange}
                                                                disabled={false}
                                                                onCheckboxChange={handleTempBorderCheckboxChange}
                                                            />
                                                        </div>
                                                        <div className="fw-semibold mt-3 mb-2 fs-6">Table Header</div>
                                                        <div className="mb-3">
                                                            <FieldTextSize
                                                                labelText="Font Size"
                                                                id="ta_head_font_size"
                                                                size={templateJson.table.layout_section.table_properties.table_header.font_size}
                                                                onValueChange={handleTableHeaderFontChange}
                                                            />
                                                        </div>
                                                        <div className="mb-3">
                                                            <FieldColorCheckbox
                                                                labelText="Background Color"
                                                                haveCheck={true}
                                                                checkboxId="taHeadBgColor"
                                                                isCheckboxEnabled={templateJson.table.layout_section.table_properties.table_header.is_show_bg_color}
                                                                inputColorId="ta_Head_bg_color"
                                                                inputColorValue={templateJson.table.layout_section.table_properties.table_header.bg_color}
                                                                onValueChange={handleTableHeaderBgColorChange}
                                                                disabled={false}
                                                                onCheckboxChange={handleTaHeadBgColorCheckboxChange}
                                                            />
                                                        </div>
                                                        <div className="mb-3">
                                                            <FieldColorCheckbox
                                                                labelText="Font Color"
                                                                haveCheck={false}
                                                                isCheckboxEnabled={true}
                                                                inputColorId="ta_Head_font_color"
                                                                inputColorValue={templateJson.table.layout_section.table_properties.table_header.font_color}
                                                                onValueChange={handleTableHeaderFontColorChange}
                                                            />
                                                        </div>
                                                        <div className="fw-semibold mt-3 mb-2 fs-6">Item Row</div>
                                                        <div className="mb-3">
                                                            <FieldTextSize
                                                                labelText="Font Size"
                                                                id="ta_body_font_size"
                                                                size={templateJson.table.layout_section.table_properties.item_row.font_size}
                                                                onValueChange={handleTableRowFontChange}
                                                            />
                                                        </div>
                                                        <div className="mb-3">
                                                            <FieldColorCheckbox
                                                                labelText="Background Color"
                                                                haveCheck={true}
                                                                checkboxId="taBodyBgColor"
                                                                isCheckboxEnabled={templateJson.table.layout_section.table_properties.item_row.is_show_bg_color}
                                                                inputColorId="ta_body_bg_color"
                                                                inputColorValue={templateJson.table.layout_section.table_properties.item_row.bg_color}
                                                                onValueChange={handleTableRowBgColorChange}
                                                                disabled={false}
                                                                onCheckboxChange={handleTaBodyBgColorCheckboxChange}
                                                            />
                                                        </div>
                                                        <div className="mb-3">
                                                            <FieldColorCheckbox
                                                                labelText="Font Color"
                                                                haveCheck={false}
                                                                isCheckboxEnabled={true}
                                                                inputColorId="ta_Body_font_color"
                                                                inputColorValue={templateJson.table.layout_section.table_properties.item_row.font_color}
                                                                onValueChange={handleTableRowFontColorChange}
                                                            />
                                                        </div>
                                                        <div className="fw-semibold mt-3 mb-2 fs-6">Item Description</div>
                                                        <div className="mb-3">
                                                            <FieldTextSize
                                                                labelText="Font Size"
                                                                id="ta_body_desc_size"
                                                                size={templateJson.table.layout_section.table_properties.item_description.font_size}
                                                                onValueChange={handleTableDescFontChange}
                                                            />
                                                        </div>
                                                        <div className="mb-0">
                                                            <FieldColorCheckbox
                                                                labelText="Font Color"
                                                                haveCheck={false}
                                                                isCheckboxEnabled={true}
                                                                inputColorId="ta_Body_desc_color"
                                                                inputColorValue={templateJson.table.layout_section.table_properties.item_description.font_color}
                                                                onValueChange={handleTableDescFontColorChange}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                                {/* <div id="tCollapseTwo" className="accordion-collapse collapse" data-bs-parent="#tAccordion">
                                                    <div className="accordion-body px-3">
                                                        <div className="fs-6 pb-3 border-bottom">Table Properties</div>
                                                        <div className="pt-3">
                                                            <FieldColorCheckbox
                                                                labelText="Table Border"
                                                                checkboxId="tempTableBorder"
                                                                isCheckboxEnabled={isTableBorderEnabled}
                                                                inputColorId="temp_border_color"
                                                                inputColorValue={tempBorderColor}
                                                                onValueChange={setTempBorderColor}
                                                                disabled={false}
                                                                onCheckboxChange={handleTempBorderCheckboxChange}
                                                            />
                                                        </div>
                                                        <div className="fw-semibold mt-3 mb-2 fs-6">Table Header</div>
                                                        <div className="mb-3">
                                                            <FieldTextSize
                                                                labelText="Font Size"
                                                                id="ta_head_font_size"
                                                                size={taHeadFontSize}
                                                                onValueChange={setTaHeadFontSize}
                                                            />
                                                        </div>
                                                        <div className="mb-3">
                                                            <FieldColorCheckbox
                                                                labelText="Background Color"
                                                                haveCheck={true}
                                                                checkboxId="taHeadBgColor"
                                                                isCheckboxEnabled={isTaHeadBgColorEnabled}
                                                                inputColorId="ta_Head_bg_color"
                                                                inputColorValue={taHeadBgColor}
                                                                onValueChange={setTaHeadBgColor}
                                                                disabled={false}
                                                                onCheckboxChange={handleTaHeadBgColorCheckboxChange}
                                                            />
                                                        </div>
                                                        <div className="mb-3">
                                                            <FieldColorCheckbox
                                                                labelText="Font Color"
                                                                haveCheck={false}
                                                                isCheckboxEnabled={true}
                                                                inputColorId="ta_Head_font_color"
                                                                inputColorValue={taHeadFontColor}
                                                                onValueChange={setTaHeadFontColor}
                                                            />
                                                        </div>
                                                        <div className="fw-semibold mt-3 mb-2 fs-6">Item Row</div>
                                                        <div className="mb-3">
                                                            <FieldTextSize
                                                                labelText="Font Size"
                                                                id="ta_body_font_size"
                                                                size={taBodyFontSize}
                                                                onValueChange={setTaBodyFontSize}
                                                            />
                                                        </div>
                                                        <div className="mb-3">
                                                            <FieldColorCheckbox
                                                                labelText="Background Color"
                                                                haveCheck={true}
                                                                checkboxId="taBodyBgColor"
                                                                isCheckboxEnabled={isTaBodyBgColorEnabled}
                                                                inputColorId="ta_body_bg_color"
                                                                inputColorValue={taBodyBgColor}
                                                                onValueChange={setTaBodyBgColor}
                                                                disabled={false}
                                                                onCheckboxChange={handleTaBodyBgColorCheckboxChange}
                                                            />
                                                        </div>
                                                        <div className="mb-3">
                                                            <FieldColorCheckbox
                                                                labelText="Font Color"
                                                                haveCheck={false}
                                                                isCheckboxEnabled={true}
                                                                inputColorId="ta_Body_font_color"
                                                                inputColorValue={taBodyFontColor}
                                                                onValueChange={setTaBodyFontColor}
                                                            />
                                                        </div>
                                                        <div className="fw-semibold mt-3 mb-2 fs-6">Item Description</div>
                                                        <div className="mb-3">
                                                            <FieldTextSize
                                                                labelText="Font Size"
                                                                id="ta_body_desc_size"
                                                                size={taBodyDescSize}
                                                                onValueChange={setTaBodyDescSize}
                                                            />
                                                        </div>
                                                        <div className="mb-0">
                                                            <FieldColorCheckbox
                                                                labelText="Font Color"
                                                                haveCheck={false}
                                                                isCheckboxEnabled={true}
                                                                inputColorId="ta_Body_desc_color"
                                                                inputColorValue={taBodyDescColor}
                                                                onValueChange={setTaBodyDescColor}
                                                            />
                                                        </div>
                                                    </div>
                                                </div> */}
                                            </div>
                                        </div>
                                    </div>
                                    <div className="tab-pane fade" id="v-pills-5" role="tabpanel"
                                        aria-labelledby="v-pills-5-tab" tabIndex="0">
                                        <div className="accordion accordion-flush bg-body-tertiary pb-2" id="toAccordion">
                                            <div className="accordion-item mb-2">
                                                <h2 className="accordion-header">
                                                    <button className="accordion-button bg-transparent fw-medium" type="button" data-bs-toggle="collapse" data-bs-target="#toCollapseOne" aria-expanded="true" aria-controls="toCollapseOne">
                                                        Labels Section
                                                    </button>
                                                </h2>
                                                <div id="toCollapseOne" className="accordion-collapse collapse show" data-bs-parent="#toAccordion">
                                                    <div className="accordion-body">
                                                        <div className="mb-3">
                                                            <div className="form-check form-check-inline">
                                                                <input type="checkbox" className="form-check-input cursor-pointer" id="allTotalSetCheck"
                                                                    // checked={isAllTotalSetEnabled}
                                                                    // onChange={allTotalSetChange} 
                                                                    checked={templateJson.total.labels_section.is_show_total_section}
                                                                    onChange={allTotalSetChange}
                                                                />
                                                                <label className="form-check-label cursor-pointer" htmlFor="allTotalSetCheck">Show Total Section</label>
                                                            </div>
                                                        </div>
                                                        {templateJson.total.labels_section.is_show_total_section ? (
                                                            <>
                                                                {/* <SingleTextCheckbox
                                                                    checkboxId="subTotalCheckbox"
                                                                    isCheckboxDisabled={false}
                                                                    checkboxLabel="Sub Total"
                                                                    isCheckboxEnabled={isSubTotalEnabled}
                                                                    inputId="subTotalCheckboxInput"
                                                                    inputValue={subTotalText}
                                                                    onValueChange={setSubTotalText}
                                                                    disabled={false}
                                                                    onCheckboxChange={handleSubTotalCheckboxChange}
                                                                /> */}
                                                                <SingleTextCheckbox
                                                                    checkboxId="subTotalCheckbox"
                                                                    isCheckboxDisabled={false}
                                                                    checkboxLabel="Sub Total"
                                                                    isCheckboxEnabled={templateJson.total.labels_section.is_show_sub_total}
                                                                    inputId="subTotalCheckboxInput"
                                                                    inputValue={templateJson.total.labels_section.sub_total_title}
                                                                    onValueChange={handleTotalSubTotalTitleChange}
                                                                    disabled={false}
                                                                    onCheckboxChange={handleSubTotalCheckboxChange}
                                                                />
                                                                {/* <SingleTextCheckbox
                                                                    checkboxId="shipChargeCheckbox"
                                                                    isCheckboxDisabled={true}
                                                                    checkboxLabel="Shipping Charges"
                                                                    isCheckboxEnabled={isShipChargeEnabled}
                                                                    inputId="shipChargeCheckboxInput"
                                                                    inputValue={shipChargeText}
                                                                    onValueChange={setShipChargeText}
                                                                    disabled={false}
                                                                    onCheckboxChange={handleShipChargeCheckboxChange}
                                                                /> */}
                                                                <SingleTextCheckbox
                                                                    checkboxId="shipChargeCheckbox"
                                                                    isCheckboxDisabled={true}
                                                                    checkboxLabel="Shipping Charges"
                                                                    isCheckboxEnabled={templateJson.total.labels_section.is_show_shipping_charges}
                                                                    inputId="shipChargeCheckboxInput"
                                                                    inputValue={templateJson.total.labels_section.shipping_charges_title}
                                                                    onValueChange={handleTotalShpChargeTitleChange}
                                                                    disabled={false}
                                                                    onCheckboxChange={handleShipChargeCheckboxChange}
                                                                />
                                                                {/* <div className="mb-3">
                                                                    <div className="form-check">
                                                                        <input type="checkbox" className="form-check-input cursor-pointer" id="discountSecCheck"
                                                                            checked={isDiscountSecEnabled}
                                                                            onChange={discountSecChange} />
                                                                        <label className="form-check-label cursor-pointer" htmlFor="discountSecCheck">
                                                                            Discount
                                                                            <TooltipTrig id="discountSecInfo"
                                                                                title="This will display the discount applied on a transaction level.">
                                                                                <span className="ps-1 text-gray">
                                                                                    <TbInfoCircleFilled size={16} />
                                                                                </span>
                                                                            </TooltipTrig>
                                                                        </label>
                                                                    </div>
                                                                </div> */}
                                                                <div className="mb-3">
                                                                    <div className="form-check">
                                                                        <input type="checkbox" className="form-check-input cursor-pointer" id="discountSecCheck"
                                                                            checked={templateJson.total.labels_section.is_show_discount}
                                                                            onChange={discountSecChange} />
                                                                        <label className="form-check-label cursor-pointer" htmlFor="discountSecCheck">
                                                                            Discount
                                                                            <TooltipTrig id="discountSecInfo"
                                                                                title="This will display the discount applied on a transaction level.">
                                                                                <span className="ps-1 text-gray">
                                                                                    <TbInfoCircleFilled size={16} />
                                                                                </span>
                                                                            </TooltipTrig>
                                                                        </label>
                                                                    </div>
                                                                </div>
                                                                {/* <div className="mb-3 row row-cols-2 justify-content-between">
                                                                    <div className="col-6">
                                                                        <div className="form-check col-form-label">
                                                                            <input type="checkbox" className="form-check-input cursor-pointer"
                                                                                id="toTaxAmtCheck"
                                                                                checked={isToTaxAmtEnabled}
                                                                                onChange={(e) => toTaxAmtCheckbox(e, setIsToTaxAmtEnabled)} />
                                                                            <label className="form-check-label cursor-pointer" htmlFor="toTaxAmtCheck">
                                                                                Total Taxable Amount
                                                                                <TooltipTrig id="toTaxAmtInfo"
                                                                                    title="This field will not be shown in the Quote PDF if you've not associated tax for any items in the Quote.">
                                                                                    <span className="ps-1 text-gray">
                                                                                        <TbInfoCircleFilled size={16} />
                                                                                    </span>
                                                                                </TooltipTrig>
                                                                            </label>
                                                                        </div>
                                                                    </div>
                                                                    <div className="col-6">
                                                                        <input type="text" className="form-control"
                                                                            id="toTaxAmtInput"
                                                                            name="toTaxAmt_name"
                                                                            value={toTaxAmtLabelText}
                                                                            onChange={(e) => handleToTaxAmtLabelChange(e, setToTaxAmtLabelText)}
                                                                            placeholder={`Enter ${toTaxAmtLabelText} label text`}
                                                                            disabled={!isToTaxAmtEnabled} />
                                                                    </div>
                                                                </div> */}
                                                                <div className="mb-3 row row-cols-2 justify-content-between">
                                                                    <div className="col-6">
                                                                        <div className="form-check col-form-label">
                                                                            <input type="checkbox" className="form-check-input cursor-pointer"
                                                                                id="toTaxAmtCheck"
                                                                                checked={templateJson.total.labels_section.is_show_tax}
                                                                                onChange={(e) => toTaxAmtCheckbox(e)} />
                                                                            <label className="form-check-label cursor-pointer" htmlFor="toTaxAmtCheck">
                                                                                Tax
                                                                                <TooltipTrig id="toTaxAmtInfo"
                                                                                    title="This field will not be shown in the Quote PDF if you've not associated tax for any items in the Quote.">
                                                                                    <span className="ps-1 text-gray">
                                                                                        <TbInfoCircleFilled size={16} />
                                                                                    </span>
                                                                                </TooltipTrig>
                                                                            </label>
                                                                        </div>
                                                                    </div>
                                                                    <div className="col-6">
                                                                        <input type="text" className="form-control"
                                                                            id="toTaxAmtInput"
                                                                            name="toTaxAmt_name"
                                                                            value={templateJson.total.labels_section.tax_title}
                                                                            onChange={(e) => handleToTaxAmtLabelChange(e)}
                                                                            placeholder={`Enter ${templateJson.total.labels_section.tax_title} label text`}
                                                                            disabled={!templateJson.total.labels_section.is_show_tax} />
                                                                    </div>
                                                                </div>
                                                                <div className="mb-3">
                                                                    <div className="form-check">
                                                                        <input type="checkbox" className="form-check-input cursor-pointer" id="adjSecCheck"
                                                                            checked={templateJson.total.labels_section.is_show_adjustment}
                                                                            onChange={adjustmentSecChange} />
                                                                        <label className="form-check-label cursor-pointer" htmlFor="adjSecCheck">
                                                                            Adjustment
                                                                            <TooltipTrig id="discountSecInfo"
                                                                                title="This will display the adjustment applied on a transaction level.">
                                                                                <span className="ps-1 text-gray">
                                                                                    <TbInfoCircleFilled size={16} />
                                                                                </span>
                                                                            </TooltipTrig>
                                                                        </label>
                                                                    </div>
                                                                </div>
                                                                {/* <div className="mb-3">
                                                                    <div className="form-check">
                                                                        <input type="checkbox" className="form-check-input cursor-pointer"
                                                                            id="showTaxDetailCheck"
                                                                            checked={isShowTaxDetailEnabled}
                                                                            onChange={showTaxDetailCheckbox} />
                                                                        <label className="form-check-label cursor-pointer" htmlFor="showTaxDetailCheck">
                                                                            Show Tax Details
                                                                        </label>
                                                                    </div>
                                                                </div> */}
                                                                <div className="mb-3">
                                                                    <div className="form-check">
                                                                        <input type="checkbox" className="form-check-input cursor-pointer"
                                                                            id="showTaxDetailCheck"
                                                                            checked={isShowTaxDetailEnabled}
                                                                            onChange={showTaxDetailCheckbox}
                                                                            disabled
                                                                        />
                                                                        <label className="form-check-label cursor-pointer" htmlFor="showTaxDetailCheck">
                                                                            Show Tax Details
                                                                        </label>
                                                                    </div>
                                                                </div>
                                                                {/* <SingleTextCheckbox
                                                                    checkboxId="mainTotalCheckbox"
                                                                    isCheckboxDisabled={true}
                                                                    checkboxLabel="Total"
                                                                    isCheckboxEnabled={isMainTotalEnabled}
                                                                    inputId="mainTotalCheckboxInput"
                                                                    inputValue={mainTotalText}
                                                                    onValueChange={setMainTotalText}
                                                                    disabled={false}
                                                                    onCheckboxChange={handleMainTotalCheckboxChange}
                                                                /> */}
                                                                <SingleTextCheckbox
                                                                    checkboxId="mainTotalCheckbox"
                                                                    isCheckboxDisabled={true}
                                                                    checkboxLabel="Total"
                                                                    isCheckboxEnabled={templateJson.total.labels_section.is_show_total}
                                                                    inputId="mainTotalCheckboxInput"
                                                                    inputValue={templateJson.total.labels_section.total_title}
                                                                    onValueChange={handleTotalTitleChange}
                                                                    disabled={false}
                                                                    onCheckboxChange={handleMainTotalCheckboxChange}
                                                                />
                                                                {/* <div className="mb-3 row row-cols-2 justify-content-between">
                                                                    <div className="col-6">
                                                                        <div className="form-check col-form-label">
                                                                            <input type="checkbox" className="form-check-input"
                                                                                id="curSymbolCheck"
                                                                                checked={isCurSymbolEnabled}
                                                                                onChange={(e) => setIsCurSymbolEnabled(e.target.checked)}
                                                                                disabled={true} />
                                                                            <label className="form-check-label" htmlFor="curSymbolCheck">Currency Symbol</label>
                                                                        </div>
                                                                    </div>
                                                                    <div className="col-6">
                                                                        <select className="form-select" id='curSymbolPos'
                                                                            name='selectCurSymbolPos' value={selectedCurSymbolPos}
                                                                            onChange={e => setSelectedCurSymbolPos(e.target.value)}>
                                                                            <option value="beforeAmt">Before Amount</option>
                                                                            <option value="afterAmt">After Amount</option>
                                                                        </select>
                                                                    </div>
                                                                </div> */}
                                                                <div className="mb-3 row row-cols-2 justify-content-between">
                                                                    <div className="col-6">
                                                                        <div className="form-check col-form-label">
                                                                            <input type="checkbox" className="form-check-input"
                                                                                id="curSymbolCheck"
                                                                                checked={templateJson.total.labels_section.is_show_currency_symbol}
                                                                                // onChange={(e) => setIsCurSymbolEnabled(e.target.checked)}
                                                                                onChange={(e) => setTemplateJson((prev) => ({
                                                                                    ...prev,
                                                                                    total: {
                                                                                        ...prev.total,
                                                                                        labels_section: {
                                                                                            ...prev.total.labels_section,
                                                                                            is_show_currency_symbol: e.target.checked
                                                                                        }
                                                                                    }
                                                                                }))}
                                                                                disabled={true} />
                                                                            <label className="form-check-label" htmlFor="curSymbolCheck">Currency Symbol</label>
                                                                        </div>
                                                                    </div>
                                                                    <div className="col-6">
                                                                        <select className="form-select" id='curSymbolPos'
                                                                            name='selectCurSymbolPos' value={templateJson.total.labels_section.currency_symbol_title}
                                                                            // onChange={e => setSelectedCurSymbolPos(e.target.value)}
                                                                            onChange={(e) => setTemplateJson((prev) => ({
                                                                                ...prev,
                                                                                total: {
                                                                                    ...prev.total,
                                                                                    labels_section: {
                                                                                        ...prev.total.labels_section,
                                                                                        currency_symbol_title: e.target.value
                                                                                    }
                                                                                }
                                                                            }))}
                                                                        >
                                                                            <option value="beforeAmt">Before Amount</option>
                                                                            <option value="afterAmt">After Amount</option>
                                                                        </select>
                                                                    </div>
                                                                </div>
                                                                <div className="mb-3">
                                                                    <div className="form-check form-check-inline">
                                                                        <input type="checkbox" className="form-check-input cursor-pointer" id="payDetailSetCheck"
                                                                            checked={isPayDetailSetEnabled}
                                                                            onChange={payDetailSetChange} />
                                                                        <label className="form-check-label cursor-pointer" htmlFor="payDetailSetCheck">Show Payment Details</label>
                                                                    </div>
                                                                </div>
                                                                {isPayDetailSetEnabled ? (<>
                                                                    <div className="mb-3 row row-cols-2 justify-content-between">
                                                                        <label className="col-form-label col-auto" htmlFor="payMade_label">
                                                                            Payment Made
                                                                        </label>
                                                                        <div className="col-6">
                                                                            <input type="text" className="form-control"
                                                                                id="payMade_label"
                                                                                name="payMade_name"
                                                                                value={payMadeLabel}
                                                                                onChange={(e) => handlePayMadeLabelChange(e, setPayMadeLabel)}
                                                                                placeholder={`Enter text`} />
                                                                        </div>
                                                                    </div>
                                                                    <div className="mb-3 row row-cols-2 justify-content-between">
                                                                        <label className="col-form-label col-auto" htmlFor="creditApplied_label">
                                                                            Credits Applied
                                                                        </label>
                                                                        <div className="col-6">
                                                                            <input type="text" className="form-control"
                                                                                id="creditApplied_label"
                                                                                name="creditApplied_name"
                                                                                value={creditAppliedLabel}
                                                                                onChange={(e) => handleCreditAppliedLabelChange(e, setCreditAppliedLabel)}
                                                                                placeholder={`Enter text`} />
                                                                        </div>
                                                                    </div>
                                                                    <div className="mb-3 row row-cols-2 justify-content-between">
                                                                        <label className="col-form-label col-auto" htmlFor="amtWitheld_label">
                                                                            Amount Withheld
                                                                        </label>
                                                                        <div className="col-6">
                                                                            <input type="text" className="form-control"
                                                                                id="amtWitheld_label"
                                                                                name="amtWitheld_name"
                                                                                value={amtWitheldLabel}
                                                                                onChange={(e) => handleAmtWitheldLabelChange(e, setAmtWitheldLabel)}
                                                                                placeholder={`Enter text`} />
                                                                        </div>
                                                                    </div>
                                                                    <div className="mb-3 row row-cols-2 justify-content-between">
                                                                        <label className="col-form-label col-auto" htmlFor="writeOffAmt_label">
                                                                            Write Off Amount
                                                                        </label>
                                                                        <div className="col-6">
                                                                            <input type="text" className="form-control"
                                                                                id="writeOffAmt_label"
                                                                                name="writeOffAmt_name"
                                                                                value={writeOffAmtLabel}
                                                                                onChange={(e) => handleWriteOffAmtLabelChange(e, setWriteOffAmtLabel)}
                                                                                placeholder={`Enter text`} />
                                                                        </div>
                                                                    </div>
                                                                    <div className="mb-3 row row-cols-2 justify-content-between">
                                                                        <label className="col-form-label col-auto" htmlFor="balDueAmt_label">
                                                                            Balance Due
                                                                        </label>
                                                                        <div className="col-6">
                                                                            <input type="text" className="form-control"
                                                                                id="balDueAmt_label"
                                                                                name="balDueAmt_name"
                                                                                value={balDueAmtLabel}
                                                                                onChange={(e) => handleBalDueAmtLabelChange(e, setBalDueAmtLabel)}
                                                                                placeholder={`Enter text`} />
                                                                        </div>
                                                                    </div>
                                                                </>) : ('')}
                                                                <div className="mb-2">
                                                                    <div className="form-check form-check-inline">
                                                                        <input type="checkbox" className="form-check-input cursor-pointer"
                                                                            id="totalQtySetCheck"
                                                                            checked={isTotalQtySetEnabled}
                                                                            onChange={totalQtySetChange} />
                                                                        <label className="form-check-label cursor-pointer" htmlFor="totalQtySetCheck">Show Quantity</label>
                                                                    </div>
                                                                </div>
                                                                {isTotalQtySetEnabled ? (<>
                                                                    <div className="mb-3 row row-cols-2 justify-content-between">
                                                                        <label className="col-form-label col-auto" htmlFor="items_total_label">
                                                                            Items in Total
                                                                        </label>
                                                                        <div className="col-6">
                                                                            <input type="text" className="form-control"
                                                                                id="items_total_label"
                                                                                name="itemsTotal_name"
                                                                                value={itemsTotalLabelText}
                                                                                onChange={(e) => handleItemsTotalLabelChange(e, setItemsTotalLabelText)}
                                                                                placeholder={`Enter label text`} />
                                                                        </div>
                                                                    </div>
                                                                    <div className="mb-0 row row-cols-2 justify-content-between">
                                                                        <label className="col-form-label col-auto" htmlFor="hours_total_label">
                                                                            Hours in Total
                                                                        </label>
                                                                        <div className="col-6">
                                                                            <input type="text" className="form-control"
                                                                                id="hours_total_label"
                                                                                name="hoursTotal_name"
                                                                                value={hoursTotalLabelText}
                                                                                onChange={(e) => handleHoursTotalLabelChange(e, setHoursTotalLabelText)}
                                                                                placeholder={`Enter label text`} />
                                                                        </div>
                                                                    </div>
                                                                </>
                                                                ) : ('')}
                                                            </>
                                                        ) : ('')}
                                                        <hr />
                                                        <div className="mb-0">
                                                            <div className="form-check">
                                                                <input type="checkbox" className="form-check-input cursor-pointer"
                                                                    id="amtShowWordsCheck"
                                                                    checked={isAmtShowWordsEnabled}
                                                                    onChange={amtShowWordsChange} />
                                                                <label className="form-check-label cursor-pointer" htmlFor="amtShowWordsCheck">
                                                                    Show amount in words
                                                                    <TooltipTrig id="showAmountWordsInfo"
                                                                        title="The amount in words will be displayed only in the organization's language.">
                                                                        <span className="ps-1 text-gray">
                                                                            <TbInfoCircleFilled size={16} />
                                                                        </span>
                                                                    </TooltipTrig>
                                                                </label>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="accordion-item mb-0">
                                                <h2 className="accordion-header">
                                                    <button className="accordion-button bg-transparent fw-medium" type="button" data-bs-toggle="collapse" data-bs-target="#toCollapseTwo" aria-expanded="false" aria-controls="toCollapseTwo">
                                                        Layout Section
                                                    </button>
                                                </h2>
                                                <div id="toCollapseTwo" className="accordion-collapse collapse" data-bs-parent="#toAccordion">
                                                    <div className="accordion-body">
                                                        <div className="fw-semibold mb-2 fs-6">Total (Subtotal, Tax)</div>
                                                        <div className="mb-3">
                                                            <FieldTextSize
                                                                labelText="Font Size"
                                                                id="total_sec_fsize"
                                                                size={templateJson.total.layout_section.total.font_size}
                                                                onValueChange={handleTotalFontChange}
                                                            />
                                                        </div>
                                                        <div className="mb-3">
                                                            <FieldColorCheckbox
                                                                labelText="Font Color"
                                                                haveCheck={false}
                                                                isCheckboxEnabled={true}
                                                                inputColorId="total_sec_Fcolor"
                                                                inputColorValue={templateJson.total.layout_section.total.font_color}
                                                                onValueChange={handleTotalFontColorChange}
                                                            />
                                                        </div>
                                                        <div className="mb-3">
                                                            <FieldColorCheckbox
                                                                labelText="Background Color"
                                                                haveCheck={true}
                                                                checkboxId="totalSecBgColorCheck"
                                                                isCheckboxEnabled={templateJson.total.layout_section.total.is_show_bg_color}
                                                                inputColorId="total_sec_bgColor"
                                                                inputColorValue={templateJson.total.layout_section.total.bg_color}
                                                                onValueChange={handleTotalBgColorChange}
                                                                disabled={false}
                                                                onCheckboxChange={handleTotalSecBgColorCheckboxChange}
                                                            />
                                                        </div>
                                                        <div className="fw-semibold mt-3 mb-2 fs-6">Balance Due</div>
                                                        <div className="mb-3">
                                                            <FieldTextSize
                                                                labelText="Font Size"
                                                                id="balDue_sec_fsize"
                                                                size={templateJson.total.layout_section.balance_due.font_size}
                                                                onValueChange={handleTotalBlcFontChange}
                                                            />
                                                        </div>
                                                        <div className="mb-3">
                                                            <FieldColorCheckbox
                                                                labelText="Font Color"
                                                                haveCheck={false}
                                                                isCheckboxEnabled={true}
                                                                inputColorId="balDue_sec_Fcolor"
                                                                inputColorValue={templateJson.total.layout_section.balance_due.font_color}
                                                                onValueChange={handleTotalBlcFontColorChange}
                                                            />
                                                        </div>
                                                        <div className="mb-3">
                                                            <FieldColorCheckbox
                                                                labelText="Background Color"
                                                                haveCheck={true}
                                                                checkboxId="balDueSecBgColorCheck"
                                                                isCheckboxEnabled={templateJson.total.layout_section.balance_due.is_show_bg_color}
                                                                inputColorId="balDue_sec_bgColor"
                                                                inputColorValue={templateJson.total.layout_section.balance_due.bg_color}
                                                                onValueChange={handleTotalBlcBgColorChange}
                                                                disabled={false}
                                                                onCheckboxChange={handleBalDueSecBgColorCheckboxChange}
                                                            />
                                                        </div>
                                                    </div>
                                                    {/* <div className="accordion-body">
                                                        <div className="fw-semibold mb-2 fs-6">Total (Subtotal, Tax)</div>
                                                        <div className="mb-3">
                                                            <FieldTextSize
                                                                labelText="Font Size"
                                                                id="total_sec_fsize"
                                                                size={totalSecFsize}
                                                                onValueChange={setTotalSecFsize}
                                                            />
                                                        </div>
                                                        <div className="mb-3">
                                                            <FieldColorCheckbox
                                                                labelText="Font Color"
                                                                haveCheck={false}
                                                                isCheckboxEnabled={true}
                                                                inputColorId="total_sec_Fcolor"
                                                                inputColorValue={totalSecFcolor}
                                                                onValueChange={setTotalSecFcolor}
                                                            />
                                                        </div>
                                                        <div className="mb-3">
                                                            <FieldColorCheckbox
                                                                labelText="Background Color"
                                                                haveCheck={true}
                                                                checkboxId="totalSecBgColorCheck"
                                                                isCheckboxEnabled={isTotalSecBgColorEnabled}
                                                                inputColorId="total_sec_bgColor"
                                                                inputColorValue={totalSecBgColor}
                                                                onValueChange={setTotalSecBgColor}
                                                                disabled={false}
                                                                onCheckboxChange={handleTotalSecBgColorCheckboxChange}
                                                            />
                                                        </div>
                                                        <div className="fw-semibold mt-3 mb-2 fs-6">Balance Due</div>
                                                        <div className="mb-3">
                                                            <FieldTextSize
                                                                labelText="Font Size"
                                                                id="balDue_sec_fsize"
                                                                size={balDueSecFsize}
                                                                onValueChange={setBalDueSecFsize}
                                                            />
                                                        </div>
                                                        <div className="mb-3">
                                                            <FieldColorCheckbox
                                                                labelText="Font Color"
                                                                haveCheck={false}
                                                                isCheckboxEnabled={true}
                                                                inputColorId="balDue_sec_Fcolor"
                                                                inputColorValue={balDueSecFcolor}
                                                                onValueChange={setBalDueSecFcolor}
                                                            />
                                                        </div>
                                                        <div className="mb-3">
                                                            <FieldColorCheckbox
                                                                labelText="Background Color"
                                                                haveCheck={true}
                                                                checkboxId="balDueSecBgColorCheck"
                                                                isCheckboxEnabled={isBalDueSecBgColorEnabled}
                                                                inputColorId="balDue_sec_bgColor"
                                                                inputColorValue={balDueSecBgColor}
                                                                onValueChange={setBalDueSecBgColor}
                                                                disabled={false}
                                                                onCheckboxChange={handleBalDueSecBgColorCheckboxChange}
                                                            />
                                                        </div>
                                                    </div> */}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="tab-pane fade" id="v-pills-6" role="tabpanel"
                                        aria-labelledby="v-pills-6-tab" tabIndex="0">
                                        <div className="accordion accordion-flush bg-body-tertiary pb-2" id="odAccordion">
                                            <div className="accordion-item mb-2">
                                                <h2 className="accordion-header">
                                                    <button className="accordion-button bg-transparent fw-medium" type="button" data-bs-toggle="collapse" data-bs-target="#odCollapseOne" aria-expanded="true" aria-controls="odCollapseOne">
                                                        Document Summary
                                                    </button>
                                                </h2>
                                                <div id="odCollapseOne" className="accordion-collapse collapse show" data-bs-parent="#odAccordion">
                                                    <div className="accordion-body">
                                                        <div className="fw-semibold mt-0 mb-2 fs-6">Notes</div>
                                                        <div className="mb-3 row row-cols-2 justify-content-between">
                                                            <label className="col-form-label col-auto" htmlFor="notes_label">
                                                                Label
                                                            </label>
                                                            <div className="col-6">
                                                                <input type="text" className="form-control"
                                                                    id="notes_label"
                                                                    name="label_title"
                                                                    value={templateJson.other_details.document_summary.notes.label_title}
                                                                    onChange={(e) => handleNotesLabelChange(e)}
                                                                    placeholder={`Enter label text`} />
                                                            </div>
                                                        </div>
                                                        <div className="mb-3">
                                                            <FieldTextSize
                                                                labelText="Font Size"
                                                                id="notes_fsize"
                                                                size={templateJson.other_details.document_summary.notes.font_size}
                                                                onValueChange={handleOtherNoteFontChange}
                                                            />
                                                        </div>
                                                        {/* <div className="mb-3 row row-cols-2 justify-content-between">
                                                            <label className="col-form-label col-auto" htmlFor="notes_label">
                                                                Label
                                                            </label>
                                                            <div className="col-6">
                                                                <input type="text" className="form-control"
                                                                    id="notes_label"
                                                                    name="notesLabel_name"
                                                                    value={notesLabelText}
                                                                    onChange={(e) => handleNotesLabelChange(e, setNotesLabelText)}
                                                                    placeholder={`Enter label text`} />
                                                            </div>
                                                        </div>
                                                        <div className="mb-3">
                                                            <FieldTextSize
                                                                labelText="Font Size"
                                                                id="notes_fsize"
                                                                size={notesFsize}
                                                                onValueChange={setNotesFsize}
                                                            />
                                                        </div> */}
                                                        <div className="fw-semibold mb-2 fs-6">Payment Options</div>
                                                        <SingleTextCheckbox
                                                            checkboxId="onlinePayLinkCheckbox"
                                                            isCheckboxDisabled={false}
                                                            checkboxLabel="online Payment Link"
                                                            isCheckboxEnabled={isOnlinePayLinkEnabled}
                                                            inputId="onlinePayLinkCheckboxInput"
                                                            inputValue={onlinePayLinkText}
                                                            onValueChange={setOnlinePayLinkText}
                                                            disabled={false}
                                                            onCheckboxChange={handleOnlinePayLinkCheckboxChange}
                                                        />
                                                        <div className="mb-4">
                                                            <button type="button" className="btn btn-outline-secondary rounded-2 w-100"
                                                                onClick={() => handleAddBankDetailsModalShow()}>
                                                                <Settings size={16} /> <span className="ps-2">Add your bank details</span>
                                                            </button>
                                                        </div>
                                                        {/* <div className="mb-2 pt-2">
                                                            <div className="form-check form-check-inline">
                                                                <input type="checkbox" className="form-check-input cursor-pointer"
                                                                    id="termAndCondSetCheck"
                                                                    checked={isTermCondSetEnabled}
                                                                    onChange={termCondSetChange} />
                                                                <label className="form-check-label fw-semibold cursor-pointer" htmlFor="termAndCondSetCheck">Terms & Conditions</label>
                                                            </div>
                                                        </div> */}
                                                        <div className="mb-2 pt-2">
                                                            <div className="form-check form-check-inline">
                                                                <input type="checkbox" className="form-check-input cursor-pointer"
                                                                    id="termAndCondSetCheck"
                                                                    checked={templateJson.other_details.document_summary.terms_and_conditions.is_show_terms_and_conditions}
                                                                    onChange={termCondSetChange} />
                                                                <label className="form-check-label fw-semibold cursor-pointer" htmlFor="termAndCondSetCheck">Terms & Conditions</label>
                                                            </div>
                                                        </div>
                                                        {templateJson.other_details.document_summary.terms_and_conditions.is_show_terms_and_conditions ? (
                                                            <>
                                                                <div className="mb-3 row row-cols-2 justify-content-between">
                                                                    <label className="col-form-label col-auto" htmlFor="term_cond_label">
                                                                        Label
                                                                    </label>
                                                                    <div className="col-6">
                                                                        <input type="text" className="form-control"
                                                                            id="term_cond_label"
                                                                            name="label_title"
                                                                            value={templateJson.other_details.document_summary.terms_and_conditions.label_title}
                                                                            onChange={(e) => handleTermCondLabelChange(e)}
                                                                            placeholder={`Enter label text`} />
                                                                    </div>
                                                                </div>
                                                                <div className="mb-3">
                                                                    <FieldTextSize
                                                                        labelText="Font Size"
                                                                        id="termCond_fsize"
                                                                        size={templateJson.other_details.document_summary.terms_and_conditions.font_size}
                                                                        onValueChange={handleOtherTermsFontChange}
                                                                    />
                                                                </div>
                                                            </>
                                                        ) : ('')}
                                                        {/* {isTermCondSetEnabled ? (
                                                            <>
                                                                <div className="mb-3 row row-cols-2 justify-content-between">
                                                                    <label className="col-form-label col-auto" htmlFor="term_cond_label">
                                                                        Label
                                                                    </label>
                                                                    <div className="col-6">
                                                                        <input type="text" className="form-control"
                                                                            id="term_cond_label"
                                                                            name="termCond_name"
                                                                            value={termCondLabelText}
                                                                            onChange={(e) => handleTermCondLabelChange(e, setTermCondLabelText)}
                                                                            placeholder={`Enter label text`} />
                                                                    </div>
                                                                </div>
                                                                <div className="mb-3">
                                                                    <FieldTextSize
                                                                        labelText="Font Size"
                                                                        id="termCond_fsize"
                                                                        size={termCondFsize}
                                                                        onValueChange={setTermCondFsize}
                                                                    />
                                                                </div>
                                                            </>
                                                        ) : ('')} */}
                                                        <div className="mb-2 pt-2">
                                                            <div className="form-check form-check-inline">
                                                                <input type="checkbox" className="form-check-input cursor-pointer"
                                                                    id="signSetCheck"
                                                                    checked={templateJson.other_details.document_summary.signature.is_show_signature}
                                                                    onChange={signSetChange} />
                                                                <label className="form-check-label fw-semibold cursor-pointer" htmlFor="signSetCheck">Signature</label>
                                                            </div>
                                                        </div>
                                                        {templateJson.other_details.document_summary.signature.is_show_signature ? (
                                                            <>
                                                                <div className="mb-3 row row-cols-2 justify-content-between">
                                                                    <label className="col-form-label col-auto" htmlFor="sign_label">
                                                                        Label
                                                                    </label>
                                                                    <div className="col-6">
                                                                        <input type="text" className="form-control"
                                                                            id="sign_label"
                                                                            name="signLabel_name"
                                                                            value={templateJson.other_details.document_summary.signature.label_title}
                                                                            onChange={(e) => handleSignLabelChange(e)}
                                                                            placeholder={`Enter label text`} />
                                                                    </div>
                                                                </div>
                                                                <div className="mb-3">
                                                                    <label className="col-form-label mb-1" htmlFor="signImgChoose">Signature image</label>
                                                                    {!templateJson.other_details.document_summary.signature.signature_image ? (
                                                                        <>
                                                                            <div className="choose-img">
                                                                                <span className="file-upload-box file-upload-small">
                                                                                    <span className="hstack opacity-75">
                                                                                        <TbUpload size={16} />
                                                                                        <span className="ps-2 text-center fs-13">Upload your file</span>
                                                                                    </span>
                                                                                    <input
                                                                                        type="file"
                                                                                        accept="image/gif,image/jpeg,image/png,image/bmp"
                                                                                        id="signImgChoose"
                                                                                        className="file-upload-input"
                                                                                        onChange={signImgChange}
                                                                                    />
                                                                                </span>
                                                                            </div>
                                                                            {signImgError && (
                                                                                <div style={{ color: "red", marginTop: "8px" }}>
                                                                                    <small>{signImgError}</small>
                                                                                </div>
                                                                            )}
                                                                        </>
                                                                    ) : (
                                                                        <>
                                                                            <div className="selected-img d-flex justify-content-between">
                                                                                <img
                                                                                    src={templateJson.other_details.document_summary.signature.signature_image.fileimage}
                                                                                    alt="sign-img"
                                                                                    className="sign-img-prev"
                                                                                    style={{ height: "31px", width: "232px", border: "1px solid #dddddd" }}
                                                                                />
                                                                                <button type="button" onClick={removeSignImage}
                                                                                    className="btn btn-outline-light text-danger px-2 py-1"
                                                                                    style={{ textDecoration: "none", color: "red" }}>
                                                                                    <Trash size={16} />
                                                                                </button>
                                                                            </div>
                                                                        </>
                                                                    )}

                                                                </div>
                                                                <div className="mb-3 row row-cols-2 justify-content-between">
                                                                    <label className="col-form-label col-auto" htmlFor="signName_text">
                                                                        Signature Name
                                                                    </label>
                                                                    <div className="col-6">
                                                                        <input type="text" className="form-control"
                                                                            id="signName_text"
                                                                            name="signText_name"
                                                                            value={templateJson.other_details.document_summary.signature.signature_name}
                                                                            onChange={(e) => handleSignNameChange(e)} />
                                                                    </div>
                                                                </div>
                                                            </>
                                                        ) : ('')}
                                                        {/* {isSignSetEnabled ? (
                                                            <>
                                                                <div className="mb-3 row row-cols-2 justify-content-between">
                                                                    <label className="col-form-label col-auto" htmlFor="sign_label">
                                                                        Label
                                                                    </label>
                                                                    <div className="col-6">
                                                                        <input type="text" className="form-control"
                                                                            id="sign_label"
                                                                            name="signLabel_name"
                                                                            value={signLabelText}
                                                                            onChange={(e) => handleSignLabelChange(e, setSignLabelText)}
                                                                            placeholder={`Enter label text`} />
                                                                    </div>
                                                                </div>

                                                                <div className="mb-3">
                                                                    <label className="col-form-label mb-1" htmlFor="signImgChoose">Signature image</label>
                                                                    {!templateJson.other_details.document_summary.signature.signature_image ? (
                                                                        <>
                                                                            <div className="choose-img">
                                                                                <span className="file-upload-box file-upload-small">
                                                                                    <span className="hstack opacity-75">
                                                                                        <TbUpload size={16} />
                                                                                        <span className="ps-2 text-center fs-13">Upload your file</span>
                                                                                    </span>
                                                                                    <input
                                                                                        type="file"
                                                                                        accept="image/gif,image/jpeg,image/png,image/bmp"
                                                                                        id="signImgChoose"
                                                                                        className="file-upload-input"
                                                                                        onChange={signImgChange}
                                                                                    />
                                                                                </span>
                                                                            </div>
                                                                            {signImgError && (
                                                                                <div style={{ color: "red", marginTop: "8px" }}>
                                                                                    <small>{signImgError}</small>
                                                                                </div>
                                                                            )}
                                                                        </>
                                                                    ) : (
                                                                        <>
                                                                            <div className="selected-img d-flex justify-content-between">
                                                                                <img
                                                                                    src={templateJson.other_details.document_summary.signature.signature_image.fileimage}
                                                                                    alt="sign-img"
                                                                                    className="sign-img-prev"
                                                                                    style={{ height: "31px", width: "232px", border: "1px solid #dddddd" }}
                                                                                />
                                                                                <button type="button" onClick={removeSignImage}
                                                                                    className="btn btn-outline-light text-danger px-2 py-1"
                                                                                    style={{ textDecoration: "none", color: "red" }}>
                                                                                    <Trash size={16} />
                                                                                </button>
                                                                            </div>
                                                                        </>
                                                                    )}

                                                                </div>
                                                                <div className="mb-3 row row-cols-2 justify-content-between">
                                                                    <label className="col-form-label col-auto" htmlFor="signName_text">
                                                                        Signature Name
                                                                    </label>
                                                                    <div className="col-6">
                                                                        <input type="text" className="form-control"
                                                                            id="signName_text"
                                                                            name="signText_name"
                                                                            value={templateJson.other_details.document_summary.signature.signature_name}
                                                                            onChange={(e) => handleSignNameChange(e)}
                                                                        />
                                                                    </div>
                                                                </div>
                                                            </>
                                                        ) : ('')} */}
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="accordion-item mb-0">
                                                <h2 className="accordion-header">
                                                    <button className="accordion-button bg-transparent fw-medium" type="button" data-bs-toggle="collapse" data-bs-target="#odCollapseTwo" aria-expanded="false" aria-controls="odCollapseTwo">
                                                        Annexure
                                                    </button>
                                                </h2>
                                                <div id="odCollapseTwo" className="accordion-collapse collapse" data-bs-parent="#odAccordion">
                                                    <div className="accordion-body">
                                                        <p>
                                                            Click {' '}
                                                            <b>Add Annexure Content</b> to enter additional
                                                            information apart from your Terms & Conditions.
                                                            It can include by-laws, clauses and other details pertaining
                                                            to your organization. This will be included on a separate
                                                            page at the end of every Invoice.
                                                        </p>
                                                        <div className="mb-0">
                                                            <button type="button" className="btn btn-outline-secondary rounded-2 w-100"
                                                                onClick={() => handleAddAnnexureModalShow()}>
                                                                <Settings size={16} /> <span className="ps-2">Add Annexure Content</span>
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* // Left side tab with settings forms END // */}

                    <div className="temp-view flex-md-grow-1">
                        <div className="overflow-auto bg-body-tertiary h-100 temp-main">

                            <div
                                className={`temp-details bg-white ${templateJson.general.template_property.orientation === 'Landscape' ? 'orientation-landscape' : ''}`}
                                style={{ width: width, minWidth: width }}>

                                <div className="temp-section" style={{ minHeight: "800px" }}>
                                    {/* PDF output area start */}
                                    <div ref={divRef}>
                                        <div className="temp-page"
                                            style={{
                                                fontFamily: getTempFontFamily(templateJson.general.font.pdf_font),
                                                fontSize: `${templateJson.general.font.font_size}pt`, color: templateJson.general.font.font_color,
                                                backgroundColor: templateJson.general.background.bg_image ? "transparent" : templateJson.general.background.bg_color && templateJson.general.background.is_show_bg_color ? templateJson.general.background.bg_color : "transparent",
                                                backgroundImage: templateJson.general.background.bg_image ? `url(${templateJson.general.background.bg_image.fileimage})` : 'none',
                                                backgroundRepeat: "no-repeat",
                                                backgroundPosition: templateJson.general.background.image_position,
                                                backgroundSize: `${width} 100%`
                                            }}>
                                            <Loader isVisible={showLoader} isModal={true} overall={false} />
                                            <div className="temp-header"
                                                style={{
                                                    height: templateJson.header.is_apply_first_page_only ? `${templateJson.header.header_first_page}0000in` : `${templateJson.general.template_property.margins.top}0000in`,
                                                    padding: `0in ${templateJson.general.template_property.margins.right}0000in 0in ${templateJson.general.template_property.margins.left}0000in`,
                                                    fontSize: "8pt", color: "#000000",
                                                    backgroundColor: templateJson.header.bg_image ? "transparent" : templateJson.header.bg_color && templateJson.header.is_show_bg_color ? templateJson.header.bg_color : "transparent",
                                                    backgroundImage: templateJson.header.bg_image ? `url(${templateJson.header.bg_image.fileimage})` : 'none',
                                                    backgroundRepeat: "no-repeat",
                                                    backgroundPosition: templateJson.header.img_position,
                                                    backgroundSize: `${width} 100%`
                                                }}>
                                                {QTHeaderArr.map((data) => (
                                                    <div>{data}</div>
                                                ))}
                                                {/* QT-17
                                            <div>Richard</div>
                                            <div>%ContactDepartment%</div>
                                            <div className="d-flex justify-content-between">
                                                <div>30/01/2025</div>
                                                <div>11324</div>
                                            </div> */}
                                            </div>

                                            <div className="temp-body" style={{ padding: `0in ${templateJson.general.template_property.margins.right}0000in 0in ${templateJson.general.template_property.margins.left}0000in`, }}>
                                                <div className="temp-bodySection"
                                                    style={{ border: `1px solid ${templateJson.table.layout_section.table_properties.is_show_table_border ? templateJson.table.layout_section.table_properties.table_border : 'transparent'}` }}>
                                                    <table style={{ width: "100%" }}>
                                                        <tbody>
                                                            <tr>
                                                                {templateJson.organization.is_show_org_logo ? (
                                                                    <>
                                                                        <td style={{ width: "10%", padding: "2px 10px", verticalAlign: "middle" }}>
                                                                            {/* <img src={templateJson.organization.org_logo.fileimage} alt="org logo" style={{ width: "150px" }} /> */}
                                                                            {'${org_logo}'}
                                                                        </td>
                                                                    </>
                                                                    // <>
                                                                    //     {!orgImg ? (
                                                                    //         ''
                                                                    //     ) : (
                                                                    //         <>
                                                                    //             <td style={{ width: "10%", padding: "2px 10px", verticalAlign: "middle" }}>
                                                                    //                 <img src={orgImg.fileimage} alt="org logo" style={{ width: "150px" }} />
                                                                    //             </td>
                                                                    //         </>
                                                                    //     )}
                                                                    // </>
                                                                ) : ('')}
                                                                <td style={{ width: "25%", padding: "2px 10px", verticalAlign: "middle" }}>
                                                                    <div>
                                                                        <span style={{
                                                                            fontSize: `${templateJson.organization.font_size}pt`, color: templateJson.organization.font_color,
                                                                            fontWeight: "bold", display: `${templateJson.organization.is_show_org_name ? 'block' : 'none'}`
                                                                        }}
                                                                            className={`temp-orgName`}>{'${current_org}'}</span>
                                                                        {!templateJson.organization.is_show_org_address ? ('') : (
                                                                            <>
                                                                                {QTOrganizationArr.map((data) => (
                                                                                    <span className="d-block"
                                                                                        style={{ fontSize: `${templateJson.general.font.font_size}pt`, color: templateJson.general.font.font_color }}>
                                                                                        {data}
                                                                                    </span>
                                                                                ))}
                                                                            </>
                                                                            // <span className="d-block"
                                                                            //     style={{ fontSize: `${allFontSize}pt`, color: allFontColor }}>
                                                                            //     Tamilnadu <br />
                                                                            //     India <br />
                                                                            //     7894561237 <br />
                                                                            //     info@digylax.com
                                                                            // </span>
                                                                        )}
                                                                    </div>
                                                                </td>
                                                                {templateJson.document.is_show_status_stamp ? (
                                                                    <td style={{ width: "25%", textAlign: "center", padding: "2px 5px", verticalAlign: "middle" }}>
                                                                        <span class="temp-status"
                                                                            style={{ display: "inline-block", color: "#54A355", fontSize: "15pt", border: "3px solid #54A355", padding: "3px 8px" }}>
                                                                            PAID
                                                                        </span>
                                                                    </td>
                                                                ) : ('')}
                                                                <td style={{ width: "40%", padding: "5px", verticalAlign: "bottom" }} align="right">
                                                                    {!templateJson.document.is_show_document_title ? ('') : (
                                                                        <div className="temp-title" style={{ fontSize: `${templateJson.document.font_size}pt`, color: templateJson.document.font_color }}>{templateJson.document.document_title}</div>
                                                                    )}
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                    <table className="temp-detailstable" cellSpacing="0" cellPadding="0" border="0"
                                                        style={{ width: "100%", tableLayout: "fixed", wordWrap: "break-word" }}>
                                                        <thead>
                                                            <tr>
                                                                <th style={{ width: "50%" }}></th>
                                                                <th style={{ width: "50%" }}></th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            <tr>
                                                                <td style={{
                                                                    paddingBottom: "10px",
                                                                    borderTop: `1px solid ${templateJson.table.layout_section.table_properties.is_show_table_border ? templateJson.table.layout_section.table_properties.table_border : 'transparent'}`,
                                                                    borderRight: `1px solid ${templateJson.table.layout_section.table_properties.is_show_table_border ? templateJson.table.layout_section.table_properties.table_border : 'transparent'}`
                                                                }}>
                                                                    {firstArray.map((checkbox) => (
                                                                        checkbox.isChecked && (
                                                                            <div className="info" key={checkbox.id}>
                                                                                <span className="temp-label" style={{ color: templateJson.general.font.label_color }}>
                                                                                    {checkbox.value}
                                                                                </span>
                                                                                <span style={{ fontWeight: '600' }}>: {checkbox.placeholderValue}</span>
                                                                            </div>
                                                                        )
                                                                    ))}
                                                                </td>
                                                                <td style={{
                                                                    paddingBottom: "10px",
                                                                    borderTop: `1px solid ${templateJson.table.layout_section.table_properties.is_show_table_border ? templateJson.table.layout_section.table_properties.table_border : 'transparent'}`
                                                                }}>
                                                                    {secondArray.map((checkbox) => (
                                                                        checkbox.isChecked && (
                                                                            <div className="info" key={checkbox.id}>
                                                                                <span className="temp-label" style={{ color: templateJson.general.font.label_color }}>
                                                                                    {checkbox.value}
                                                                                </span>
                                                                                <span style={{ fontWeight: '600' }}>: {checkbox.placeholderValue}</span>
                                                                            </div>
                                                                        )
                                                                    ))}
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                    <div style={{ clear: "both" }}></div>
                                                    <table className="temp-addresstable" border="0" cellSpacing="0" cellPadding="0"
                                                        style={{ borderBottom: `1px solid ${templateJson.table.layout_section.table_properties.is_show_table_border ? templateJson.table.layout_section.table_properties.table_border : 'transparent'}` }}>
                                                        <thead>
                                                            <tr>
                                                                {!templateJson.customer.is_bill_to ? ('') : (
                                                                    <th style={{ borderTop: `1px solid ${templateJson.table.layout_section.table_properties.is_show_table_border ? templateJson.table.layout_section.table_properties.table_border : 'transparent'}`, borderRight: `1px solid ${templateJson.table.layout_section.table_properties.is_show_table_border ? templateJson.table.layout_section.table_properties.table_border : 'transparent'}`, borderBottom: `1px solid ${templateJson.table.layout_section.table_properties.is_show_table_border ? templateJson.table.layout_section.table_properties.table_border : 'transparent'}` }}>
                                                                        <div style={{ color: templateJson.general.font.label_color, marginBottom: "0px", display: "block" }} className="temp-label"><b>{templateJson.customer.bill_to_title}</b></div>
                                                                    </th>
                                                                )}
                                                                {!templateJson.customer.is_ship_to ? ('') : (
                                                                    <th style={{ borderTop: `1px solid ${templateJson.table.layout_section.table_properties.is_show_table_border ? templateJson.table.layout_section.table_properties.table_border : 'transparent'}`, borderBottom: `1px solid ${templateJson.table.layout_section.table_properties.is_show_table_border ? templateJson.table.layout_section.table_properties.table_border : 'transparent'}` }}>
                                                                        <div style={{ color: templateJson.general.font.label_color, marginBottom: "0px", display: "block" }} className="temp-label"><b>{templateJson.customer.ship_to_title}</b></div>
                                                                    </th>
                                                                )}
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            <tr>
                                                                {!templateJson.customer.is_bill_to ? ('') : (
                                                                    <td style={{ borderRight: `1px solid ${templateJson.table.layout_section.table_properties.is_show_table_border ? templateJson.table.layout_section.table_properties.table_border : 'transparent'}`, paddingBottom: "10px" }} valign="top">
                                                                        {QTBillToArr.map((data) => (
                                                                            <span className="d-block"
                                                                                style={{ fontSize: `${templateJson.general.font.font_size}pt`, color: templateJson.general.font.font_color }}>
                                                                                {data}
                                                                            </span>
                                                                        ))}
                                                                        {/* <span style={{ whiteSpace: "pre-wrap", lineHeight: "15px" }}>
                                                                        <strong><span className="temp-customer-name" style={{ fontSize: `${cusNameFontSize}pt`, color: cusNameFontColor }}>Rob &amp; Joe Traders</span></strong><br />
                                                                        34, Riche Street <br />
                                                                        Chennai <br />
                                                                        631603 Tamil Nadu <br />
                                                                        India <br />
                                                                    </span> */}
                                                                    </td>
                                                                )}
                                                                {!templateJson.customer.is_ship_to ? ('') : (
                                                                    <td style={{ paddingBottom: "10px" }}>
                                                                        <div>
                                                                            {QTShipToArr.map((data) => (
                                                                                <span className="d-block"
                                                                                    style={{ fontSize: `${templateJson.general.font.font_size}pt`, color: templateJson.general.font.font_color }}>
                                                                                    {data}
                                                                                </span>
                                                                            ))}
                                                                            {/* <span style={{ whiteSpace: "pre-wrap", lineHeight: "15px" }}>
                                                                            34, Riche Street <br />
                                                                            Chennai <br />
                                                                            631603 Tamil Nadu <br />
                                                                            India <br />
                                                                        </span> */}
                                                                        </div>
                                                                    </td>
                                                                )}
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                    <div style={{ clear: "both", display: 'none' }}></div>
                                                    <div className="subject-block d-none" style={{ marginTop: "0", padding: "10px" }}>
                                                        {thirdArray.map((checkbox) => (
                                                            checkbox.isChecked && (
                                                                <div className="temp-label subject-block-label" key={checkbox.id} style={{ color: templateJson.general.font.label_color }}>
                                                                    {checkbox.value} :{'${INVOICES.Subject}'}
                                                                </div>
                                                            )
                                                        ))}
                                                        <div className="subject-block-value"
                                                            style={{ whiteSpace: "pre-wrap", lineHeight: "14px" }}>
                                                            Description
                                                            {QTAttentionArr.map((data) => (
                                                                <span className="d-block"
                                                                    style={{ fontSize: `${templateJson.general.font.font_size}pt`, color: templateJson.general.font.font_color }}>
                                                                    {data}
                                                                </span>
                                                            ))}
                                                            {/* Attention content binding section */}
                                                            {/* %EstimateNumber%
                                                        %CompanyName%
                                                        %ContactEMailIds%
                                                        %FirstName%
                                                        %ContactMobile% */}
                                                        </div>
                                                    </div>
                                                    <TableContent
                                                        isTableBorderEnabled={templateJson.table.layout_section.table_properties.is_show_table_border}
                                                        tempBorderColor={templateJson.table.layout_section.table_properties.table_border}
                                                        isLineItemNumCheckEnabled={templateJson.table.labels_section.table_properties.line_item_number.is_show_line_item_number}
                                                        lineNumWidth={templateJson.table.labels_section.table_properties.line_item_number.width}
                                                        taHeadFontSize={templateJson.table.layout_section.table_properties.table_header.font_size}
                                                        taHeadFontColor={templateJson.table.layout_section.table_properties.table_header.font_color}
                                                        isTaHeadBgColorEnabled={templateJson.table.layout_section.table_properties.table_header.is_show_bg_color}
                                                        taHeadBgColor={templateJson.table.layout_section.table_properties.table_header.bg_color}
                                                        lineNumLabelText={templateJson.table.labels_section.table_properties.line_item_number.label}
                                                        itemWidth={templateJson.table.labels_section.table_properties.item.width}
                                                        isItemEnabled={templateJson.table.labels_section.table_properties.item.is_show_item}
                                                        itemLabelText={templateJson.table.labels_section.table_properties.item.label}
                                                        isDescLabelEnabled={templateJson.table.labels_section.table_properties.description.is_show_description}
                                                        descLabelText={templateJson.table.labels_section.table_properties.description.label}
                                                        isTaQtyEnabled={templateJson.table.labels_section.table_properties.quantity.is_show_quantity}
                                                        taQtyWidth={templateJson.table.labels_section.table_properties.quantity.width}
                                                        taQtyLabelText={templateJson.table.labels_section.table_properties.quantity.label}
                                                        isTaRateEnabled={templateJson.table.labels_section.table_properties.rate.is_show_rate}
                                                        taRateWidth={templateJson.table.labels_section.table_properties.rate.width}
                                                        taRateLabelText={templateJson.table.labels_section.table_properties.rate.label}
                                                        isTaDisEnabled={templateJson.table.labels_section.table_properties.discount.is_show_discount}
                                                        taDisWidth={templateJson.table.labels_section.table_properties.discount.width}
                                                        taDisLabelText={templateJson.table.labels_section.table_properties.discount.label}
                                                        isTaTaxPerEnabled={templateJson.table.labels_section.table_properties.tax.is_show_tax}
                                                        taTaxPerWidth={templateJson.table.labels_section.table_properties.tax.width}
                                                        taTaxPerLabelText={templateJson.table.labels_section.table_properties.tax.label}
                                                        isTaTaxAmtEnabled={isTaTaxAmtEnabled}
                                                        taTaxAmtWidth={taTaxAmtWidth}
                                                        taTaxAmtLabelText={taTaxAmtLabelText}
                                                        isTaAmtEnabled={templateJson.table.labels_section.table_properties.amount.is_show_amount}
                                                        taAmtWidth={templateJson.table.labels_section.table_properties.amount.width}
                                                        taAmtLabelText={templateJson.table.labels_section.table_properties.amount.label}
                                                        taBodyFontSize={templateJson.table.layout_section.table_properties.item_row.font_size}
                                                        isTaBodyBgColorEnabled={templateJson.table.layout_section.table_properties.item_row.is_show_bg_color}
                                                        tempBgImg={templateJson.general.background.bg_image}
                                                        taBodyBgColor={templateJson.table.layout_section.table_properties.item_row.bg_color}
                                                        taBodyFontColor={templateJson.table.layout_section.table_properties.item_row.font_color}
                                                        taBodyDescColor={templateJson.table.layout_section.table_properties.item_description.font_color}
                                                        taBodyDescSize={templateJson.table.layout_section.table_properties.item_description.font_size}
                                                        isTaQtyUnitEnabled={templateJson.table.labels_section.table_properties.quantity.is_show_unit}
                                                        QTItemArr={QTItemArr}
                                                        selectedModule="Invoices"
                                                    />
                                                    {/* <table style={{ width: "100%", tableLayout: "fixed", clear: "both", borderTop: `1px solid ${isTableBorderEnabled ? tempBorderColor : 'transparent'}` }}
                                                    className="temp-itemtable" cellSpacing="0" cellPadding="0" border="0">
                                                    <thead>
                                                        <tr style={{ height: "17px" }}>
                                                            {!isLineItemNumCheckEnabled ? ('') : (
                                                                <td
                                                                    style={{
                                                                        padding: "5px 5px 2px 5px", width: `${lineNumWidth}%`, textAlign: "center",
                                                                        wordWrap: "break-word", fontWeight: "normal",
                                                                        fontSize: `${taHeadFontSize}pt`, color: taHeadFontColor, backgroundColor: `${isTaHeadBgColorEnabled ? taHeadBgColor : 'transparent'}`,
                                                                        borderRight: `1px solid ${isTableBorderEnabled ? tempBorderColor : 'transparent'}`, borderBottom: `1px solid ${isTableBorderEnabled ? tempBorderColor : 'transparent'}`,
                                                                        borderLeft: "0px"
                                                                    }}
                                                                    valign="bottom" rowSpan="2" className="temp-itemtable-header temp-itemtable-breakword">
                                                                    <b>{lineNumLabelText}</b>
                                                                </td>
                                                            )}
                                                            <td
                                                                style={{
                                                                    padding: "5px 7px 2px 7px", width: `${itemWidth}%`, textAlign: "left",
                                                                    wordWrap: "break-word", fontWeight: "normal",
                                                                    fontSize: `${taHeadFontSize}pt`, color: taHeadFontColor, backgroundColor: `${isTaHeadBgColorEnabled ? taHeadBgColor : 'transparent'}`,
                                                                    borderRight: `1px solid ${isTableBorderEnabled ? tempBorderColor : 'transparent'}`, borderBottom: `1px solid ${isTableBorderEnabled ? tempBorderColor : 'transparent'}`
                                                                }}
                                                                valign="bottom" rowSpan="2" className="temp-itemtable-header temp-itemtable-breakword">
                                                                <b>
                                                                    {!isItemEnabled ? ('') : (itemLabelText)} {isItemEnabled && isDescLabelEnabled ? (<>&amp;</>) : ('')}
                                                                    {!isDescLabelEnabled ? ('') : (<>{' '} {descLabelText}</>)}
                                                                </b>
                                                            </td>
                                                            {!isTaQtyEnabled ? ('') : (
                                                                <td
                                                                    style={{
                                                                        padding: "5px 7px 2px 7px", width: `${taQtyWidth}%`, textAlign: "right",
                                                                        wordWrap: "break-word", fontWeight: "normal",
                                                                        fontSize: `${taHeadFontSize}pt`, color: taHeadFontColor, backgroundColor: `${isTaHeadBgColorEnabled ? taHeadBgColor : 'transparent'}`,
                                                                        borderRight: `1px solid ${isTableBorderEnabled ? tempBorderColor : 'transparent'}`, borderBottom: `1px solid ${isTableBorderEnabled ? tempBorderColor : 'transparent'}`
                                                                    }}
                                                                    valign="bottom" rowSpan="2" className="temp-itemtable-header temp-itemtable-breakword">
                                                                    <b>{taQtyLabelText}</b>
                                                                </td>
                                                            )}
                                                            {!isTaRateEnabled ? ('') : (
                                                                <td
                                                                    style={{
                                                                        padding: "5px 7px 2px 7px", width: `${taRateWidth}%`, textAlign: "right",
                                                                        wordWrap: "break-word", fontWeight: "normal",
                                                                        fontSize: `${taHeadFontSize}pt`, color: taHeadFontColor, backgroundColor: `${isTaHeadBgColorEnabled ? taHeadBgColor : 'transparent'}`,
                                                                        borderRight: `1px solid ${isTableBorderEnabled ? tempBorderColor : 'transparent'}`, borderBottom: `1px solid ${isTableBorderEnabled ? tempBorderColor : 'transparent'}`
                                                                    }}
                                                                    valign="bottom" rowSpan="2" className="temp-itemtable-header temp-itemtable-breakword">
                                                                    <b>{taRateLabelText}</b>
                                                                </td>
                                                            )}
                                                            {!isTaDisEnabled ? ('') : (
                                                                <td
                                                                    style={{
                                                                        padding: "5px 7px 2px 7px", width: `${taDisWidth}%`, textAlign: "right",
                                                                        wordWrap: "break-word", fontWeight: "normal",
                                                                        fontSize: `${taHeadFontSize}pt`, color: taHeadFontColor, backgroundColor: `${isTaHeadBgColorEnabled ? taHeadBgColor : 'transparent'}`,
                                                                        borderRight: `1px solid ${isTableBorderEnabled ? tempBorderColor : 'transparent'}`, borderBottom: `1px solid ${isTableBorderEnabled ? tempBorderColor : 'transparent'}`
                                                                    }}
                                                                    valign="bottom" rowSpan="2" className="temp-itemtable-header temp-itemtable-breakword">
                                                                    <b>{taDisLabelText}</b>
                                                                </td>
                                                            )}
                                                            {!isTaTaxPerEnabled ? ('') : (
                                                                <td
                                                                    style={{
                                                                        padding: "5px 7px 2px 7px", width: `${taTaxPerWidth}%`, textAlign: "right",
                                                                        wordWrap: "break-word", fontWeight: "normal",
                                                                        fontSize: `${taHeadFontSize}pt`, color: taHeadFontColor, backgroundColor: `${isTaHeadBgColorEnabled ? taHeadBgColor : 'transparent'}`,
                                                                        borderRight: `1px solid ${isTableBorderEnabled ? tempBorderColor : 'transparent'}`, borderBottom: `1px solid ${isTableBorderEnabled ? tempBorderColor : 'transparent'}`
                                                                    }}
                                                                    valign="bottom" rowSpan="2" className="temp-itemtable-header temp-itemtable-breakword">
                                                                    <b>{taTaxPerLabelText}</b>
                                                                </td>
                                                            )}
                                                            {!isTaTaxAmtEnabled ? ('') : (
                                                                <td
                                                                    style={{
                                                                        padding: "5px 7px 2px 7px", width: `${taTaxAmtWidth}%`, textAlign: "right",
                                                                        wordWrap: "break-word", fontWeight: "normal",
                                                                        fontSize: `${taHeadFontSize}pt`, color: taHeadFontColor, backgroundColor: `${isTaHeadBgColorEnabled ? taHeadBgColor : 'transparent'}`,
                                                                        borderRight: `1px solid ${isTableBorderEnabled ? tempBorderColor : 'transparent'}`, borderBottom: `1px solid ${isTableBorderEnabled ? tempBorderColor : 'transparent'}`
                                                                    }}
                                                                    valign="bottom" rowSpan="2" className="temp-itemtable-header temp-itemtable-breakword">
                                                                    <b>{taTaxAmtLabelText}</b>
                                                                </td>
                                                            )}
                                                            {!isTaAmtEnabled ? ('') : (
                                                                <td
                                                                    style={{
                                                                        padding: "5px 7px 2px 7px", width: `${taAmtWidth}%`, textAlign: "right",
                                                                        wordWrap: "break-word", fontWeight: "normal",
                                                                        fontSize: `${taHeadFontSize}pt`, color: taHeadFontColor, backgroundColor: `${isTaHeadBgColorEnabled ? taHeadBgColor : 'transparent'}`,
                                                                        borderRight: `1px solid ${isTableBorderEnabled ? tempBorderColor : 'transparent'}`, borderBottom: `1px solid ${isTableBorderEnabled ? tempBorderColor : 'transparent'}`,
                                                                        borderRight: "0px"
                                                                    }}
                                                                    valign="bottom" rowSpan="2" className="temp-itemtable-header temp-itemtable-breakword">
                                                                    <b>{taAmtLabelText}</b>
                                                                </td>
                                                            )}
                                                        </tr>
                                                    </thead>
                                                    <tbody className="itemBody">
                                                        <tr className="breakrow-inside breakrow-after" style={{ height: "20px", pageBreakAfter: "auto", pageBreakInside: "avoid" }}>
                                                            {!isLineItemNumCheckEnabled ? ('') : (
                                                                <td valign="top" className="temp-item-row"
                                                                    style={{
                                                                        textAlign: "center", padding: "1px 5px", wordWrap: "break-word",
                                                                        borderRight: `1px solid ${isTableBorderEnabled ? tempBorderColor : 'transparent'}`, borderBottom: `1px solid ${isTableBorderEnabled ? tempBorderColor : 'transparent'}`,
                                                                        fontSize: `${taBodyFontSize}pt`, backgroundColor: `${isTaBodyBgColorEnabled && !tempBgImg ? taBodyBgColor : 'transparent'}`, color: taBodyFontColor,
                                                                        borderLeft: "0"
                                                                    }}>
                                                                    1
                                                                </td>
                                                            )}
                                                            <td valign="top" className="temp-item-row"
                                                                style={{
                                                                    padding: "1px 5px", wordWrap: "break-word",
                                                                    borderRight: `1px solid ${isTableBorderEnabled ? tempBorderColor : 'transparent'}`, borderBottom: `1px solid ${isTableBorderEnabled ? tempBorderColor : 'transparent'}`,
                                                                    fontSize: `${taBodyFontSize}pt`, backgroundColor: `${isTaBodyBgColorEnabled && !tempBgImg ? taBodyBgColor : 'transparent'}`, color: taBodyFontColor
                                                                }}>
                                                                <div>
                                                                    <span style={{ wordWrap: "break-word" }}>Brochure Design</span><br />
                                                                    <span style={{ whiteSpace: "pre-wrap", wordWrap: "break-word", color: taBodyDescColor, fontSize: `${taBodyDescSize}pt` }} className="temp-item-desc">Brochure Design Single Sided Color</span><br />
                                                                </div>
                                                            </td>
                                                            {!isTaQtyEnabled ? ('') : (
                                                                <td valign="top" className="temp-item-row"
                                                                    style={{
                                                                        textAlign: "right", padding: "1px 5px", wordWrap: "break-word",
                                                                        borderRight: `1px solid ${isTableBorderEnabled ? tempBorderColor : 'transparent'}`, borderBottom: `1px solid ${isTableBorderEnabled ? tempBorderColor : 'transparent'}`,
                                                                        fontSize: `${taBodyFontSize}pt`, backgroundColor: `${isTaBodyBgColorEnabled && !tempBgImg ? taBodyBgColor : 'transparent'}`, color: taBodyFontColor
                                                                    }}>
                                                                    1.00
                                                                    {!isTaQtyUnitEnabled ? ('') : (<div>Nos</div>)}
                                                                </td>
                                                            )}
                                                            {!isTaRateEnabled ? ('') : (
                                                                <td valign="top" className="temp-item-row"
                                                                    style={{
                                                                        textAlign: "right", padding: "1px 5px", wordWrap: "break-word",
                                                                        borderRight: `1px solid ${isTableBorderEnabled ? tempBorderColor : 'transparent'}`, borderBottom: `1px solid ${isTableBorderEnabled ? tempBorderColor : 'transparent'}`,
                                                                        fontSize: `${taBodyFontSize}pt`, backgroundColor: `${isTaBodyBgColorEnabled && !tempBgImg ? taBodyBgColor : 'transparent'}`, color: taBodyFontColor
                                                                    }}>
                                                                    300.00
                                                                </td>
                                                            )}
                                                            {!isTaDisEnabled ? ('') : (
                                                                <td valign="top" className="temp-item-row"
                                                                    style={{
                                                                        textAlign: "right", padding: "1px 5px", wordWrap: "break-word",
                                                                        borderRight: `1px solid ${isTableBorderEnabled ? tempBorderColor : 'transparent'}`, borderBottom: `1px solid ${isTableBorderEnabled ? tempBorderColor : 'transparent'}`,
                                                                        fontSize: `${taBodyFontSize}pt`, backgroundColor: `${isTaBodyBgColorEnabled && !tempBgImg ? taBodyBgColor : 'transparent'}`, color: taBodyFontColor
                                                                    }}>
                                                                    0.00
                                                                </td>
                                                            )}
                                                            {!isTaTaxPerEnabled ? ('') : (
                                                                <td valign="top" className="temp-item-row"
                                                                    style={{
                                                                        textAlign: "right", padding: "1px 5px", wordWrap: "break-word",
                                                                        borderRight: `1px solid ${isTableBorderEnabled ? tempBorderColor : 'transparent'}`, borderBottom: `1px solid ${isTableBorderEnabled ? tempBorderColor : 'transparent'}`,
                                                                        fontSize: `${taBodyFontSize}pt`, backgroundColor: `${isTaBodyBgColorEnabled && !tempBgImg ? taBodyBgColor : 'transparent'}`, color: taBodyFontColor
                                                                    }}>
                                                                    <span>7.00%</span>
                                                                </td>
                                                            )}
                                                            {!isTaTaxAmtEnabled ? ('') : (
                                                                <td valign="top" className="temp-item-row"
                                                                    style={{
                                                                        textAlign: "right", padding: "1px 5px", wordWrap: "break-word",
                                                                        borderRight: `1px solid ${isTableBorderEnabled ? tempBorderColor : 'transparent'}`, borderBottom: `1px solid ${isTableBorderEnabled ? tempBorderColor : 'transparent'}`,
                                                                        fontSize: `${taBodyFontSize}pt`, backgroundColor: `${isTaBodyBgColorEnabled && !tempBgImg ? taBodyBgColor : 'transparent'}`, color: taBodyFontColor
                                                                    }}>
                                                                    <span>21.00</span>
                                                                </td>
                                                            )}
                                                            {!isTaAmtEnabled ? ('') : (
                                                                <td valign="top" className="temp-item-row"
                                                                    style={{
                                                                        textAlign: "right", padding: "1px 5px", wordWrap: "break-word",
                                                                        borderRight: `1px solid ${isTableBorderEnabled ? tempBorderColor : 'transparent'}`, borderBottom: `1px solid ${isTableBorderEnabled ? tempBorderColor : 'transparent'}`,
                                                                        fontSize: `${taBodyFontSize}pt`, backgroundColor: `${isTaBodyBgColorEnabled && !tempBgImg ? taBodyBgColor : 'transparent'}`, color: taBodyFontColor,
                                                                        borderRight: "0"
                                                                    }}>
                                                                    300.00
                                                                </td>
                                                            )}
                                                        </tr>
                                                        <tr className="breakrow-inside breakrow-after" style={{ height: "20px", pageBreakAfter: "auto", pageBreakInside: "avoid" }}>
                                                            {!isLineItemNumCheckEnabled ? ('') : (
                                                                <td valign="top" className="temp-item-row"
                                                                    style={{
                                                                        textAlign: "center", padding: "1px 5px", wordWrap: "break-word",
                                                                        borderRight: `1px solid ${isTableBorderEnabled ? tempBorderColor : 'transparent'}`, borderBottom: `1px solid ${isTableBorderEnabled ? tempBorderColor : 'transparent'}`,
                                                                        fontSize: `${taBodyFontSize}pt`, backgroundColor: `${isTaBodyBgColorEnabled && !tempBgImg ? taBodyBgColor : 'transparent'}`, color: taBodyFontColor,
                                                                        borderLeft: "0"
                                                                    }}>
                                                                    2
                                                                </td>
                                                            )}
                                                            <td valign="top" className="temp-item-row"
                                                                style={{
                                                                    padding: "1px 5px", wordWrap: "break-word",
                                                                    borderRight: `1px solid ${isTableBorderEnabled ? tempBorderColor : 'transparent'}`, borderBottom: `1px solid ${isTableBorderEnabled ? tempBorderColor : 'transparent'}`,
                                                                    fontSize: `${taBodyFontSize}pt`, backgroundColor: `${isTaBodyBgColorEnabled && !tempBgImg ? taBodyBgColor : 'transparent'}`, color: taBodyFontColor
                                                                }}>
                                                                <div>
                                                                    <span style={{ wordWrap: "break-word" }}>Web Design Packages(Template) - Basic</span><br />
                                                                    <span style={{ whiteSpace: "pre-wrap", wordWrap: "break-word", color: taBodyDescColor, fontSize: `${taBodyDescSize}pt` }} className="temp-item-desc">Custom Themes for your business. Inclusive of 10 hours of marketing and annual training</span><br />
                                                                </div>
                                                            </td>
                                                            {!isTaQtyEnabled ? ('') : (
                                                                <td valign="top" className="temp-item-row"
                                                                    style={{
                                                                        textAlign: "right", padding: "1px 5px", wordWrap: "break-word",
                                                                        borderRight: `1px solid ${isTableBorderEnabled ? tempBorderColor : 'transparent'}`, borderBottom: `1px solid ${isTableBorderEnabled ? tempBorderColor : 'transparent'}`,
                                                                        fontSize: `${taBodyFontSize}pt`, backgroundColor: `${isTaBodyBgColorEnabled && !tempBgImg ? taBodyBgColor : 'transparent'}`, color: taBodyFontColor
                                                                    }}>
                                                                    1.00
                                                                    {!isTaQtyUnitEnabled ? ('') : (<div>Nos</div>)}
                                                                </td>
                                                            )}
                                                            {!isTaRateEnabled ? ('') : (
                                                                <td valign="top" className="temp-item-row"
                                                                    style={{
                                                                        textAlign: "right", padding: "1px 5px", wordWrap: "break-word",
                                                                        borderRight: `1px solid ${isTableBorderEnabled ? tempBorderColor : 'transparent'}`, borderBottom: `1px solid ${isTableBorderEnabled ? tempBorderColor : 'transparent'}`,
                                                                        fontSize: `${taBodyFontSize}pt`, backgroundColor: `${isTaBodyBgColorEnabled && !tempBgImg ? taBodyBgColor : 'transparent'}`, color: taBodyFontColor
                                                                    }}>
                                                                    250.00
                                                                </td>
                                                            )}
                                                            {!isTaDisEnabled ? ('') : (
                                                                <td valign="top" className="temp-item-row"
                                                                    style={{
                                                                        textAlign: "right", padding: "1px 5px", wordWrap: "break-word",
                                                                        borderRight: `1px solid ${isTableBorderEnabled ? tempBorderColor : 'transparent'}`, borderBottom: `1px solid ${isTableBorderEnabled ? tempBorderColor : 'transparent'}`,
                                                                        fontSize: `${taBodyFontSize}pt`, backgroundColor: `${isTaBodyBgColorEnabled && !tempBgImg ? taBodyBgColor : 'transparent'}`, color: taBodyFontColor
                                                                    }}>
                                                                    0.00
                                                                </td>
                                                            )}
                                                            {!isTaTaxPerEnabled ? ('') : (
                                                                <td valign="top" className="temp-item-row"
                                                                    style={{
                                                                        textAlign: "right", padding: "1px 5px", wordWrap: "break-word",
                                                                        borderRight: `1px solid ${isTableBorderEnabled ? tempBorderColor : 'transparent'}`, borderBottom: `1px solid ${isTableBorderEnabled ? tempBorderColor : 'transparent'}`,
                                                                        fontSize: `${taBodyFontSize}pt`, backgroundColor: `${isTaBodyBgColorEnabled && !tempBgImg ? taBodyBgColor : 'transparent'}`, color: taBodyFontColor
                                                                    }}>
                                                                    <span>4.70%</span>
                                                                </td>
                                                            )}
                                                            {!isTaTaxAmtEnabled ? ('') : (
                                                                <td valign="top" className="temp-item-row"
                                                                    style={{
                                                                        textAlign: "right", padding: "1px 5px", wordWrap: "break-word",
                                                                        borderRight: `1px solid ${isTableBorderEnabled ? tempBorderColor : 'transparent'}`, borderBottom: `1px solid ${isTableBorderEnabled ? tempBorderColor : 'transparent'}`,
                                                                        fontSize: `${taBodyFontSize}pt`, backgroundColor: `${isTaBodyBgColorEnabled && !tempBgImg ? taBodyBgColor : 'transparent'}`, color: taBodyFontColor
                                                                    }}>
                                                                    <span>11.75</span>
                                                                </td>
                                                            )}
                                                            {!isTaAmtEnabled ? ('') : (
                                                                <td valign="top" className="temp-item-row"
                                                                    style={{
                                                                        textAlign: "right", padding: "1px 5px", wordWrap: "break-word",
                                                                        borderRight: `1px solid ${isTableBorderEnabled ? tempBorderColor : 'transparent'}`, borderBottom: `1px solid ${isTableBorderEnabled ? tempBorderColor : 'transparent'}`,
                                                                        fontSize: `${taBodyFontSize}pt`, backgroundColor: `${isTaBodyBgColorEnabled && !tempBgImg ? taBodyBgColor : 'transparent'}`, color: taBodyFontColor,
                                                                        borderRight: "0"
                                                                    }}>
                                                                    250.00
                                                                </td>
                                                            )}
                                                        </tr>
                                                        <tr className="breakrow-inside breakrow-after" style={{ height: "20px", pageBreakAfter: "auto", pageBreakInside: "avoid" }}>
                                                            {!isLineItemNumCheckEnabled ? ('') : (
                                                                <td valign="top" className="temp-item-row"
                                                                    style={{
                                                                        textAlign: "center", padding: "1px 5px", wordWrap: "break-word",
                                                                        borderRight: `1px solid ${isTableBorderEnabled ? tempBorderColor : 'transparent'}`, borderBottom: `1px solid ${isTableBorderEnabled ? tempBorderColor : 'transparent'}`,
                                                                        fontSize: `${taBodyFontSize}pt`, backgroundColor: `${isTaBodyBgColorEnabled && !tempBgImg ? taBodyBgColor : 'transparent'}`, color: taBodyFontColor,
                                                                        borderLeft: "0"
                                                                    }}>
                                                                    3
                                                                </td>
                                                            )}
                                                            <td valign="top" className="temp-item-row"
                                                                style={{
                                                                    padding: "1px 5px", wordWrap: "break-word",
                                                                    borderRight: `1px solid ${isTableBorderEnabled ? tempBorderColor : 'transparent'}`, borderBottom: `1px solid ${isTableBorderEnabled ? tempBorderColor : 'transparent'}`,
                                                                    fontSize: `${taBodyFontSize}pt`, backgroundColor: `${isTaBodyBgColorEnabled && !tempBgImg ? taBodyBgColor : 'transparent'}`, color: taBodyFontColor
                                                                }}>
                                                                <div>
                                                                    <span style={{ wordWrap: "break-word" }}>Print Ad - Basic - Color</span><br />
                                                                    <span style={{ whiteSpace: "pre-wrap", wordWrap: "break-word", color: taBodyDescColor, fontSize: `${taBodyDescSize}pt` }} className="temp-item-desc">Print Ad 1/8 size Color</span><br />
                                                                </div>
                                                            </td>
                                                            {!isTaQtyEnabled ? ('') : (
                                                                <td valign="top" className="temp-item-row"
                                                                    style={{
                                                                        textAlign: "right", padding: "1px 5px", wordWrap: "break-word",
                                                                        borderRight: `1px solid ${isTableBorderEnabled ? tempBorderColor : 'transparent'}`, borderBottom: `1px solid ${isTableBorderEnabled ? tempBorderColor : 'transparent'}`,
                                                                        fontSize: `${taBodyFontSize}pt`, backgroundColor: `${isTaBodyBgColorEnabled && !tempBgImg ? taBodyBgColor : 'transparent'}`, color: taBodyFontColor
                                                                    }}>
                                                                    1.00
                                                                    {!isTaQtyUnitEnabled ? ('') : (<div>Nos</div>)}
                                                                </td>
                                                            )}
                                                            {!isTaRateEnabled ? ('') : (
                                                                <td valign="top" className="temp-item-row"
                                                                    style={{
                                                                        textAlign: "right", padding: "1px 5px", wordWrap: "break-word",
                                                                        borderRight: `1px solid ${isTableBorderEnabled ? tempBorderColor : 'transparent'}`, borderBottom: `1px solid ${isTableBorderEnabled ? tempBorderColor : 'transparent'}`,
                                                                        fontSize: `${taBodyFontSize}pt`, backgroundColor: `${isTaBodyBgColorEnabled && !tempBgImg ? taBodyBgColor : 'transparent'}`, color: taBodyFontColor
                                                                    }}>
                                                                    80.00
                                                                </td>
                                                            )}
                                                            {!isTaDisEnabled ? ('') : (
                                                                <td valign="top" className="temp-item-row"
                                                                    style={{
                                                                        textAlign: "right", padding: "1px 5px", wordWrap: "break-word",
                                                                        borderRight: `1px solid ${isTableBorderEnabled ? tempBorderColor : 'transparent'}`, borderBottom: `1px solid ${isTableBorderEnabled ? tempBorderColor : 'transparent'}`,
                                                                        fontSize: `${taBodyFontSize}pt`, backgroundColor: `${isTaBodyBgColorEnabled && !tempBgImg ? taBodyBgColor : 'transparent'}`, color: taBodyFontColor
                                                                    }}>
                                                                    0.00
                                                                </td>
                                                            )}
                                                            {!isTaTaxPerEnabled ? ('') : (
                                                                <td valign="top" className="temp-item-row"
                                                                    style={{
                                                                        textAlign: "right", padding: "1px 5px", wordWrap: "break-word",
                                                                        borderRight: `1px solid ${isTableBorderEnabled ? tempBorderColor : 'transparent'}`, borderBottom: `1px solid ${isTableBorderEnabled ? tempBorderColor : 'transparent'}`,
                                                                        fontSize: `${taBodyFontSize}pt`, backgroundColor: `${isTaBodyBgColorEnabled && !tempBgImg ? taBodyBgColor : 'transparent'}`, color: taBodyFontColor
                                                                    }}>
                                                                    <span></span>
                                                                </td>
                                                            )}
                                                            {!isTaTaxAmtEnabled ? ('') : (
                                                                <td valign="top" className="temp-item-row"
                                                                    style={{
                                                                        textAlign: "right", padding: "1px 5px", wordWrap: "break-word",
                                                                        borderRight: `1px solid ${isTableBorderEnabled ? tempBorderColor : 'transparent'}`, borderBottom: `1px solid ${isTableBorderEnabled ? tempBorderColor : 'transparent'}`,
                                                                        fontSize: `${taBodyFontSize}pt`, backgroundColor: `${isTaBodyBgColorEnabled && !tempBgImg ? taBodyBgColor : 'transparent'}`, color: taBodyFontColor
                                                                    }}>
                                                                    <span></span>
                                                                </td>
                                                            )}
                                                            {!isTaAmtEnabled ? ('') : (
                                                                <td valign="top" className="temp-item-row"
                                                                    style={{
                                                                        textAlign: "right", padding: "1px 5px", wordWrap: "break-word",
                                                                        borderRight: `1px solid ${isTableBorderEnabled ? tempBorderColor : 'transparent'}`, borderBottom: `1px solid ${isTableBorderEnabled ? tempBorderColor : 'transparent'}`,
                                                                        fontSize: `${taBodyFontSize}pt`, backgroundColor: `${isTaBodyBgColorEnabled && !tempBgImg ? taBodyBgColor : 'transparent'}`, color: taBodyFontColor,
                                                                        borderRight: "0"
                                                                    }}>
                                                                    80.00
                                                                </td>
                                                            )}
                                                        </tr>
                                                    </tbody>
                                                </table> */}
                                                    <div style={{ width: "100%", marginTop: "1px" }}>
                                                        <div style={{ width: "50%", padding: "4px 4px 6px 7px", float: "left" }}>
                                                            {isTotalQtySetEnabled ? (
                                                                <div style={{ margin: "3px 0 5px" }}>
                                                                    <div>
                                                                        <span style={{
                                                                            fontSize: `${templateJson.total.layout_section.total.font_size}pt`,
                                                                            color: templateJson.total.layout_section.total.font_color,
                                                                            backgroundColor: `${templateJson.total.layout_section.total.is_show_bg_color && !templateJson.general.background.bg_image ? templateJson.total.layout_section.total.bg_color : 'transparent'}`,
                                                                            marginBottom: "6.5px", display: "inline-block"
                                                                        }}
                                                                            className="temp-totals">{itemsTotalLabelText}</span>{' '}
                                                                        <span>3.00</span>
                                                                    </div>
                                                                </div>
                                                            ) : ('')}
                                                            <div style={{ margin: "10px 0 5px" }}>
                                                                <div style={{ color: templateJson.general.font.label_color, paddingRight: "10px" }}>Total Tax Amount
                                                                    <span>{"${TotalTaxAmount}"}</span>
                                                                </div>
                                                            </div>
                                                            {isAmtShowWordsEnabled ? (
                                                                <div style={{ margin: "10px 0 5px" }}>
                                                                    <div style={{ color: templateJson.general.font.label_color, paddingRight: "10px" }}>Total In Words</div>
                                                                    <span>
                                                                        <b>
                                                                            <i>{"${TotalInWords}"}</i>
                                                                            {/* <i>Indian Rupee Six Hundred Sixty-Two and Seventy-Five Paise Only</i> */}
                                                                        </b>
                                                                    </span>
                                                                </div>
                                                            ) : ('')}
                                                            <div style={{ paddingTop: "10px" }}>
                                                                <span style={{ color: templateJson.general.font.label_color }} className="temp-label">{notesLabelText}</span>
                                                                <p style={{ fontSize: `${notesFsize}pt`, fontFamily: "inherit", whiteSpace: "pre-wrap", wordWrap: "break-word" }}
                                                                    className="temp-notes">
                                                                    {/* Looking forward for your business. */}
                                                                    {'${INVOICES.Notes}'}
                                                                </p>
                                                            </div>
                                                            {isOnlinePayLinkEnabled ? (
                                                                <div style={{ marginTop: "20px" }}>
                                                                    <div style={{ marginTop: "10px", pageBreakInside: "avoid" }}>
                                                                        <span style={{
                                                                            color: templateJson.general.font.label_color,
                                                                            paddingRight: "8px", display: "inline-block", verticalAlign: "middle"
                                                                        }}>
                                                                            {onlinePayLinkText}
                                                                        </span>
                                                                        <img src={paymentIcon}
                                                                            style={{ width: "95px", height: "17px", cursor: "pointer", verticalAlign: "middle" }} />
                                                                    </div>
                                                                </div>
                                                            ) : ('')}
                                                            {/* Bank Details section */}
                                                            {/* <div style={{marginTop:"10px", width:"100%",wordWrap:"break-word"}} className="bank-details-section"><div>%SalesPersonName%</div><div>%SalesEmail%</div><div>%CompanyStreetAddress1%</div><div>%CompanyStreetAddress2%</div><div>%CompanyCountry%</div><div>%CompanyPhoneNumber%</div></div> */}
                                                            {/* // END Bank Details section // */}
                                                            {isTermCondSetEnabled ? (
                                                                <div style={{ clear: "both", marginTop: "20px", width: "100%" }}>
                                                                    <div style={{ color: templateJson.general.font.label_color }} className="temp-label">{termCondLabelText}</div>
                                                                    {/* <div style={{ fontSize: `${termCondFsize}pt`, whiteSpace: "pre-wrap", wordWrap: "break-word" }} className="temp-terms">
                                                                        Your company's Terms and Conditions will be displayed here.
                                                                        You can add it in the Invoice Preferences page under Settings.
                                                                    </div> */}
                                                                    {"${INVOICES.Terms and Conditions}"}
                                                                </div>
                                                            ) : ('')}
                                                        </div>
                                                        <div style={{
                                                            width: "43.6%", float: "right",
                                                            fontSize: `${templateJson.total.layout_section.total.font_size}pt`,
                                                            color: templateJson.total.layout_section.total.font_color,
                                                            backgroundColor: `${templateJson.total.layout_section.total.is_show_bg_color && !templateJson.general.background.bg_image ? templateJson.total.layout_section.total.bg_color : 'transparent'}`
                                                        }} className="temp-totals">
                                                            <table style={templateJson.total.labels_section.is_show_total_section ? { borderLeft: `1px solid ${templateJson.table.layout_section.table_properties.is_show_table_border ? templateJson.table.layout_section.table_properties.table_border : 'transparent'}` } : {}}
                                                                className="temp-totaltable"
                                                                cellSpacing="0" border="0" width="100%">
                                                                {templateJson.total.labels_section.is_show_total_section ? (
                                                                    <tbody>
                                                                        {templateJson.total.labels_section.is_show_sub_total ? (
                                                                            <tr>
                                                                                <td valign="middle" style={{ padding: "4px 7px 0", textAlign: "right" }}>{templateJson.total.labels_section.sub_total_title}</td>
                                                                                <td valign="middle" style={{ padding: "4px 7px 0", textAlign: "right", width: "110px" }}>{'${Sub Total}'}</td>
                                                                            </tr>
                                                                        ) : ('')}
                                                                        {templateJson.total.labels_section.is_show_discount ? (
                                                                            <tr>
                                                                                <td valign="middle" style={{ padding: "4px 7px 0", textAlign: "right" }}>Discount</td>
                                                                                <td valign="middle" style={{ padding: "4px 7px 0", textAlign: "right", width: "110px" }}>
                                                                                    {'${Discount}'}
                                                                                </td>
                                                                            </tr>
                                                                        ) : ('')}
                                                                        {/* {isToTaxAmtEnabled ? (
                                                                            <tr style={{ height: "10px" }}>
                                                                                <td valign="middle" align="right" style={{ padding: "4px 7px 0", textAlign: "right" }}>{toTaxAmtLabelText}</td>
                                                                                <td valign="middle" style={{ padding: "4px 7px 0", textAlign: "right", width: "110px" }}>{"${Tax}"}</td>
                                                                            </tr>
                                                                        ) : ('')} */}
                                                                        {templateJson.total.labels_section.is_show_tax ? (
                                                                            <tr style={{ height: "10px" }}>
                                                                                <td valign="middle" align="right" style={{ padding: "4px 7px 0", textAlign: "right" }}>{templateJson.total.labels_section.tax_title}</td>
                                                                                <td valign="middle" style={{ padding: "4px 7px 0", textAlign: "right", width: "110px" }}> {"${Tax Amount}"}</td>
                                                                            </tr>
                                                                        ) : ('')}
                                                                        {templateJson.total.labels_section.is_show_adjustment ? (
                                                                            <tr>
                                                                                <td valign="middle" style={{ padding: "4px 7px 0", textAlign: "right" }}>Adjustment</td>
                                                                                <td valign="middle" style={{ padding: "4px 7px 0", textAlign: "right", width: "110px" }}>
                                                                                    {'${Adjustment}'}
                                                                                </td>
                                                                            </tr>
                                                                        ) : ('')}
                                                                        {isShowTaxDetailEnabled ? (
                                                                            <>
                                                                                <tr style={{ height: "10px" }}>
                                                                                    <td valign="middle" align="right" style={{ padding: "4px 7px 0", textAlign: "right" }}>Sample Tax1 (4.70%)</td>
                                                                                    <td valign="middle" style={{ padding: "4px 7px 0", textAlign: "right", width: "110px" }}>11.75</td>
                                                                                </tr>
                                                                                <tr style={{ height: "10px" }}>
                                                                                    <td valign="middle" align="right" style={{ padding: "4px 7px 0", textAlign: "right" }}>Sample Tax2 (7.00%)</td>
                                                                                    <td valign="middle" style={{ padding: "4px 7px 0", textAlign: "right", width: "110px" }}>21.00</td>
                                                                                </tr>
                                                                            </>
                                                                        ) : ('')}
                                                                        {/* {isMainTotalEnabled ? (
                                                                            <tr>
                                                                                <td valign="middle" style={{ padding: "4px 7px 0", textAlign: "right" }}><b>{mainTotalText}</b></td>
                                                                                <td valign="middle" style={{ padding: "4px 7px 0", textAlign: "right", width: "110px" }}>
                                                                                    <b>
                                                                                        {selectedCurSymbolPos === "beforeAmt" ? "₹" : ""}
                                                                                        {"${Total}"}
                                                                                        {selectedCurSymbolPos === "afterAmt" ? "₹" : ""}
                                                                                    </b>
                                                                                </td>
                                                                            </tr>
                                                                        ) : ('')} */}
                                                                        {templateJson.total.labels_section.is_show_total ? (
                                                                            <tr>
                                                                                <td valign="middle" style={{ padding: "4px 7px 0", textAlign: "right" }}><b>{templateJson.total.labels_section.total_title}</b></td>
                                                                                <td valign="middle" style={{ padding: "4px 7px 0", textAlign: "right", width: "110px" }}>
                                                                                    <b>
                                                                                        {templateJson.total.labels_section.currency_symbol_title === "beforeAmt" && "${Symbol}"}
                                                                                        {"${Grand Total}"}
                                                                                        {templateJson.total.labels_section.currency_symbol_title === "afterAmt" && "${Symbol}"}
                                                                                    </b>
                                                                                </td>
                                                                            </tr>
                                                                        ) : ('')}

                                                                        {isPayDetailSetEnabled ? (
                                                                            <>
                                                                                <tr style={{ height: "10px" }}>
                                                                                    <td valign="middle">{payMadeLabel}</td>
                                                                                    <td valign="middle" style={{ width: "110px", color: "red" }}>(-) {"${Payment Made}"}</td>
                                                                                    {/* <td valign="middle" style={{ width: "110px", color: "red" }}>(-) 100.00</td> */}
                                                                                </tr>
                                                                                <tr style={{
                                                                                    height: "10px",
                                                                                    fontSize: `${balDueSecFsize}pt`, color: balDueSecFcolor, backgroundColor: balDueSecBgColor
                                                                                }}>
                                                                                    <td valign="middle"><b>{balDueAmtLabel}</b></td>
                                                                                    <td valign="middle" style={{ width: "110px" }}>
                                                                                        <strong>
                                                                                            {templateJson.total.labels_section.currency_symbol_title === "beforeAmt" && "${Symbol}"}
                                                                                            {"${Balance Due}"}
                                                                                            {templateJson.total.labels_section.currency_symbol_title === "afterAmt" && "${Symbol}"}
                                                                                        </strong>
                                                                                    </td>
                                                                                </tr>
                                                                            </>
                                                                        ) : ('')}
                                                                        <tr>
                                                                            <td style={{ borderBottom: `1px solid ${templateJson.table.layout_section.table_properties.is_show_table_border ? templateJson.table.layout_section.table_properties.table_border : 'transparent'}` }} colSpan="2"></td>
                                                                        </tr>
                                                                    </tbody>
                                                                ) : ('')}
                                                                {templateJson.other_details.document_summary.signature.is_show_signature ? (
                                                                    <tbody>
                                                                        <tr>
                                                                            <td style={{ textAlign: "center", paddingTop: "5px" }} colSpan="2">
                                                                                {templateJson.other_details.document_summary.signature.signature_name &&
                                                                                    <div style={{ paddingRight: "5px" }} className="temp-totals">{'${signature_name}'}</div>
                                                                                }
                                                                                {templateJson.other_details.document_summary.signature.signature_image ? (
                                                                                    <>{'${signature_image}'}</>
                                                                                ) : (
                                                                                    <div style={{ minHeight: "75px" }}></div>
                                                                                )}
                                                                                {/* {templateJson.other_details.document_summary.signature.signature_image ? (
                                                                                        <img src={templateJson.other_details.document_summary.signature.signature_image.fileimage} style={{ maxWidth: "240px", maxHeight: "240px" }} />
                                                                                    ) : (
                                                                                        <div style={{ minHeight: "75px" }}></div>
                                                                                    )} */}
                                                                            </td>
                                                                            {/* <td style={{ textAlign: "center", paddingTop: "5px" }} colSpan="2">
                                                                                    <div style={{ paddingRight: "5px" }} className="temp-totals">{templateJson.other_details.document_summary.signature.signature_name}</div>
                                                                                    {templateJson.other_details.document_summary.signature.signature_image ? (
                                                                                        <img src={templateJson.other_details.document_summary.signature.signature_image.fileimage} style={{ maxWidth: "240px", maxHeight: "240px" }} />
                                                                                    ) : (
                                                                                        <div style={{ minHeight: "75px" }}></div>
                                                                                    )}
                                                                                </td> */}
                                                                        </tr>
                                                                        <tr>
                                                                            <td colSpan="2"
                                                                                style={templateJson.total.labels_section.is_show_total_section ? { borderBottom: `1px solid ${templateJson.table.layout_section.table_properties.is_show_table_border ? templateJson.table.layout_section.table_properties.table_border : 'transparent'}`, textAlign: "center" } : {}}>
                                                                                <div style={{
                                                                                    fontSize: `${templateJson.total.layout_section.total.font_size}pt`,
                                                                                    color: templateJson.total.layout_section.total.font_color,
                                                                                    backgroundColor: `${templateJson.total.layout_section.total.is_show_bg_color && !templateJson.general.background.bg_image ? templateJson.total.layout_section.total.bg_color : 'transparent'}`,
                                                                                    textAlign: "center"
                                                                                }}
                                                                                    className="temp-totals">{templateJson.other_details.document_summary.signature.label_title}</div>
                                                                            </td>
                                                                        </tr>
                                                                    </tbody>
                                                                ) : ('')}
                                                                {/* {isSignSetEnabled ? (
                                                                    <tbody>
                                                                        <tr>
                                                                            <td style={{ textAlign: "center", paddingTop: "5px" }} colSpan="2">
                                                                                {templateJson.other_details.document_summary.signature.signature_name &&
                                                                                    <div style={{ paddingRight: "5px" }} className="temp-totals">{'${signature_name}'}</div>
                                                                                }
                                                                                {templateJson.other_details.document_summary.signature.signature_image ? (
                                                                                    <>{'${signature_image}'}</>
                                                                                ) : (
                                                                                    <div style={{ minHeight: "75px" }}></div>
                                                                                )}
                                                                            </td>
                                                                            //<td style={{ textAlign: "center", paddingTop: "5px" }} colSpan="2">
                                                                                <div style={{ paddingRight: "5px" }} className="temp-totals">{signNameText}</div>
                                                                                {signImg ? (
                                                                                    <img src={signImg.fileimage} style={{ maxWidth: "240px", maxHeight: "240px" }} />
                                                                                ) : (
                                                                                    <div style={{ minHeight: "75px" }}></div>
                                                                                )}
                                                                            </td>//
                                                                        </tr>
                                                                        <tr>
                                                                            <td colSpan="2"
                                                                                style={templateJson.total.labels_section.is_show_total_section ? { borderBottom: `1px solid ${templateJson.table.layout_section.table_properties.is_show_table_border ? templateJson.table.layout_section.table_properties.table_border : 'transparent'}`, textAlign: "center" } : {}}>
                                                                                <div style={{
                                                                                    fontSize: `${totalSecFsize}pt`,
                                                                                    color: totalSecFcolor,
                                                                                    backgroundColor: `${isTotalSecBgColorEnabled && !templateJson.general.background.bg_image ? totalSecBgColor : 'transparent'}`,
                                                                                    textAlign: "center"
                                                                                }}
                                                                                    className="temp-totals">{signLabelText}</div>
                                                                            </td>
                                                                        </tr>
                                                                    </tbody>
                                                                ) : ('')} */}
                                                            </table>
                                                        </div>
                                                        <div style={{ clear: "both" }}></div>
                                                    </div>
                                                    {annexContValues.length > 0 ? (
                                                        <div style={{ width: "99%", padding: "7px" }}>
                                                            <div style={{ pageBreakBefore: "always", marginTop: "20px", pageBreakInside: "auto", whiteSpace: "pre" }}
                                                                className="annexure-plain">
                                                                {QTAnnexureArr.map((data) => (
                                                                    <div>{data}</div>
                                                                ))}
                                                                {/* {annexContValues} */}
                                                            </div>
                                                        </div>
                                                    ) : ('')}
                                                    {templateJson.general.template_property.payment_stub.include_payment_stub ? (
                                                        <div
                                                            className={`temp-payment-stub bg-white ${templateJson.general.template_property.payment_stub.payment_stub_postion === 'firstPage' ? 'first-page' : 'separate-page'}`}
                                                            style={{ width: "100%", padding: "20px 4% 0", fontSize: "8pt", color: "#333333", backgroundColor: "#ffffff" }}>
                                                            <table style={{ border: "none" }} cellSpacing="0" border="0" width="100%">
                                                                <tbody>
                                                                    <tr>
                                                                        <td valign="bottom" style={{ padding: "4px 7px 4%", textAlign: "left", width: "50%" }}>
                                                                            <div>From</div>
                                                                            <div><b>Rob & Joe Traders</b></div>
                                                                            <div style={{ borderBottom: "1px dashed #000000" }}>Richard Jones</div>
                                                                        </td>
                                                                        <td valign="bottom" style={{ padding: "4px 7px 4%", textAlign: "right", width: "20%" }}></td>
                                                                        <td valign="bottom" style={{ padding: "4px 7px 2%", width: "30%" }}>
                                                                            <div><b style={{ fontSize: "20pt" }}>Payment Stub</b></div>
                                                                        </td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td valign="bottom" colSpan={3} style={{ padding: "4px 7px 0", textAlign: "left", width: "100%" }}>
                                                                            <div>
                                                                                <span style={{ display: "inline-block", width: "90px" }}>Invoice#</span>
                                                                                <span style={{ display: "inline-block", width: "30px" }}>:</span>
                                                                                <span style={{ display: "inline-block", width: "110px" }}>{'${INVOICE.Invoice Number}'}</span>
                                                                            </div>
                                                                            <div>
                                                                                <span style={{ display: "inline-block", width: "90px" }}>Invoice Date</span>
                                                                                <span style={{ display: "inline-block", width: "30px" }}>:</span>
                                                                                <span style={{ display: "inline-block", width: "110px" }}>{'${INVOICE.CreatedAt}'}</span>
                                                                            </div>
                                                                            <div>
                                                                                <span style={{ display: "inline-block", width: "90px" }}>Balance Due</span>
                                                                                <span style={{ display: "inline-block", width: "30px" }}>:</span>
                                                                                <span style={{ display: "inline-block", width: "110px" }}>{'${INVOICE.BalanceDue}'}</span>
                                                                            </div>
                                                                        </td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td valign="top" style={{ padding: "4px 7px 4%", textAlign: "right", width: "50%" }}>
                                                                            <div style={{ width: "90%", border: "1px solid #dddddd" }}>
                                                                                <div style={{ width: "80px", padding: "5px", backgroundColor: "#f3f3f3", borderRight: "1px solid #dddddd" }}><b>Amount Enclosed</b></div>
                                                                                <div style={{ width: "200px" }}></div>
                                                                            </div>
                                                                        </td>
                                                                        <td valign="bottom" style={{ padding: "4px 7px 4%", textAlign: "right", width: "20%" }}></td>
                                                                        <td valign="bottom" style={{ padding: "4px 7px 2%", width: "30%" }}>
                                                                            <div style={{ fontSize: "10pt" }}>
                                                                                <b>DIGYLAX</b><br />
                                                                                <span>TAMILNADU</span><br />
                                                                                <span>INDIA</span><br />
                                                                                <span>7894561237</span><br />
                                                                                <span>info@digylax.com</span>
                                                                            </div>
                                                                        </td>
                                                                    </tr>
                                                                </tbody>
                                                            </table>
                                                        </div>
                                                    ) : ('')}
                                                </div>
                                            </div>

                                            <div className="temp-footer"
                                                style={{
                                                    height: `${templateJson.general.template_property.margins.bottom}0000in`,
                                                    padding: `0in ${templateJson.general.template_property.margins.right}0000in 0in ${templateJson.general.template_property.margins.left}0000in`,
                                                    fontSize: `${templateJson.footer.font_size}pt`, color: templateJson.footer.font_color,
                                                    backgroundColor: templateJson.footer.bg_image ? "transparent" : templateJson.footer.bg_color && templateJson.footer.is_show_bg_color ? templateJson.footer.bg_color : "transparent",
                                                    backgroundImage: templateJson.footer.bg_image ? `url(${templateJson.footer.bg_image.fileimage})` : 'none',
                                                    backgroundRepeat: "no-repeat",
                                                    backgroundPosition: templateJson.footer.img_position,
                                                    backgroundSize: `${width} 100%`
                                                }}>
                                                {QTFooterArr.map((data) => (
                                                    <div style={{ borderTop: "0", wordWrap: "break-word" }} className="temp-footer-content">
                                                        {data}
                                                    </div>
                                                ))}
                                                {/* <div style={{borderTop:"0",wordWrap:"break-word"}} className="temp-footer-content">
                                                <div>Digylax Pvt Ltd</div>
                                                <div className="page-num" style={{textAlign: "right", fontSize: "8pt", color: "#000000"}}>1</div>
                                            </div> */}
                                            </div>

                                        </div>
                                    </div>
                                    {/* // PDF output area END // */}
                                </div>
                                {/* // Template section // */}
                            </div>

                        </div>
                    </div>
                </div>

            </div>
        </div>

        {/* // new code-dp::start */}
        {showQTHeaderContent &&
            <HeaderContent
                showQTHeaderContent={showQTHeaderContent}
                setshowQTHeaderContent={setshowQTHeaderContent}
                QTHeaderValues={QTHeaderValues}
                handleInsertQTHeaderPlaceholder={handleInsertQTHeaderPlaceholder}
                handleQTHeaderValuesChange={handleQTHeaderValuesChange}
                selectedModule="Invoices"
            />
        }

        {showQTFooterContent &&
            <FooterContent
                showQTFooterContent={showQTFooterContent}
                setshowQTFooterContent={setshowQTFooterContent}
                QTFooterValues={QTFooterValues}
                handleInsertQTFooterPlaceholder={handleInsertQTFooterPlaceholder}
                handleQTFooterValuesChange={handleQTFooterValuesChange}
                selectedModule="Invoices"
            />
        }

        {/* Header & Footer - Custom Content Modal */}
        {/* // Header & Footer - Custom Content Modal END // */}

        {/* new-dp:start */}
        {showQTOrganizationContent &&
            <OrganizationContent
                showQTOrganizationContent={showQTOrganizationContent}
                setshowQTOrganizationContent={setshowQTOrganizationContent}
                QTOrganizationValues={QTOrganizationValues}
                handleInsertQTOrganizationPlaceholder={handleInsertQTOrganizationPlaceholder}
                handleQTOrganizationValuesChange={handleQTOrganizationValuesChange}
            />
        }

        {showQTBillToContent &&
            <BillToContent
                showQTBillToContent={showQTBillToContent}
                setshowQTBillToContent={setshowQTBillToContent}
                QTBillToValues={QTBillToValues}
                handleInsertQTBillToPlaceholder={handleInsertQTBillToPlaceholder}
                handleQTBillToValuesChange={handleQTBillToValuesChange}
                selectedModule="Invoices"
            />
        }

        {showQTShipToContent &&
            <ShipToContent
                showQTShipToContent={showQTShipToContent}
                setshowQTShipToContent={setshowQTShipToContent}
                QTShipToValues={QTShipToValues}
                handleInsertQTShipToPlaceholder={handleInsertQTShipToPlaceholder}
                handleQTShipToValuesChange={handleQTShipToValuesChange}
                selectedModule="Invoices"
            />
        }

        {showQTAttentionContent &&
            <AttentionContent
                showQTAttentionContent={showQTAttentionContent}
                setshowQTAttentionContent={setshowQTAttentionContent}
                QTAttentionValues={QTAttentionValues}
                handleInsertQTAttentionPlaceholder={handleInsertQTAttentionPlaceholder}
                handleQTAttentionValuesChange={handleQTAttentionValuesChange}
                selectedModule="Invoices"
            />
        }

        {showQTItemContent &&
            <ItemContent
                showQTItemContent={showQTItemContent}
                setshowQTItemContent={setshowQTItemContent}
                QTItemValues={QTItemValues}
                handleInsertQTItemPlaceholder={handleInsertQTItemPlaceholder}
                handleQTItemValuesChange={handleQTItemValuesChange}
                selectedModule="Invoices"
            />
        }

        {showQTAnnexureContent &&
            <AnnexureContent
                showQTAnnexureContent={showQTAnnexureContent}
                setshowQTAnnexureContent={setshowQTAnnexureContent}
                QTAnnexureValues={QTAnnexureValues}
                handleInsertQTAnnexurePlaceholder={handleInsertQTAnnexurePlaceholder}
                handleQTAnnexureValuesChange={handleQTAnnexureValuesChange}
                selectedModule="Invoices"
            />
        }
        {/* new-dp:start */}

        {/* Header & Footer - Custom Content Modal */}
        {/* <SimpleModal
            show={headFootCusContModal}
            handleClose={() => setHeadFootCusContModal(false)}
            handleShow={() => setHeadFootCusContModal(true)}
            size="lg"
            modalTitle={haFtitle}
        >
            <div className="card p-0">
                <div className="card-header d-flex justify-content-between">
                    <Dropdown>
                        <Dropdown.Toggle variant="light" className="with-arrow px-3" id="headFootCont_dropdownBtn">
                            <span className="pe-3">Insert Placeholders</span>
                        </Dropdown.Toggle>
                        <Dropdown.Menu className="max-h-400px">
                            <div className="hstack align-items-start">
                                {customPlaceholders.map((categoryTitle, index) => (
                                    <div key={index} className={index !== 0 ? 'ps-2 border-start' : 'pe-2'}>
                                        <Dropdown.ItemText className="fw-medium dropdown-header">{categoryTitle.categoryTitle}</Dropdown.ItemText>
                                        {categoryTitle.items.map((item, itemIndex) => (
                                            <Dropdown.Item key={itemIndex} onClick={() => handleInsertCustomPlaceholder(item)}>
                                                {item}
                                            </Dropdown.Item>
                                        ))}
                                    </div>
                                ))}
                            </div>
                        </Dropdown.Menu>
                    </Dropdown>
                </div>
                <textarea rows={9} id="header_custom_cont_input" className="form-control border-0"
                    value={hAfCustomValues} onChange={handleHaFcustomValuesChange}></textarea>
            </div>
            <div className="mt-4 form-text text-muted">
                <span className="fw-semibold pe-2">Note:</span>
                If your content exceeds the template margin, you can adjust the margin values accordingly.
            </div>
        </SimpleModal> */}
        {/* // Header & Footer - Custom Content Modal END // */}

        {/* Org Address Format Modal */}
        {/* <Modal show={orgAddressFormatShow} onHide={orgAddressModalClose} size="lg" backdrop="static" keyboard={false}>
            <Modal.Header closeButton>
                <Modal.Title className="font-17 fw-normal">
                    <span className="align-middle">Organization Address Format (Displayed in PDF only)</span>
                    <TooltipTrig id="orgAddressFormatInfo" placement={"right"}
                        title={<span className="pe-4 d-inline-block">Placeholders and characters like comma, space, -, ., : are allowed.</span>}>
                        <span className="ps-1 text-gray">
                            <GoQuestion size={20} />
                        </span>
                    </TooltipTrig>
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {orgAddConfigShow ? (
                    <>
                        <textarea rows={9} id="org_custom_cont_input" className="form-control border-0 text-uppercase"
                            value={orgAddCustomValues} disabled></textarea>
                        <div className="mt-2 form-text text-muted">
                            This is the common address format. To edit this address format, go to
                            <span className="fw-semibold ps-1">Settings &gt; Preferences &gt; General</span>.
                        </div>
                        <div className="mt-4 mb-0 alert alert-light d-flex align-items-center" role="alert">
                            <div className="text-info">
                                <i className="fa-solid fa-circle-info fs-5"></i>
                            </div>
                            <div className="ms-2 small">
                                Do you want to have a custom address format only for this template ?
                            </div>
                            <div className="ms-auto">
                                <button type="button" className="btn btn-link text-decoration-none small px-0"
                                    onClick={() => setOrgAddConfigShow()}>
                                    <Settings size={16} /> <span className="ps-1">Configure</span>
                                </button>
                            </div>
                        </div>
                    </>
                ) : (
                    <>
                        <div className="card p-0">
                            <div className="card-header d-flex justify-content-between">
                                <Dropdown>
                                    <Dropdown.Toggle variant="light" className="with-arrow px-3" id="orgCont_dropdownBtn">
                                        <span className="pe-3">Insert Placeholder</span>
                                    </Dropdown.Toggle>
                                    <Dropdown.Menu className="max-h-400px">
                                        <div className="hstack align-items-start">
                                            {orgCustomPlaceholders.map((categoryTitle, index) => (
                                                <div key={index} className={index !== 0 ? 'ps-2 border-start' : 'pe-2'}>
                                                    {categoryTitle.items.map((item, itemIndex) => (
                                                        <Dropdown.Item key={itemIndex} onClick={() => handleInsertOrgCustomPlaceholder(item)}>
                                                            {item}
                                                        </Dropdown.Item>
                                                    ))}
                                                </div>
                                            ))}
                                        </div>
                                    </Dropdown.Menu>
                                </Dropdown>
                            </div>
                            <textarea rows={9} id="org_cont_input" className="form-control border-0 text-uppercase"
                                value={orgAddCustomValues} onChange={handleOrgCustomValuesChange}></textarea>
                        </div>
                        <div className="mt-3 alert alert-warning d-flex" role="alert">
                            <div className="text-warning">
                                <i className="fa-solid fa-circle-info fs-6"></i>
                            </div>
                            <div className="ms-2 small pe-3">
                                This custom address format will be used only in this template.
                                If you leave the custom address format empty,
                                the common address format will be used.
                            </div>
                        </div>
                    </>
                )}
            </Modal.Body>
            <Modal.Footer>
                {orgAddConfigShow ? (
                    <Button variant="outline-secondary" className="py-1 me-auto" onClick={orgAddressModalClose}>
                        Close
                    </Button>
                ) : (
                    <>
                        <Button variant="primary" className="py-1" onClick={orgAddressModalClose}>
                            Preview
                        </Button>
                        <Button variant="outline-secondary" className="py-1" onClick={orgAddressModalClose}>
                            Cancel
                        </Button>
                        <Button variant="link" type="reset" className="p-0 py-2 ms-auto text-decoration-none"
                            onClick={() => setOrgAddConfigShow(true)}>Use Common Format</Button>
                    </>
                )}
            </Modal.Footer>
        </Modal> */}
        {/* // Org Address Format Modal END // */}

        {/* Bill To And Ship To Address Format Modal */}
        {/* <Modal show={billOrShipAddressFormatShow} onHide={billOrShipAddressModalClose} size="lg" backdrop="static" keyboard={false}>
            <Modal.Header closeButton>
                <Modal.Title className="font-17 fw-normal">
                    <span className="align-middle">{billOrShipTitle} Address Format (Displayed in PDF only)</span>
                    <TooltipTrig id="billOrShipAddressFormatInfo" placement={"right"}
                        title={<span className="pe-4 d-inline-block">Placeholders and characters like comma, space, -, ., : are allowed.</span>}>
                        <span className="ps-1 text-gray">
                            <GoQuestion size={20} />
                        </span>
                    </TooltipTrig>
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {billOrShipAddConfigShow ? (
                    <>
                        <textarea rows={9} id="billOrShip_add_format_input" className="form-control border-0 text-uppercase"
                            value={billOrShipAddCustomValues} disabled></textarea>
                        <div className="mt-2 form-text text-muted">
                            This is the common address format. To edit this address format, go to
                            <span className="fw-semibold ps-1">Settings &gt; Preferences &gt; Customers and Vendors</span>.
                        </div>
                        <div className="mt-4 mb-0 alert alert-light d-flex align-items-center" role="alert">
                            <div className="text-info">
                                <i className="fa-solid fa-circle-info fs-5"></i>
                            </div>
                            <div className="ms-2 small">
                                Do you want to have a custom address format only for this template ?
                            </div>
                            <div className="ms-auto">
                                <button type="button" className="btn btn-link text-decoration-none small px-0"
                                    onClick={() => setBillOrShipAddConfigShow()}>
                                    <Settings size={16} /> <span className="ps-1">Configure</span>
                                </button>
                            </div>
                        </div>
                    </>
                ) : (
                    <>
                        <div className="card p-0">
                            <div className="card-header d-flex justify-content-between">
                                <Dropdown>
                                    <Dropdown.Toggle variant="light" className="with-arrow px-3" id="billOrShipCont_dropdownBtn">
                                        <span className="pe-3">Insert Placeholder</span>
                                    </Dropdown.Toggle>
                                    <Dropdown.Menu className="max-h-400px">
                                        <div className="hstack align-items-start">
                                            {billOrShipCustomPlaceholders.map((categoryTitle, index) => (
                                                <div key={index} className={index !== 0 ? 'ps-2 border-start' : 'pe-2'}>
                                                    <Dropdown.ItemText className="fw-medium dropdown-header">{categoryTitle.categoryTitle}</Dropdown.ItemText>
                                                    {categoryTitle.items.map((item, itemIndex) => (
                                                        <Dropdown.Item key={itemIndex} onClick={() => handleInsertBillOrShipCustomPlaceholder(item)}>
                                                            {item}
                                                        </Dropdown.Item>
                                                    ))}
                                                </div>
                                            ))}
                                        </div>
                                    </Dropdown.Menu>
                                </Dropdown>
                            </div>
                            <textarea rows={9} id="billOrShip_cont_input" className="form-control border-0 text-uppercase"
                                value={billOrShipAddCustomValues} onChange={handleBillOrShipCustomValuesChange}></textarea>
                        </div>
                        <div className="mt-3 alert alert-warning d-flex" role="alert">
                            <div className="text-warning">
                                <i className="fa-solid fa-circle-info fs-6"></i>
                            </div>
                            <div className="ms-2 small pe-3">
                                This custom address format will be used only in this template.
                                If you leave the custom address format empty,
                                the common address format will be used.
                            </div>
                        </div>
                    </>
                )}
            </Modal.Body>
            <Modal.Footer>
                {billOrShipAddConfigShow ? (
                    <Button variant="outline-secondary" className="py-1 me-auto" onClick={billOrShipAddressModalClose}>
                        Close
                    </Button>
                ) : (
                    <>
                        <Button variant="primary" className="py-1" onClick={billOrShipAddressModalClose}>
                            Preview
                        </Button>
                        <Button variant="outline-secondary" className="py-1" onClick={billOrShipAddressModalClose}>
                            Cancel
                        </Button>
                        <Button variant="link" type="reset" className="p-0 py-2 ms-auto text-decoration-none"
                            onClick={() => setBillOrShipAddConfigShow(true)}>Use Common Format</Button>
                    </>
                )}
            </Modal.Footer>
        </Modal> */}
        {/* // Bill To And Ship To Address Format Modal END // */}

        {/* Add Attention Content Modal */}
        {/* <SimpleModal
            show={addAttentionContModal}
            handleClose={() => setAddAttentionContModal(false)}
            handleShow={() => setAddAttentionContModal(true)}
            size="lg"
            modalTitle="Add Attention Content"
        >
            <div className="card p-0">
                <div className="card-header d-flex justify-content-between">
                    <Dropdown>
                        <Dropdown.Toggle variant="light" className="with-arrow px-3" id="headFootCont_dropdownBtn">
                            <span className="pe-3">Insert Placeholders</span>
                        </Dropdown.Toggle>
                        <Dropdown.Menu className="max-h-400px">
                            <div className="hstack align-items-start">
                                {customPlaceholders.map((categoryTitle, index) => (
                                    <div key={index} className={index !== 0 ? 'ps-2 border-start' : 'pe-2'}>
                                        <Dropdown.ItemText className="fw-medium dropdown-header">{categoryTitle.categoryTitle}</Dropdown.ItemText>
                                        {categoryTitle.items.map((item, itemIndex) => (
                                            <Dropdown.Item key={itemIndex} onClick={() => handleInsertCustomPlaceholder(item)}>
                                                {item}
                                            </Dropdown.Item>
                                        ))}
                                    </div>
                                ))}
                            </div>
                        </Dropdown.Menu>
                    </Dropdown>
                </div>
                <textarea rows={9} id="header_custom_cont_input" className="form-control border-0"
                    value={hAfCustomValues} onChange={handleHaFcustomValuesChange}></textarea>
            </div>
            <div className="mt-4 form-text text-muted">
                <span className="fw-semibold pe-2">Note:</span>
                Attention content will be displayed above the "Item Table".
            </div>
        </SimpleModal> */}
        {/* // Add Attention Content Modal END // */}

        {/* Customize Item Name & Description Modal */}
        {/* <SimpleModal
            show={cusNameAndDescModal}
            handleClose={() => setCusNameAndDescModal(false)}
            handleShow={() => setCusNameAndDescModal(true)}
            size="lg"
            modalTitle="Customize Item Name & Description Format"
        >
            <div className="card p-0">
                <div className="card-header d-flex justify-content-between">
                    <Dropdown>
                        <Dropdown.Toggle variant="light" className="with-arrow px-3" id="headFootCont_dropdownBtn">
                            <span className="pe-3">Insert Placeholders</span>
                        </Dropdown.Toggle>
                        <Dropdown.Menu className="max-h-400px">
                            <div className="hstack align-items-start">
                                {cusNameAndDescPlaceholders.map((categoryTitle, index) => (
                                    <div key={index} className={index !== 0 ? 'ps-2 border-start' : 'pe-2'}>
                                        <Dropdown.ItemText className="fw-medium dropdown-header">{categoryTitle.categoryTitle}</Dropdown.ItemText>
                                        {categoryTitle.items.map((item, itemIndex) => (
                                            <Dropdown.Item key={itemIndex} onClick={() => handleCusNameAndDescPlaceholder(item)}>
                                                {item}
                                            </Dropdown.Item>
                                        ))}
                                    </div>
                                ))}
                            </div>
                        </Dropdown.Menu>
                    </Dropdown>
                </div>
                <textarea rows={9} id="header_custom_cont_input" className="form-control border-0"
                    value={cusNameAndDescValues} onChange={handleCusNameAndDescValuesChange}></textarea>
            </div>
            <div className="mt-4 form-text text-muted">
                <span className="fw-semibold pe-2">Note:</span>
                If your content exceeds the template margin, you can adjust the margin values accordingly.
            </div>
        </SimpleModal> */}
        {/* // Customize Item Name & Description Modal END // */}

        {/* Add Bank details Modal */}
        <SimpleModal
            show={addBankDetailsModal}
            handleClose={() => setAddBankDetailsModal(false)}
            handleShow={() => setAddBankDetailsModal(true)}
            size="lg"
            modalTitle="Add your bank details"
        >
            <div className="card p-0">
                <div className="card-header d-flex justify-content-between">
                    <Dropdown>
                        <Dropdown.Toggle variant="light" className="with-arrow px-3" id="headFootCont_dropdownBtn">
                            <span className="pe-3">Insert Placeholders</span>
                        </Dropdown.Toggle>
                        <Dropdown.Menu className="max-h-400px">
                            <div className="hstack align-items-start">
                                {customPlaceholders.map((categoryTitle, index) => (
                                    <div key={index} className={index !== 0 ? 'ps-2 border-start' : 'pe-2'}>
                                        <Dropdown.ItemText className="fw-medium dropdown-header">{categoryTitle.categoryTitle}</Dropdown.ItemText>
                                        {categoryTitle.items.map((item, itemIndex) => (
                                            <Dropdown.Item key={itemIndex} onClick={() => handleInsertCustomPlaceholder(item)}>
                                                {item}
                                            </Dropdown.Item>
                                        ))}
                                    </div>
                                ))}
                            </div>
                        </Dropdown.Menu>
                    </Dropdown>
                </div>
                <textarea rows={9} id="header_custom_cont_input" className="form-control border-0"
                    value={hAfCustomValues} onChange={handleHaFcustomValuesChange}></textarea>
            </div>
            <div className="mt-4 form-text text-muted">
                <span className="fw-semibold pe-2">Note:</span>
                Bank details will be displayed below "Customer Notes".
            </div>
        </SimpleModal>
        {/* // Add Bank details Modal END // */}

        {/* Add Annexure Content Modal */}
        <SimpleModal
            show={addAnnexureModal}
            handleClose={() => setAddAnnexureModal(false)}
            handleShow={() => setAddAnnexureModal(true)}
            size="lg"
            modalTitle="Add Annexure Content"
        >
            <div className="card p-0">
                <div className="card-header d-flex justify-content-between">
                    <Dropdown>
                        <Dropdown.Toggle variant="light" className="with-arrow px-3" id="headFootCont_dropdownBtn">
                            <span className="pe-3">Insert Placeholders</span>
                        </Dropdown.Toggle>
                        <Dropdown.Menu className="max-h-400px">
                            <div className="hstack align-items-start">
                                {customPlaceholders.map((categoryTitle, index) => (
                                    <div key={index} className={index !== 0 ? 'ps-2 border-start' : 'pe-2'}>
                                        <Dropdown.ItemText className="fw-medium dropdown-header">{categoryTitle.categoryTitle}</Dropdown.ItemText>
                                        {categoryTitle.items.map((item, itemIndex) => (
                                            <Dropdown.Item key={itemIndex} onClick={() => handleInsertAnnexContPlaceholder(item)}>
                                                {item}
                                            </Dropdown.Item>
                                        ))}
                                    </div>
                                ))}
                            </div>
                        </Dropdown.Menu>
                    </Dropdown>
                </div>
                <textarea rows={9} id="header_custom_cont_input" className="form-control border-0"
                    value={annexContValues} onChange={handleAnnexContValuesChange}></textarea>
            </div>
        </SimpleModal>
        {/* // Add Annexure Content Modal END // */}

    </>);
}

export default InvoiceTemplate;